export default {
  '短袖长': 'Short Sleeve Length',
  '上衣版型': 'Jacket Fit',
  '上衣长度': 'Jacket Length',
  '裤子版型': 'Trouser Fit',
  '裤腰高度': 'Waist Height',
  '上海旗舰店': 'Shanghai Flagship Store',
  '刚刚': 'Just now',
  '北京朝阳店': 'Beijing Chaoyang Store',
  '1分钟前': '1 minute ago',
  '深圳南山店': 'Shenzhen Nanshan Store',
  '3分钟前': '3 minutes ago',
  '成都春熙店': 'Chengdu Chunxi Store',
  '8分钟前': '8 minutes ago',
  '杭州西湖店': 'Hangzhou West Lake Store',
  '15分钟前': '15 minutes ago',
  '工作台总览': 'Dashboard Overview',
  '管理员': 'Admin',
  '· 全店数据 · 实时更新': '· Store-wide Data · Real-time Updates',
  '点击进入': 'Click to Enter',
  '广州天河店': 'Guangzhou Tianhe Store',
  '在线': 'Online',
  '未回款客户': 'Clients with Outstanding Payments',
  '家': ' clients',
  '天未回': ' days overdue',
  '交货': 'Delivery',
  '出货': 'Shipment',
  '运输': 'Transport',
  '配送': 'Distribution',
  '手机': 'Mobile',
  '邮件': 'Email',
  '裙装设计': 'Skirt Design',
  '同上衣': 'Same Top',
  '创建订单失败': 'Failed to Create Order',
  'AI思考中': 'AI Thinking...',
  '档': ' Tier',
  '当前档位：': 'Current Tier: ',
  '档 ·': ' Tier ·',
  '销售额': 'Sales',
  '(汇率': '(Exchange Rate',
  '综合提成率：': 'Overall Commission Rate:',
  '分档明细': 'Tier Details',
  '档（': ' Tier (',
  '档(': ' Tier (',
  '个人提成按定制单/团单分别计算；团队管理提成基于全团队总销售额（含本人）超额累进': 'Personal commission is calculated separately for custom and group orders; team management commission is based on total team sales (including self) with progressive excess',
  '· 适用定制单提成阶梯': '· Applies to Custom Order Commission Tiers',
  '提成': 'Commission',
  '当前档：': 'Current Tier: ',
  '· 适用团单提成阶梯': '· Applies to Group Order Commission Tiers',
  '其他团队成员销售额': 'Other Team Members Sales',
  '· 定制单 + 团单合并计入团队管理提成': '· Custom + Group orders are combined into team management commission',
  '小计：$': 'Subtotal: $',
  '添加成员': 'Add Member',
  '保存成员': 'Save Member',
  '个人业绩小计 (USD) 定制单 + 团单': 'Personal Performance Subtotal (USD) Custom + Group Orders',
  '小计（': 'Subtotal (',
  '人）': ' People)',
  '团队总销售额：': 'Total Team Sales:',
  '本人 $': 'Self $',
  '+ 其他成员 $': '+ Other Members $',
  '团队管理提成：': 'Team Management Commission:',
  '个人提成（定制单 + 团单）': 'Personal Commission (Custom + Group Orders)',
  '定制': 'Custom',
  '+ 团单': '+ Group Orders',
  '团队总销售 $': 'Total Team Sales $',
  '合计提成': 'Total Commission',
  '汇率': 'Exchange Rate',
  '加载提成配置...': 'Loading commission config...',
  '加载历史记录失败': 'Failed to load history',
  '请输入员工姓名': 'Please enter employee name',
  '定制单': 'Custom Order',
  '团单（成衣单）': 'Group Order (Ready-to-Wear)',
  '已删除': 'Deleted',
  '审批历史': 'Approval History',
  '保存记录': 'Save Record',
  '订单原价 (USD)': 'Order Original Price (USD)',
  '折后实收价 (USD)': 'Discounted Actual Price (USD)',
  '最低折扣系数（审批红线）': 'Minimum Discount Factor (Approval Red Line)',
  '折）': ' Discount)',
  '折扣可视化': 'Discount Visualization',
  '折扣系数': 'Discount Factor',
  '审批红线': 'Approval Red Line',
  '100%（原价）': '100% (Original Price)',
  '最低限制': 'Minimum Limit',
  '提成影响分析': 'Commission Impact Analysis',
  '折扣导致提成减少': 'Discount Reduces Commission',
  '提成阶梯对比': 'Commission Tier Comparison',
  '员工姓名': 'Employee Name',
  '是否需审批': 'Approval Required?',
  '折扣审批历史': 'Discount Approval History',
  '*必填': '*Required',
  '(固定月薪)': '(Fixed Monthly Salary)',
  '业绩提成': 'Performance Commission',
  '(USD，超额累进)': '(USD, Progressive)',
  '定制单提成明细': 'Custom Order Commission Details',
  '团单提成明细': 'Group Order Commission Details',
  '业绩提成（本人 + 团队管理）': 'Performance Commission (Self + Team Management)',
  '团队管理提成（经理专属）': 'Team Management Commission (Manager Only)',
  '团队总销售额 = 本人定制单 + 本人团单 + 其他成员定制单 + 其他成员团单': 'Total Team Sales = Self Custom + Self Group + Other Members Custom + Other Members Group',
  '当前团队总销售额：': 'Current Total Team Sales:',
  '(USD，不含经理本人)': '(USD, Excluding Manager)',
  '团队管理提成明细（超额累进）': 'Team Management Commission Details (Progressive)',
  '跟单提成': 'Order Tracking Commission',
  '跟单提成明细': 'Order Tracking Commission Details',
  '阶梯：$0-$30,000 → 0.1%；$30,001-$80,000 → 0.2%；$80,001以上 → 0.3%': 'Tiers: $0–$30,000 → 0.1%; $30,001–$80,000 → 0.2%; $80,001 and above → 0.3%',
  '行政提成': 'Administrative Commission',
  '(单，超额累进)': '(Orders, Progressive)',
  '单': ' orders',
  '行政提成明细': 'Administrative Commission Details',
  '阶梯：0-50单 → ¥3/单；51-100单 → ¥4/单；101单以上 → ¥6/单（超额累进）': 'Tiers: 0–50 orders → ¥3/order; 51–100 orders → ¥4/order; 101+ orders → ¥6/order (progressive)',
  '(绩效奖金、大单奖励、新客奖等)': '(Performance bonus, large-order reward, new-client reward, etc.)',
  '扣减项': 'Deductions',
  '出勤扣减': 'Attendance Deduction',
  '(迟到/早退/旷工等)': '(Late/Early/Absenteeism, etc.)',
  '社保扣减': 'Social Insurance Deduction',
  '(个人承担部分)': '(Employee Portion)',
  '公积金扣减': 'Housing Fund Deduction',
  '个税扣减（应纳税所得额': 'Income Tax Deduction (Taxable Income ',
  '手动输入': 'Manual Input',
  '其他扣减': 'Other Deductions',
  '(提成回滚、处罚扣款等)': '(Commission rollback, penalty deductions, etc.)',
  '定制单提成': 'Custom Order Commission',
  '团单提成': 'Group Order Commission',
  '· 当月实发工资': '· Current Month Net Pay',
  '税前总收入': 'Total Gross Income',
  '合计扣减': 'Total Deductions',
  '提成合计 (USD)': 'Total Commission (USD)',
  '人力成本在控制范围内': 'Labor Cost Within Control',
  '人力成本超出红线': 'Labor Cost Exceeds Red Line',
  '人力成本占比：': 'Labor Cost Ratio:',
  '（红线': '(Red Line ',
  '实发工资 ÷ 汇率 ÷ 本人月销售额（USD）': 'Net Pay ÷ Exchange Rate ÷ Monthly Sales (USD)',
  '行政人员按订单量计算，不计算人力成本占比': 'Admin staff are calculated by order volume; labor cost ratio does not apply',
  '工资明细': 'Payroll Details',
  '收入项': 'Income Items',
  '团队总销售': 'Total Team Sales',
  '单 超额累进': ' orders progressive',
  '个税扣减': 'Income Tax Deduction',
  'YYYY年MM月': 'YYYY-MM',
  '保存工资记录到数据库': 'Save Payroll Record to Database',
  '提成构成': 'Commission Breakdown',
  '工资核算': 'Payroll Calculation',
  '汇总员工当月所有收入与扣减项，计算实发工资': 'Aggregate all monthly income and deductions to calculate net pay',
  '提成：': 'Commission:',
  '税前：': 'Gross:',
  '实发：': 'Net Pay:',
  '本人定制单 (USD)': 'Self Custom Order (USD)',
  '本人团单 (USD)': 'Self Group Order (USD)',
  '其他成员定制单 (USD)': 'Other Member Custom Order (USD)',
  '其他成员团单 (USD)': 'Other Member Group Order (USD)',
  '月负责订单金额 (USD)': 'Monthly Responsible Order Amount (USD)',
  '月处理订单量 (单)': 'Monthly Processed Order Volume (Orders)',
  '个税扣减 (0=自动)': 'Income Tax Deduction (0=Auto)',
  '核算结果': 'Calculation Result',
  '提成（USD）': 'Commission (USD)',
  '提成（CNY）': 'Commission (CNY)',
  '个税（自动估算）': 'Income Tax (Auto Estimate)',
  '未命名': 'Unnamed',
  '角色': 'Role',
  '提成(CNY)': 'Commission (CNY)',
  '添加员工': 'Add Employee',
  '批量工资核算': 'Batch Payroll Calculation',
  '录入全员数据，一键计算当月工资并导出Excel': 'Enter all employee data, calculate monthly payroll with one click, and export to Excel',
  '员工总数': 'Total Employees',
  '人': ' employees',
  '实发工资合计': 'Total Net Pay',
  '当月工资汇总表': 'Monthly Payroll Summary',
  '合计（': 'Total (',
  '加载销售价格表异常:': 'Error loading sales price table:',
  '款': 'Style',
  '已选': 'Selected',
  '行': 'Rows',
  '清除': 'Clear',
  '年终分红记录已保存': 'Year-end Bonus Record Saved',
  '年份': 'Year',
  '年度利润': 'Annual Profit',
  '分红池': 'Bonus Pool',
  '员工分红池': 'Employee Bonus Pool',
  '计算及发放年终分红': 'Calculate and Distribute Year-end Bonus',
  '历史记录': 'History',
  '分红基础参数': 'Bonus Base Parameters',
  '年度税后利润 (CNY)': 'Annual After-tax Profit (CNY)',
  '个人分红权重': 'Personal Bonus Weight',
  '根据绩效、司龄等因素分配权重点数': 'Allocate weight points based on performance, tenure, etc.',
  '分红总池': 'Total Bonus Pool',
  '股东分红池': 'Shareholder Bonus Pool',
  '% 分配': '% Distribution',
  '本人预计分红': 'Estimated Personal Bonus',
  '权重占比：': 'Weight Ratio:',
  '点）': ' Points)',
  '分红总池 = 年度税后利润 × 分红池比例': 'Total Bonus Pool = Annual After-tax Profit × Bonus Pool Ratio',
  '员工分红池 = 分红总池 × 员工分红比例': 'Employee Bonus Pool = Total Bonus Pool × Employee Bonus Ratio',
  '个人分红 = 员工分红池 ×（本人权重 ÷ 总权重）': 'Personal Bonus = Employee Bonus Pool × (Self Weight ÷ Total Weight)',
  '注：权重点数由管理层根据年度绩效、司龄、贡献度等综合评定，具体权重分配规则由公司另行制定。': 'Note: Weight points are evaluated by management based on annual performance, tenure, contribution, etc. Specific weight allocation rules are set by the company separately.',
  '历史分红记录': 'Historical Bonus Records',
  '上衣/西装': 'Jacket / Suit',
  '共享数据': 'Shared Data',
  '管理订单中可选的品类（单品/组合），包含中英文名称和面料用量': 'Manage available categories (single/combo) in orders, including Chinese/English names and fabric usage',
  '定制订单提成阶梯（业务员）': 'Custom Order Commission Tiers (Sales)',
  '适用于单件或少量定制 MTM 订单，5档超额累进': 'Applies to single or small-quantity custom MTM orders, 5-tier progressive excess',
  '最小值 (USD)': 'Minimum (USD)',
  '最大值 (USD)': 'Maximum (USD)',
  '团单提成阶梯（业务员）': 'Group Order Commission Tiers (Sales)',
  '适用于 RTW 成衣订单，提成按折后实际总额计算': 'Applies to RTW ready-to-wear orders; commission is calculated based on actual discounted total',
  '团队管理提成阶梯（业务经理）': 'Team Management Commission Tiers (Sales Manager)',
  '基于团队所有成员（含经理本人）的定制单+团单总销售额，超额累进': 'Based on total custom + group sales of all team members (including manager), progressive excess',
  '跟单员提成阶梯': 'Order Follow-up Commission Tiers',
  '按月负责订单金额（USD）超额累进，提成换算为人民币后计入工资': 'Progressive based on monthly responsible order amount (USD); commission is converted to CNY and included in salary',
  '最小金额 (USD)': 'Minimum Amount (USD)',
  '最大金额 (USD)': 'Maximum Amount (USD)',
  '行政人员提成阶梯': 'Administrative Staff Commission Tiers',
  '按月处理订单量（单）超额累进，直接以人民币计入工资': 'Progressive based on monthly processed order volume (orders), directly included in salary in CNY',
  '最小单量（单）': 'Minimum Order Volume (Orders)',
  '最大单量（单）': 'Maximum Order Volume (Orders)',
  '元/单': 'CNY/Order',
  '全额退款': 'Full Refund',
  '全额追回该订单已发放的提成': 'Fully recover commission already paid for this order',
  '退款工单完成当月，从业务员后续提成中扣除': 'Deduct from the designer’s subsequent commission in the month the refund ticket is completed',
  '扣减提成 = 原提成 × (退款金额 ÷ 订单原总额)': 'Deducted Commission = Original Commission × (Refund Amount ÷ Order Original Total)',
  '售后完成当月': 'Month After-Sales Completed',
  '事后折扣': 'Subsequent Discount',
  '视为部分退款，同比例扣减提成': 'Treated as partial refund; commission deducted proportionally',
  '折扣审批通过当月': 'Month Discount Approved',
  '坏账': 'Bad Debt',
  '全额追回该订单提成，并额外扣减坏账金额的5%（上限月薪20%）': 'Fully recover commission for this order and additionally deduct 5% of the bad debt amount (capped at 20% of monthly salary)',
  '财务确认坏账当月': 'Month Finance Confirms Bad Debt',
  '正常推送': 'Push Normally',
  '不推送': 'Do Not Push',
  '移除': 'Remove',
  '推送到特体': 'Push to Special Body',
  '停产': 'Discontinued',
  '缺货': 'Out of Stock',
  '预订': 'Pre-order',
  '共享设计项': 'Shared Design Items',
  '订单错误': 'Order Error',
  '客户投诉': 'Customer Complaint',
  '数据安全': 'Data Security',
  '考勤': 'Attendance',
  '请输入处罚描述': 'Please Enter Penalty Description',
  '添加成功': 'Added Successfully',
  '添加失败': 'Add Failed',
  '请先勾选违规项': 'Please Select Violation Items First',
  '请选择处罚月份': 'Please Select Penalty Month',
  '处罚记录保存成功': 'Penalty Record Saved Successfully',
  '违规情形': 'Violation',
  '处罚金额': 'Penalty Amount',
  '模拟': 'Simulate',
  '确认删除？': 'Confirm Delete?',
  '管理违规处罚规则及扣款标准': 'Manage Violation Penalty Rules and Deduction Standards',
  '新增规则': 'Add Rule',
  '新增处罚规则': 'Add Penalty Rule',
  '处罚描述': 'Penalty Description',
  '描述违规情形': 'Describe Violation',
  '处罚金额 (CNY)': 'Penalty Amount (CNY)',
  '确认添加': 'Confirm Add',
  '处罚模拟器': 'Penalty Simulator',
  '勾选左侧违规项，自动汇总当月扣款': 'Select violations on the left to automatically aggregate monthly deductions',
  '合计扣款': 'Total Deductions',
  '保存处罚记录': 'Save Penalty Record',
  '请在左侧勾选违规项': 'Please Select Violations on the Left',
  '处罚执行说明': 'Penalty Execution Instructions',
  '处罚按实际规则全额执行，不设额外上限': 'Penalties are executed in full according to actual rules, with no additional cap',
  '当月工资不足扣除时，顺延至下月': 'If current month salary is insufficient, deductions carry over to next month',
  '所有处罚需有记录和通知': 'All penalties require records and notification',
  '员工有权在3个工作日内申诉': 'Employees have the right to appeal within 3 working days',
  '员工姓名 *': 'Employee Name *',
  '处罚月份 *': 'Penalty Month *',
  '本次处罚合计': 'Total Penalty Amount',
  '项违规': ' Violations',
  '处罚历史记录': 'Penalty History',
  '选择月份筛选': 'Filter by Month',
  '无折扣': 'No Discount',
  '轻微优惠': 'Slight Discount',
  '常规折扣': 'Regular Discount',
  '大客户折扣': 'VIP Discount',
  '战略折扣': 'Strategic Discount',
  '— 通配': '— Wildcard',
  '物流费用': 'Logistics Cost',
  '物流费用功能开发中': 'Logistics Cost Feature Under Development',
  ' 等': ' etc.',
  '加载设计项...': 'Loading Design Items...',
  '暂无设计项': 'No Design Items',
  '... 更多设计': '... More Designs',
  '海军蓝人字纹': 'Navy Herringbone',
  '深灰大方格': 'Dark Gray Windowpane',
  '咖啡色纯亚麻': 'Coffee Pure Linen',
  '面料 D': 'Fabric D',
  '面料 E': 'Fabric E',
  '面料 F': 'Fabric F',
  '面料 G': 'Fabric G',
  '面料 H': 'Fabric H',
  '面料 I': 'Fabric I',
  '面料 J': 'Fabric J',
  '请从左侧选择设计项': 'Please Select Design Items from the Left',
  '已锁定（与': 'Locked (same as ',
  '相同）': ')',
  '未选择': 'Not Selected',
  '搜索编号/名称...': 'Search No./Name...',
  '套装内所有品类使用相同面料，如需不同面料请分开下单': 'All items in the suit use the same fabric; please place separate orders if different fabrics are needed',
  '客供面料（CMT来料加工）：由客户自行提供面料，发票中面料费用为零，仅计工艺加工费。请填写每块面料的物流信息。': 'Customer-supplied Fabric (CMT): Fabric provided by the customer; fabric cost on invoice is zero, only processing fee is charged. Please fill in logistics info for each fabric.',
  '面料 #': 'Fabric #',
  '如：Holland & Sherry': 'e.g., Holland & Sherry',
  '如：HS-2024-001': 'e.g., HS-2024-001',
  '如：细条纹、人字纹': 'e.g., Pinstripe, Herringbone',
  '如：150': 'e.g., 150',
  '如：DHL、顺丰': 'e.g., DHL, SF Express',
  '快递运单号': 'Courier Tracking No.',
  '如：3': 'e.g., 3',
  '+ 添加面料': '+ Add Fabric',
  '自由选择款式细节，完全个性化定制': 'Freely choose style details for fully personalized customization',
  '从样衣库中选择已有款式，一键下单': 'Select existing styles from the sample library and order with one click',
  '暂无设计选项': 'No Design Options',
  '✓ 已选择': '✓ Selected',
  '上传失败': 'Upload Failed',
  '请至少上传一张图片': 'Please Upload At Least One Image',
  '确认发货成功': 'Confirm Shipment Successful',
  '提交失败': 'Submit Failed',
  '链接无效或已过期': 'Link Invalid or Expired',
  '物料类型': 'Material Type',
  '采购折扣价': 'Purchase Discount Price',
  '批量采购编号': 'Bulk Purchase No.',
  '全部已发货': 'All Shipped',
  '合并采购单': 'Merge Purchase Orders',
  '供应商：': 'Supplier:',
  '联系人：': 'Contact:',
  '供应商电话：': 'Supplier Phone:',
  '收件信息': 'Recipient Info',
  '加工厂名': 'Factory Name',
  '收件地址': 'Recipient Address',
  '采购单：': 'Purchase Order:',
  '金额:': 'Amount:',
  '折扣:': 'Discount:',
  '物流商': 'Logistics Provider',
  '发货单号': 'Shipment Tracking No.',
  '发货凭证': 'Shipment Voucher',
  '个采购单，': ' purchase orders,',
  '总金额:': 'Total Amount:',
  '折扣总金额:': 'Total Discount Amount:',
  '统一确认发货': 'Confirm Shipment in Batch',
  '请选择物流商': 'Please Select Logistics Provider',
  '请输入发货单号': 'Please Enter Shipment Tracking No.',
  '发货凭证图片': 'Shipment Voucher Image',
  '上传': 'Upload',
  '请输入备注（可选）': 'Please Enter Remarks (Optional)',
  '确认已发货': 'Confirm Shipped',
  '全部采购单已确认发货': 'All Purchase Orders Confirmed Shipped',
  '如有疑问，请联系采购方工作人员': 'If you have any questions, please contact the purchasing staff',
  '类型名称': 'Type Name',
  '物料名称': 'Material Name',
  '输入订单号搜索': 'Search order number',
  '请输入物料名称': 'Please enter material name',
  '采购明细': 'Purchase Details',
  '发货信息': 'Shipping Info',
  '无图片': 'No Image',
  '确认发货': 'Confirm Shipment',
  '快速切换至其他用户账号': 'Quick Switch to Another User Account',
  '功能开发中...': 'Feature Under Development...',
  '业务员（定制单）': 'Designer (Custom Order)',
  '按单笔订单金额计算提成': 'Commission calculated per order amount',
  '业务员（团单）': 'Designer (Group Order)',
  '按团单总金额计算提成': 'Commission calculated by group order total',
  '按单笔订单固定金额提成': 'Fixed commission per order',
  '管理员/老板': 'Admin / Owner',
  '管理员提成配置': 'Admin Commission Config',
  '参考汇率（CNY/USD）': 'Reference Exchange Rate (CNY/USD)',
  '通用参数': 'General Parameters',
  '用于提成计算中 USD→CNY 转换，实际发薪以当月汇率为准': 'Used for USD→CNY conversion in commission calculations; actual payroll uses the exchange rate of the month',
  '人力成本上限比例': 'Labor Cost Cap Ratio',
  '人力成本占销售额上限（如 8 = 8%）': 'Labor cost as a percentage of sales cap (e.g., 8 = 8%)',
  '最低折扣系数': 'Minimum Discount Factor',
  '折扣参数': 'Discount Parameters',
  '低于此折扣需要管理员审批（如 0.7 = 7折）': 'Discounts below this require admin approval (e.g., 0.7 = 30% off)',
  '裂变提成比例': 'Referral Commission Ratio',
  '提成参数': 'Commission Parameters',
  '新客户裂变提成比例（如 0.005 = 0.5%）': 'New customer referral commission ratio (e.g., 0.005 = 0.5%)',
  '裂变提成期限（月）': 'Referral Commission Period (Months)',
  '裂变提成计算的有效月数': 'Valid months for referral commission calculation',
  '最大裂变层数': 'Max Referral Layers',
  '裂变提成最多计算的层级数': 'Maximum layers counted for referral commission',
  '加载配置失败': 'Failed to Load Config',
  '该参数键名已存在': 'Parameter Key Already Exists',
  '配置已保存': 'Config Saved',
  '已重置为默认值，请刷新页面': 'Reset to defaults; please refresh the page',
  '重置失败': 'Reset Failed',
  '新增参数': 'Add Parameter',
  '参数键名': 'Parameter Key',
  '参数值': 'Parameter Value',
  '显示名称': 'Display Name',
  '人民币/美元汇率': 'CNY/USD Exchange Rate',
  '数字': 'Number',
  '字符串': 'String',
  '布尔值': 'Boolean',
  '分组': 'Group',
  '描述': 'Description',
  '参数说明': 'Parameter Description',
  '汇率、基础费率等全局配置': 'Global config for exchange rates, base rates, etc.',
  '提成计算相关参数': 'Commission calculation parameters',
  '折扣审批和限制相关': 'Discount approval and limit settings',
  '提成阶梯配置': 'Commission Tier Config',
  '按角色配置不同的提成阶梯规则': 'Configure different commission tier rules by role',
  '下限金额': 'Lower Limit Amount',
  '上限金额': 'Upper Limit Amount',
  '提成比例/金额': 'Commission Rate / Amount',
  '无上限': 'No Upper Limit',
  '百分比(%)': 'Percentage (%)',
  '固定金额': 'Fixed Amount',
  '添加阶梯': 'Add Tier',
  '确定重置为默认配置吗？': 'Confirm reset to default config?',
  '确定': 'Confirm',
  '重置默认': 'Reset Defaults',
  '保存全部配置': 'Save All Config',
  '加载系统配置...': 'Loading System Config...',
  '管理系统全局参数和提成阶梯配置': 'Manage system global parameters and commission tier config',
  '全局参数': 'Global Parameters',
  '提成阶梯': 'Commission Tiers',
  '基础信息': 'Basic Info',
  '地址信息': 'Address Info',
  '尺寸信息': 'Size Info',
  '交期信息': 'Delivery Info',
  '直接映射': 'Direct Mapping',
  '枚举映射': 'Enum Mapping',
  '固定值': 'Fixed Value',
  '组合映射': 'Combined Mapping',
  '客户电话': 'Customer Phone',
  '收货地址': 'Shipping Address',
  '顾客姓名(webName)': 'Customer Name (webName)',
  '电话(webPhone)': 'Phone (webPhone)',
  '地址(webAddress)': 'Address (webAddress)',
  '快递(webExpress)': 'Express (webExpress)',
  '身高(tech1)': 'Height (tech1)',
  '体重(tech11)': 'Weight (tech11)',
  '试衣(webQQ)': 'Fitting (webQQ)',
  '工艺备注(suggest)': 'Craft Notes (suggest)',
  '单马甲': 'Single Vest',
  '2件套(上衣+西裤)': '2-Piece Set (Jacket + Trousers)',
  '3件套(上衣+西裤+马甲)': '3-Piece Set (Jacket + Trousers + Vest)',
  '马甲+裤子': 'Vest + Trousers',
  'coat(西上装)': 'coat (Jacket)',
  'topcoat(大衣)': 'topcoat (Overcoat)',
  'pant(西裤)': 'pant (Trousers)',
  'vest(马甲)': 'vest (Vest)',
  'shirt(衬衫)': 'shirt (Shirt)',
  '1A1B(2件套)': '1A1B (2-Piece Set)',
  '1A1B1C(3件套)': '1A1B1C (3-Piece Set)',
  '1B1C(马甲+裤子)': '1B1C (Vest + Trousers)',
  '自动': 'Auto',
  '已人工确认': 'Manually confirmed',
  'CMT加工费 / 面料编号': 'CMT Processing Fee / Fabric Code',
  'CMT来料加工无需选择系统面料': 'CMT: no system fabric selection required',
  '保存草稿失败': 'Failed to save draft',
  '搜索结果': 'Search Results',
  '作废后关联订单将恢复为未开票状态，是否继续？': 'Related orders will revert to uninvoiced status. Continue?',
  '取消核对': 'Cancel Check',
  '标记为已核对': 'Mark as Checked',
  '导出Excel成功': 'Excel exported successfully',
  '导出PDF成功': 'PDF exported successfully',
  '已取消核对': 'Check cancelled',
  '已标记为已核对': 'Marked as checked',
  '已转为正式发票': 'Converted to official invoice',
  '正在生成Excel...': 'Generating Excel...',
  '正在生成PDF...': 'Generating PDF...',
  '确认作废': 'Confirm Void',
  '确认作废发票': 'Confirm Void Invoice',
  '确认驳回': 'Confirm Reject',
  '确认驳回发票': 'Confirm Reject Invoice',
  '驳回后关联订单将恢复为未开票状态，是否继续？': 'Rejecting will restore associated orders to uninvoiced status. Continue?',
  '转正式发票': 'Convert to Official Invoice',
  '确认保存草稿': 'Confirm Save Draft',
  '草稿保存成功': 'Draft saved successfully',
  '订单出入库': 'Order Inbound/Outbound',
  '出入库类型': 'Inbound/Outbound Type',
  '入库': 'Inbound',
  '出库': 'Outbound',
  '待入库': 'Pending Inbound',
  '待出库': 'Pending Outbound',
  '标记入库成功': 'Inbound marked',
  '标记出库成功': 'Outbound marked',
  '请先填写物流公司和物流单号': 'Please fill in logistics company and tracking number',
  '按订单标记入库与出库': 'Mark inbound/outbound per order',
  '查询': 'Search',
  '工厂编号': 'Factory Code',
  '订单编号': 'Order No.',
  '备注信息': 'Remarks',
  '新增记录': 'New Record',
  '编辑出入库记录': 'Edit Inbound/Outbound Record',
  '新增出入库记录': 'New Inbound/Outbound Record',
  '管理订单的入库与出库记录': 'Manage order inbound and outbound records',
  '请选择出入库类型': 'Please select inbound/outbound type',
  '请输入工厂编号': 'Please enter factory code',
  '请输入订单编号': 'Please enter order no.',
  '请输入物流公司': 'Please enter logistics company',
  '请输入物流单号': 'Please enter tracking no.',
  '请输入备注信息': 'Please enter remarks',
  '0.15-0.6 双贡针': '0.15-0.6cm Double Stitch',
  '0.15-0.9 双贡针': '0.15-0.9cm Double Stitch',
  '0.15-0.9cm 双贡针': '0.15–0.9cm Double',
  '0.15cm 贡针': '0.15cm Stitch',
  '0.3cm 贡针': '0.3cm Stitch',
  '0.6cm 贡针': '0.6cm Stitch',
  '0.9cm 贡针': '0.9cm Stitch',
  '1 个平叠锁眼 + 1 纽扣': '1 Kissing Flat Buttonhole + 1 Button',
  '1 个平斜锁眼 + 1 纽扣': '1 Slant Flat Buttonhole + 1 Button',
  '1 个平斜锁眼+1 纽扣': '1 Flat Slanted Buttonhole + 1 Button',
  '1 个平锁眼 + 1 纽扣': '1 Flat Buttonhole + 1 Button',
  '1 个斜叠锁眼 + 1 纽扣': '1 Kissing Slanted Buttonhole + 1 Button',
  '2 个平叠锁眼 + 2 纽扣': '2 Kissing Flat Buttonholes + 2 Buttons',
  '2 个平斜锁眼 + 2 纽扣': '2 Slant Flat Buttonholes + 2 Buttons',
  '2 个平斜锁眼+2 纽扣': '2 Flat Slanted Buttonholes + 2 Buttons',
  '2 个平锁眼 + 2 纽扣': '2 Flat Buttonholes + 2 Buttons',
  '2 个斜叠锁眼 + 2 纽扣': '2 Kissing Slanted Buttonholes + 2 Buttons',
  '2 件套': '2-PCS',
  '2 次代用料毛样': '2nd Quick Muslin Fitting',
  '20米以上价格': '20m+ Price',
  '3 个平叠锁眼+3 纽扣': '3 Kissing Flat Buttonholes + 3 Buttons',
  '3 个平斜锁眼+3 纽扣': '3 Flat Slanted Buttonholes + 3 Buttons',
  '3 个平锁眼 + 3 纽扣': '3 Flat Buttonholes + 3 Buttons',
  '3 个平锁眼+3 纽扣': '3 Flat Buttonholes + 3 Buttons',
  '3 个斜叠锁眼+3 纽扣': '3 Kissing Slanted Buttonholes + 3 Buttons',
  '3 个贴袋': '3 Patch Pockets',
  '3 件套': '3-PCS',
  '4 个平叠锁眼+4 纽扣': '4 Kissing Flat Buttonholes + 4 Buttons',
  '4 个平斜锁眼+4 纽扣': '4 Flat Slanted Buttonholes + 4 Buttons',
  '4 个平锁眼 + 4 纽扣': '4 Flat Buttonholes + 4 Buttons',
  '4 个平锁眼+4 纽扣': '4 Flat Buttonholes + 4 Buttons',
  '4 个斜叠锁眼+4 纽扣': '4 Kissing Slanted Buttonholes + 4 Buttons',
  '5 个平叠锁眼+5 纽扣': '5 Kissing Flat Buttonholes + 5 Buttons',
  '5 个平斜锁眼+5 纽扣': '5 Flat Slanted Buttonholes + 5 Buttons',
  '5 个平锁眼 + 5 纽扣': '5 Flat Buttonholes + 5 Buttons',
  '5 个平锁眼+5 纽扣': '5 Flat Buttonholes + 5 Buttons',
  '5 个斜叠锁眼+5 纽扣': '5 Kissing Slanted Buttonholes + 5 Buttons',
  '5.5cm 袋盖': '5.5cm Flap',
  '6 个平叠锁眼+6 纽扣': '6 Kissing Flat Buttonholes + 6 Buttons',
  '6 个平斜锁眼+6 纽扣': '6 Flat Slanted Buttonholes + 6 Buttons',
  '6 个平锁眼 + 6 纽扣': '6 Flat Buttonholes + 6 Buttons',
  '6 个平锁眼+6 纽扣': '6 Flat Buttonholes + 6 Buttons',
  '6 个斜叠锁眼+6 纽扣': '6 Kissing Slanted Buttonholes + 6 Buttons',
  '6.5cm 袋盖': '6.5cm Flap',
  '60米以上价格': '60m+ Price',
  '7.5cm 袋盖': '7.5cm Flap',
  '8.5cm 袋盖': '8.5cm Flap',
  'AI 生成最终款式图': 'AI Preview',
  'API 配置': 'API Settings',
  'API配置': 'API Config',
  'CMT工艺费（USD）': 'CMT Labour Only (USD)',
  'IP 地址': 'IP Address',
  'POLO 门襟 3.5cm（门襟 3 扣）': 'Polo Placket 3.5cm (3 Buttons)',
  'POLO 门襟 3cm（门襟 3 扣）': 'Polo Placket 3cm (3 Buttons)',
  'RTW成衣': 'Ready-to-Wear (RTW)',
  'RTW成衣价格表': 'RTW Volume Price List',
  'V 型开口': 'V-shape Opening',
  'V 领': 'V-neckline',
  '一字半里（包边）': 'Straight 1/4 Half Lining (Bound)',
  '一字半里（贡针）': 'Straight 1/4 Half Lining (Pick Stitch)',
  '一字胸袋+下单开线袋': 'Chest Welt + Lower Single Besom',
  '一字胸袋+下双开线袋': 'Chest Welt + Lower Double Besom',
  '一字胸袋+下贴袋': 'Chest Welt + Lower Patch',
  '一字领（外弧 CUTAWAY）': 'Cutaway Collar',
  '一片领': 'One-piece Collar',
  '一金（住房公积金）': 'Housing Fund',
  '三件套西装': '3-Piece Suit',
  '上一字胸袋+下双线袋有袋盖': 'Chest Welt + Lower Flapped Double Besom',
  '上一步': 'Back',
  '上下都无口袋': 'No Pockets',
  '上传体型照': 'Upload Photos',
  '体型照': 'Body Photos',
  '上传凭证': 'Upload Receipt',
  '上传图片': 'Upload Image',
  '上左右一字袋+下左右一字袋': 'Both-side Welt Chest + Both-side Welt Lower',
  '上弧形': 'Upper Arc Milanese',
  '上衣 + 马甲': 'Jacket + Vent',
  '上衣长短习惯': 'Jacket Length Habit',
  '下一步': 'Next',
  '下单日期': 'Order Date',
  '下单日期（B 端）': 'MM/DD/YYYY',
  '下口袋袋盖高度': 'Flap Height',
  '下圆青果领': 'Dropped Round Shawl Lapel',
  '下弧形': 'Lower Arc Milanese',
  '下摆型': 'Bottom Style',
  '下载': 'Download',
  '不可拆卸插片': 'Fixed Collar Stays',
  '不合格': 'Unqualified',
  '不合格原因': 'Defect Reason',
  '不合格数量': 'Failed Qty',
  '不试身': 'No Fitting',
  '专业能力': 'Professionalism',
  '业务员': 'Sales Staff',
  '业务经理': 'Sales Manager',
  '两件套西装': '2-Piece Suit',
  '个人分红': 'Personal Dividend',
  '个人所得税': 'Income Tax',
  '个人提成阶梯': 'Personal Commission Tiers',
  '个人资料': 'Profile',
  '个性收费': 'Customizations',
  '个性收费项配置': 'Extra Charge Config',
  '中圆青果领': 'Medium Round Shawl Lapel',
  '中文': 'Chinese',
  '中文名称': 'Chinese name',
  '中腰': 'Waist/Stomach',
  '中英双语': 'Bilingual',
  '主题': 'Theme',
  '争议处理': 'Dispute',
  '事事如意': 'Everything Goes Well',
  '五险（保险）': 'Social Insurances',
  '亚麻系列': 'Linen',
  '交易日期': 'Transaction Date',
  '人民币参考': '¥X,XXX.XX',
  '仅复用客户信息': 'Copy Client Info Only',
  '仅复用款式': 'Copy Style Only',
  '今日新增订单': 'Today New Orders',
  '仓储物流': 'Warehouse',
  '付款信息': 'Payment',
  '付款审核': 'Payment Audit',
  '付款审核中': 'Payment Review',
  '付款已确认': 'Payment Confirmed',
  '付款异常': 'Payment Exception',
  '付款方式': 'Payment Method',
  '付款状态': 'Payment Status',
  '付款记录': 'Payment History',
  '付款金额': 'Payment Amount',
  '代用料手工毛样': 'Handmade Quick Muslin Fitting',
  '代用料毛样': 'Quick Muslin Fitting',
  '代采购': 'Agency Order',
  '价格': 'Price',
  '价格体系': 'Pricing',
  '价格如有变动，恕不另行通知。': 'Prices are subject to change without prior notice.',
  '价格档': 'Price Tier',
  '客供价格档': 'CMT Price Tier',
  '价格档次': 'Price Grade',
  '价格等级表': 'Price Grade Table',
  '优先级': 'Priority',
  '优先（10 天）': 'Priority (10 days)',
  '优惠活动': 'Promotions',
  '伸缩调节袢纽扣': 'Elastic Adjuster with Button',
  '住房公积金': 'Housing Fund',
  '体型及尺寸档案': 'Measurement History',
  '体型描述': 'Body Description',
  '体型特征': 'Body Profile',
  '体重': 'Weight',
  '体重超出正常范围，请检查修改。': 'Weight seems unusual. Please double-check.',
  '余款须在发货前结清。': 'The balance must be settled before shipment.',
  '供应商': 'Supplier',
  '供应商对账单': 'Supplier Bills',
  '供应商管理': 'Suppliers',
  '工厂映射导入': 'Factory Mapping Import',
  '工厂映射数据管理': 'Factory Mapping Management',
  '导入选项': 'Import Options',
  '试运行（不写入数据库）': 'Dry Run (No DB Write)',
  '清空该工厂旧映射后再导入': 'Clear Old Mappings Before Import',
  'JD-HP 推送映射表': 'JD-HP Push Mapping Table',
  '设计选项表': 'Design Options Table',
  '对应文件：JD-HP推送映射完整对照表-Final.xlsx': 'File: JD-HP Push Mapping Full Comparison Table-Final.xlsx',
  '对应文件：09_设计选项_JD_V1.5.xlsx': 'File: 09_Design_Options_JD_V1.5.xlsx',
  '请至少上传一个映射 Excel 文件': 'Please upload at least one mapping Excel file',
  '试运行完成，请查看结果': 'Dry run completed, please review the results',
  '从 Excel 批量导入设计选项与工厂工艺编码映射': 'Batch import design options and factory craft code mappings from Excel',
  '导入结果': 'Import Results',
  '当前为试运行模式，未实际写入数据库': 'Current mode is dry run, no data written to database',
  '映射类型': 'Mapping Type',
  '错误信息': 'Error Messages',
  '侧伸缩腰': 'Hidden Side Elastic',
  '侧开叉': 'Side Vent',
  '侧松紧腰': 'Side Elastic',
  '侧缝顺色哑光色丁 1.5cm': 'Side Matching Matte Satin 1.5cm',
  '侧缝顺色哑光色丁 2.5cm': 'Side Matching Matte Satin 2.5cm',
  '侧缝黑色哑光色丁 1.5cm': 'Side Black Matte Satin 1.5cm',
  '侧缝黑色哑光色丁 2.5cm': 'Side Black Matte Satin 2.5cm',
  '保存': 'Save',
  '保存修改': 'Save Changes',
  '保存失败': 'Save failed',
  '保存成功': 'Saved',
  '信用卡': 'Credit Card',
  '信用额度': 'Credit Limit',
  '信用额度管理': 'Credit Limit',
  '修改密码': 'Change Password',
  '修改设置': 'Update Settings',
  '修改费': 'Alteration Fee',
  '修身': 'Slim',
  '倒缝袖（垫肩 0.1cm + 单层棉条 + 自然褶）': 'Spalla Camicia (0.1cm pad, natural pleats)',
  '倒缝袖（无垫肩 + 无棉条 + 自然褶）': 'Spalla Camicia (No padding, natural pleats)',
  '假袖叉假锁眼': 'Mock Vent (No Open)',
  '假袖叉圆头锁眼': 'Mock Vent (Round BH)',
  '假袖叉圆弧翻边（4.5cm）': 'Non-functional Vent + Functional Buttonhole + Curved Turn-up 4.5cm',
  '假袖叉圆弧翻边（7.5cm）': 'Non-functional Vent + Functional Buttonhole + Curved Turn-up 7.5cm',
  '假袖叉无锁眼': 'Mock Vent (No BH)',
  '假袖叉直翻边（4.5cm）': 'Non-functional Vent + Functional Buttonhole + Straight Turn-up 4.5cm',
  '假袖叉直翻边（7.5cm）': 'Non-functional Vent + Functional Buttonhole + Straight Turn-up 7.5cm',
  '停用': 'Inactive',
  '催款通知': 'Overdue Reminder',
  '充值 / 退款金额': 'Deposit/Refund',
  '充值记录': 'Recharge History',
  '光门襟 3.5cm': 'French Placket 3.5cm',
  '光门襟 3cm': 'French Placket 3cm',
  '克重': 'Weight',
  '免熨系列': 'Wrinkle-free',
  '免费系列': 'Free Lining',
  '入门档': 'BASIC / Entry',
  '全体员工总权重': 'Total Weight',
  '全勤': 'Attendance Bonus',
  '全屏': 'Fullscreen',
  '全手工': 'Full Bespoke',
  '全手工全麻衬厚胸衬': 'Full Handmade Full Canvas (Structured)',
  '全手工全麻衬薄胸衬': 'Full Handmade Full Canvas (Soft)',
  '全松紧腰': 'Full Elastic',
  '全松紧（前门襟无松紧）': 'Full Elastic (No Fly Elastic)',
  '全衬': 'Full Canvas',
  '全裤袢 10 个 1cm': '10 Belt Loops (1cm)',
  '全裤袢 2cm': 'Full Belt Loops (2cm)',
  '全裤袢 6 个 1cm': '6 Belt Loops (1cm)',
  '全裤袢 7 个 1cm': '7 Belt Loops (1cm)',
  '全裤袢 8 个 1cm': '8 Belt Loops (1cm)',
  '全贡针': 'Full Pick Stitch',
  '全部': 'All',
  '全部已读': 'Mark all read',
  '全里': 'Full Lining',
  '全麻衬厚胸衬': 'Full Canvas (Structured)',
  '全麻衬薄胸衬': 'Full Canvas (Soft)',
  '公司仓库': 'JD Warehouse',
  '公告': 'Announcement',
  '共': 'Total',
  '关税': 'Duties',
  '关联单号': 'Related Order #',
  '关联售后工单': 'Related Tickets',
  '关联工厂': 'Link Factories',
  '关闭': 'Close',
  '其他': 'Other',
  '加工费 (USD)': 'Processing Fee (USD)',
  '其他奖金': 'Other Bonus',
  '其他成员团单合计': 'Team RTW Sales (Others)',
  '其他成员定制单合计': 'Team MTM Sales (Others)',
  '其他扣款': 'Other Deductions',
  '其他服装': 'Other Clothing',
  '其他费用': 'Other Fees',
  '其它费用': 'Other',
  '其它费用/关税': 'Other Fees / Duties',
  '内容': 'Content',
  '内折 5cm': 'Inner Hem 5cm',
  '内折 7cm': 'Inner Hem 7cm',
  '内滚条': 'Inner Piping',
  '内袋款式': 'Inner Pocket Style',
  '内袖口撞色': 'Inner Cuffs Contrast',
  '内贡针及贡针线': 'Inner Pick Stitch & Thread',
  '内过肩撞色': 'Inner Yoke Contrast',
  '内门襟撞色': 'Inner Placket Contrast',
  '内领+内袖口+内门襟撞色': 'Inner Collar + Inner Cuffs + Inner Placket Contrast',
  '内领+内袖口撞色': 'Inner Collar + Inner Cuffs Contrast',
  '内领底居中': 'Under Collar Center',
  '内领撞色': 'Inner Collar Contrast',
  '冬季': 'Winter',
  '净尺寸': 'Body',
  '准直胸袋': 'Welt Chest Pocket',
  '减少': 'Decrease',
  '减少品类信息将丢失': 'Removing categories will discard associated data',
  '凭证/参考号': 'Reference No.',
  '凭证截图': 'Receipt',
  '出生日期': 'Date of Birth',
  '出货期': 'Finished Date',
  '出货通知': 'Shipping Notification',
  '分红年份': 'Dividend Year',
  '分红池比例': 'Dividend Pool Ratio',
  '切角 1 眼 2 扣': 'Angled 1-Buttonhole 2-Buttons',
  '切角 2 用': 'Angled Convertible Cuff',
  '切角 2 眼 2 扣': 'Angled 2-Buttonholes 2-Buttons',
  '创建失败': 'Creation failed',
  '创建新订单': 'New Order',
  '创建日期': 'Created Date',
  '创建时间': 'Created At',
  '创建订单': 'Create Order',
  '创建订单过程中，系统会自动保存您的进度': 'Your progress will be auto-saved',
  '初审通过': 'First Review Passed',
  '删除': 'Delete',
  '删除失败': 'Delete failed',
  '删除订单': 'Delete Order',
  '利润汇总': 'Profit Summary',
  '刷新': 'Refresh',
  '刷新重试': 'Refresh & Retry',
  '刺绣位置': 'Embroidery Placement',
  '刺绣内容': 'Embroidery Content',
  '刺绣备注': 'Embroidery Notes',
  '刺绣姓名缩写': 'Monogram Embroidery',
  '刺绣字体': 'Embroidery Font',
  '刺绣设计': 'Embroidery Design',
  '刺绣高度': 'Embroidery Height',
  '前后全里': 'Full Lining',
  '前后半里': 'Half Lining',
  '前挺缝线': 'Front Crease',
  '前浪': 'Front Rise',
  '前片全里': 'Front Full Lining',
  '前片半里': 'Front Half Lining',
  '前片设计': 'Front Design',
  '前片贴布': 'Front Placket Fabric',
  '前端分类项配置': 'Front Category',
  '前端渲染发生错误': 'Frontend Rendering Error',
  '前胸宽': 'Chest Width (Front)',
  '前腰节': 'Front Waist Length',
  '前腰节长': 'Front Waist Length',
  '前衣长': 'Front Length',
  '前长': 'Front Length',
  '前领 1 个纽扣': '1-Button Collar Stand',
  '前领 2 个纽扣': '2-Button Collar Stand',
  '剪刀型': 'Scissors Shape Milanese',
  '加入购物车': 'Add to Cart',
  '加急单数量': 'Rush Orders',
  '加急费': 'Rush Order Fee',
  '加急（7 天）': 'Rush (7 days)',
  '加载中…': 'Loading…',
  '包装升级': 'Premium Packaging',
  '千克': 'kg',
  '半圆形半里（包边）': 'Half Rounded Half Lining (Bound)',
  '半圆形半里（贡针）': 'Half Rounded Half Lining (Pick Stitch)',
  '半手工半麻衬厚胸衬': 'Half Handmade Half Canvas (Firm)',
  '半手工半麻衬薄胸衬': 'Half Handmade Half Canvas (Soft)',
  '半手工无结构无胸衬': 'Semi-Handmade Unstructured (No Canvas)',
  '半衬': 'Half Canvas',
  '半贡针': 'Half Pick Stitch',
  '半麻衬厚胸衬': 'Half Canvas (Firm)',
  '半麻衬薄胸衬': 'Half Canvas (Soft)',
  '单 6 扣': '6-Button Single Breasted',
  '单上衣': 'Jacket Only',
  '单价': 'Unit Price',
  '单价 (USD)': 'Unit Price (USD)',
  '单价（USD）': 'Price (USD)',
  '单位': 'Unit',
  '单大衣': 'Overcoat Only',
  '单开线竖口袋': 'Vertical Single Besom Pocket',
  '单开线袋+锁眼钉扣': 'Single Besom + Buttonhole & Button',
  '单开线袋（无眼无扣）': 'Single Besom (No Buttonhole)',
  '单排 1 粒对拉扣': '1 Wrap',
  '单排 1 粒扣': '1 SB',
  '单排 2 粒扣': '2 SB',
  '单排 3 扣': '3-Button Single Breasted',
  '单排 3 扣 2': '3/2,SB',
  '单排 3 粒扣': '3 SB',
  '单排 4 扣': '4-Button Single Breasted',
  '单排 5 扣': '5-Button Single Breasted',
  '单独发': 'Ship Separately',
  '单独开票': 'Separate',
  '单省道': 'Single Dart',
  '单线袋': 'Single Besom Pocket',
  '单线袋（1.2cm）': 'Single Besom (1.2cm)',
  '单衬衫': 'Shirt Only',
  '单褶向内': 'Single Reverse Pleat',
  '单褶向内+手工套结': 'Single Reverse Pleat + Hand Bartack',
  '单褶向外': 'Single Forward Pleat',
  '单褶向外+手工套结': 'Single Forward Pleat + Hand Bartack',
  '单西裙': 'Skirt Only',
  '单西裤': 'Trousers Only',
  '单边宝剑头调节袢': 'Single Side Adjuster (Sword)',
  '单边小弧形调节袢': 'Single-side Curved Adjuster',
  '单边廓尔格腰': 'Single Gurkha Waistband',
  '卡袋上订商标 + 面料标': 'Brand + Fabric Label on Card Pocket',
  '卡袋上订商标+面料标': 'Brand + Fabric Label on Card Pocket',
  '厘米': 'cm',
  '原金额': 'Original Amount',
  '参考值': 'Guide',
  '参考汇率': 'Exchange Rate (USD→CNY)',
  '双开叉无防风条': 'Double Vent (No Vent Stay)',
  '双开叉防风条': 'Double Vent (Vent Stay)',
  '双开线竖口袋': 'Vertical Double Besom Pocket',
  '双开线袋+圆扣袢+锁眼钉扣': 'Double Besom + Round Tab + Buttonhole & Button',
  '双开线袋+锁眼钉扣': 'Double Besom + Buttonhole & Button',
  '双开线袋（无眼无扣）': 'Double Besom (No Buttonhole)',
  '双排 2 扣 1': '2x1 DB',
  '双排 4 扣 2': '4x2 DB',
  '双排 4 扣 2+尖下摆': 'DB 4×2 + Pointed Hem',
  '双排 5 扣 3 斜门襟': 'DB 5×3 Diagonal Fly',
  '双排 6 扣 1': '6x1 DB',
  '双排 6 扣 2': '6x2 DB',
  '双排 6 扣 2+尖下摆': 'DB 6×2 + Pointed Hem',
  '双排 6 扣 3': '6x3 DB',
  '双排 6 扣 3 斜门襟+尖下摆': 'DB 6×3 Diagonal Fly + Pointed Hem',
  '双排 6 扣 3+尖下摆': 'DB 6×3 + Pointed Hem',
  '双排 8 扣 4': '8x4 DB',
  '双排 8 扣 4+尖下摆': 'DB 8×4 + Pointed Hem',
  '双省道': 'Double Darts',
  '双线大袋（有袋盖）+ 一字票袋（无袋盖）': 'Flapped Double Besom + Welt Ticket Pocket',
  '双线大袋（有袋盖）+ 双线票袋（有袋盖）': 'Flapped Double Besom + Ticket Pocket (Flap)',
  '双线大袋（直角袋盖）+双线票袋（直角袋盖）': 'Double Besom (Square Flap) + Double Besom Ticket (Square Flap)',
  '双线袋': 'Double Besom Pocket',
  '双线袋 + 小圆直袋盖': 'Double Besom + Standard Flap',
  '双线袋无袋盖': 'Double Besom without Flap',
  '双线袋（无盖）+ 双线票袋（无盖）': 'Double Besom (No flap) + Double Besom Ticket (No flap)',
  '双褶向内': 'Double Reverse Pleats',
  '双褶向内+手工套结': 'Double Reverse Pleats + Hand Bartack',
  '双褶向外+手工套结': 'Double Forward Pleats + Hand Bartack',
  '双褶外': 'Double Forward Pleats',
  '双边廓尔格腰': 'Double Gurkha Waistband',
  '发票列表': 'Invoice List',
  '发票号': 'Invoice #',
  '发票数': 'Invoice Count',
  '发票记录': 'Invoices',
  '发货': 'Ship',
  '发货中': 'Shipping',
  '发货单': 'Shipping Note',
  '发货管理': 'Shipping',
  '发起售后': 'Create Ticket',
  '发送失败': 'Send failed',
  '发送状态': 'Sent Status',
  '发送给供应商': 'Send to Supplier',
  '取消': 'Cancel',
  '取消后订单将无法恢复': 'Order cannot be recovered after cancellation',
  '取消订单': 'Cancel Order',
  '取消订单失败，请联系客服。': 'We couldn\'t cancel this order. Please contact your designer.',
  '取消选择': 'Clear Selection',
  '口袋': 'Pockets',
  '古巴领': 'Cuban Collar',
  '可拆卸插片': 'Removable Collar Stays',
  '可用': 'Available',
  '可用余额': 'Available Balance',
  '可用额度': 'Available Credit',
  '右 3': 'Right 3',
  '右前 1 个裤袢 1cm': '1 Right-front Belt Loop (1cm)',
  '右前 1 个裤袢 2cm': '1 Right-front Belt Loop (2cm)',
  '右前片下腰口': 'Right Front Below Waistband',
  '右前腰部（第 4 个纽扣右侧）': 'Right Front Waist (Right of 4th Button)',
  '右单开线袋+锁眼钉扣': 'Right Single Besom + Buttonhole & Button',
  '右单开线袋（无眼无扣）': 'Right Single Besom (No Buttonhole)',
  '右双开线袋+桃型袋盖': 'Right Double Besom + Curved Flap',
  '右双开线袋+菱形袋盖': 'Right Double Besom + Diamond Flap',
  '右双开线袋+锁眼钉扣': 'Right Double Besom + Buttonhole & Button',
  '右双开线袋（无眼无扣）': 'Right Double Besom (No Buttonhole)',
  '右开线袋+圆扣袢+锁眼钉扣': 'Right Welt + Round Tab + Buttonhole & Button',
  '右手腕': 'Right Wrist',
  '右挂面袋上居中': 'Right Facing Pocket',
  '右腰线上双线袋+右袋布内': 'Right Waist Double Welt +Inside Right Pocket',
  '右腰线上双线袋+左袋布内': 'Right Waist Double Welt + Inside Left Pocket',
  '右腰缝上一字袋+右袋布内': 'Right Seam Welt + Inside Right Pocket',
  '右腰缝上一字袋+左袋布内': 'Right Seam Welt + Inside Left Pocket',
  '右腰里刺绣': 'Right Waistband Inside Embroidery',
  '右腰里订商标': 'Brand Label – Right Waistband Inside',
  '右腰里订面料标': 'Fabric Label – Right Waistband Inside',
  '右腰顶开缝袋': 'Right Waist Top Seam Pocket',
  '右表袋+桃型袋盖+锁眼钉扣': 'Right Watch Pocket & Curved Flap',
  '右表袋+菱形袋盖+锁眼钉扣': 'Right Watch Pocket + Diamond Flap + Button',
  '右袖口': 'Right Cuff',
  '右袖长': 'Right Sleeve Length',
  '右里袋上居中': 'Right Inner Pocket',
  '右驳头眼顺边绣': 'Right Lapel Buttonhole Edge Embroidery',
  '合体': 'Regular',
  '合体要求': 'Fit',
  '合作年限': 'Partnership Years',
  '合作状态': 'Partnership Status',
  '合作等级': 'Rating (1-5)',
  '合作门店': 'Partner Stores',
  '合并发票': 'Combined Invoice',
  '合并开票': 'Combined',
  '合格': 'Qualified',
  '合格数量': 'Passed Qty',
  '同上衣里布': 'Same as Jacket',
  '同大身': 'Same as Body',
  '同步失败': 'Sync failed',
  '同西服上衣': 'Same as Jacket',
  '后中衩': 'Center Vent',
  '后中长': 'Back Center Length',
  '后台日期': 'YYYY-MM-DD',
  '后尖角贴袋': 'Back Pointed Patch Pocket',
  '后开叉型': 'Back Vent',
  '后开衩': 'Back Vent',
  '后片省': 'Back Darts',
  '后片设计': 'Back Style',
  '后端服务返回错误': 'Backend Service Error',
  '后背内工字褶': 'Hidden Box Pleat',
  '后背双褶': 'Double Back Pleats',
  '后背双褶+双省': 'Double Back Pleats + Double Darts',
  '后背宽': 'Back Width',
  '后背明工字褶': 'Visible Box Pleat',
  '后背明工字褶+双省': 'Visible Box Pleat + Double Darts',
  '后背用料': 'Back Fabric',
  '后腰开口': 'Back Waistband Opening',
  '后腰节': 'Back Waist Length',
  '后腰节长': 'Back Waist Length',
  '后衣长': 'Back Length',
  '后表袋+桃型袋盖+暗锁眼钉扣': 'Back Watch Pocket + Curved Flap + Hidden Button',
  '后表袋+菱形袋盖+暗锁眼钉扣': 'Back Watch Pocket + Diamond Flap + Hidden Button',
  '后领底尼上口居中': 'Under Collar – Top',
  '后领底尼下口居中': 'Under Collar – Bottom',
  '启用': 'Enabled',
  '告警': 'Alert',
  '员工': 'Employee',
  '员工分红比例': 'Employee Dividend Ratio',
  '员工工资汇总': 'Salary Summary',
  '品牌': 'Brand',
  '品牌名称': 'Brand Name',
  '品类': 'Category',
  '品类选择': 'Category',
  '品类配置': 'Category Config',
  '品质': 'Quality',
  '响应速度': 'Responsiveness',
  '售后': 'After-sales',
  '售后信息': 'After Sales',
  '售后工单': 'After-sales Tickets',
  '售后申请失败，请稍后重试。': 'Something went wrong. Please try again.',
  '售后管理': 'After Sales',
  '售后记录': 'After-sales History',
  '商标': 'Labels',
  '商标 + 领标': 'Brand + Neck Label',
  '商标+领标': 'Brand Label + Collar Label',
  '商标及码标都订后复势': 'Brand + Size Label on Back Yoke',
  '商标在右': 'Brand Label Right',
  '商标在左': 'Brand Label Left',
  '商标订下里襟': 'Label on Under Placket',
  '商标订卡袋上': 'Brand Label on Card Pocket',
  '商标订后复势': 'Label on Back Yoke',
  '商标订后复势+面料标订下里襟': 'Brand on Back Yoke + Fabric on Under Placket',
  '四季': 'All Season',
  '团单提成率': 'RTW Commission Rate',
  '团队管理提成': 'Team Management Commission',
  '团队管理提成率': 'Team Management Rate',
  '国家/地区': 'Country',
  '图案': 'Pattern',
  '图片': 'Image',
  '图片上传失败，请检查文件格式和大小。': 'Couldn\'t upload image. Please check file type and size.',
  '圆头 5cm+暗钩': 'Rounded Tip 5cm + Hook & Bar',
  '圆头 5cm+锁眼钉扣': 'Rounded Extension 5cm + Buttonhole & Button',
  '圆形牛仔袋（又名月牙袋）': 'Curved Denim Pocket',
  '圆形青果领': 'Full Round Shawl Lapel',
  '圆摆': 'Rounded Hem',
  '圆角 1 眼 2 扣': 'Rounded 1-Buttonhole 2-Buttons',
  '圆角 2 用': 'Rounded Convertible Cuff',
  '圆角 2 眼 2 扣': 'Rounded 2-Buttonholes 2-Buttons',
  '圆角立领': 'Mandarin Collar (Band Collar)',
  '圆角领': 'Round Collar',
  '圆贴布中褶': 'Curved Placket – Medium Tuck',
  '圆贴布大褶': 'Curved Placket – Large Tuck',
  '圆贴布小褶（塔克）': 'Curved Placket – Small Tuck',
  '圆贴布无褶': 'Curved Placket – No Tuck',
  '在右袋布内': 'Inside Right Pocket',
  '在左右袋布内': 'Inside Both Pocket',
  '在左袋布内': 'Inside Left Pocket',
  '在线门店': 'Online Stores',
  '地址': 'Address',
  '城市': 'City',
  '基准价': 'Default Price',
  '基本信息': 'Basic Info',
  '基本工资': 'Base Salary',
  '基础价格': 'Base Price',
  '基础价格表': 'Base Price List',
  '基础数据管理': 'Master Data',
  '增加': 'Increase',
  '处理': 'Handle',
  '处理中': 'Processing',
  '处理失败': 'Processing failed',
  '处理方式': 'Action',
  '处罚规则': 'Penalty Rules',
  '备注': 'Notes',
  '备货': 'Restock',
  '备货中': 'Pre-order',
  '复制旧订单': 'Duplicate from Existing',
  '复制订单': 'Duplicate Order',
  '复制链接': 'Copy Link',
  '复审通过': 'Second Review Passed',
  '复用全部信息': 'Copy All',
  '复用旧订单': 'Use Existing',
  '夏季': 'Summer',
  '外翻 3.5cm': 'Turn-up Cuff 3.5cm',
  '外翻 3cm': 'Turn-up Cuff 3cm',
  '外翻 5.5cm': 'Turn-up Cuff 5.5cm',
  '外翻 5cm': 'Turn-up Cuff 5cm',
  '外翻 6cm': 'Turn-up Cuff 6cm',
  '外裤长': 'Outseam',
  '外贡针线': 'Outer Pick Stitch Thread',
  '外过肩撞色': 'Outer Yoke Contrast',
  '外领面居中': 'Outer Collar Center',
  '大 U 型': 'Large U-neckline',
  '大八字领': 'Wide Spread Collar',
  '大圆型下摆': 'Large Round Hem',
  '大挂面': 'Wide Facing',
  '大挂面无里（包边）': 'Wide Facing Unlined (Bound)',
  '大挂面无里（贡针）': 'Wide Facing Unlined (Pick Stitch)',
  '大挂面（适合无里布工艺）': 'Large Facing (for unlined)',
  '大腿围': 'Thigh',
  '大衣': 'Overcoat',
  '天': 'Days',
  '天然混纺系列': 'Natural Blend',
  '奖励通知': 'Reward Notification',
  '奢华档': 'LUXURY',
  '奢华档（高）': 'LUXURY (High)',
  '女': 'Female',
  '婚礼系列': 'Wedding',
  '子账号': 'Sub-accounts',
  '字体颜色': 'Font Color',
  '存储地点': 'Warehouse Location',
  '完成': 'Done',
  '完成录入待提交': 'Ready to Submit',
  '定制单提成率': 'MTM Commission Rate',
  '定制设计': 'Custom Design',
  '宝剑头 5cm+暗钩': 'Sword Tip 5cm + Hook & Bar',
  '宝剑头 5cm+锁眼钉扣': 'Sword Tip 5cm + Buttonhole & Button',
  '宝剑头挂面': 'Sword Head Facing',
  '实发工资': 'Net Salary',
  '实发提成': 'Actual Commission Paid',
  '实际完成': 'Actual Completion',
  '审批人': 'Approved By',
  '审批备注': 'Approval Note',
  '审批状态': 'Approval Status',
  '审核订单': 'Review Order',
  '审核通过': 'Reviewed',
  '审核驳回': 'Changes Needed',
  '客供图片': 'Client Image',
  '客供里布': 'Client-supplied Lining',
  '客户': 'Customer',
  '客户/门店': 'Client / Store',
  '客户信息&款式设计': 'Client & Style',
  '客户名称': 'Client Name',
  '客户基本信息': 'Customer Info',
  '客户姓名': 'Client Name',
  '客户报价单': 'Client Quotation',
  '客户标签': 'Tags',
  '客户状态': 'Client Status',
  '客户编号': 'Client Code',
  '宴会系列': 'Banquet',
  '宽松': 'Relaxed',
  '寄出日期': 'Shipped Date',
  '密码': 'Password',
  '密码重置失败': 'Password reset failed',
  '密钥': 'API Key',
  '对账单': 'Statement',
  '对账截止日': 'Statement End',
  '对账起始日': 'Statement Start',
  '导入': 'Import',
  '导出': 'Export',
  '导出列表': 'Export List',
  '导出发票': 'Export Invoice',
  '小 U 型': 'Small U-neckline',
  '小圆头 5cm+暗钩': 'Small Round Tip 5cm + Hook & Bar',
  '小圆头 5cm+锁眼钉扣': 'Small Round Tip 5cm + Buttonhole & Button',
  '小圆青果领': 'Small Round Shawl Lapel',
  '小腿围': 'Calf',
  '小腿高度': 'Calf Height',
  '尖角下摆': 'Pointed Hem',
  '尖青果领（JD 尖青果领）': 'Pointed Shawl Lapel',
  '屈身体': 'Rounded Shoulders',
  '工作台': 'Workbench',
  '工厂': 'Factory',
  '工厂A': 'Factory A',
  '工厂B': 'Factory B',
  '工厂供应商': 'Factory Suppliers',
  '工厂信息': 'Factory',
  '工厂单号': 'Factory Order No.',
  '模糊查询': 'Keyword Search',
  '门店编号/工厂单号/面料号': 'Store No. / Factory No. / Fabric No.',
  '工厂原始编号': 'Factory Original Code',
  '工厂名称': 'Factory Name',
  '工厂已确认': 'Factory Confirmed',
  '工厂待审核': 'Factory Pending',
  '工厂成本': 'Factory Cost',
  '工厂成本配置': 'Factory Cost',
  '工厂状态': 'Factory Status',
  '工字褶': 'Inverted Box Pleat',
  '工艺': 'Workmanship',
  '工艺配置': 'Craft Config',
  '左 1 右 2': 'Left 1, Right 2',
  '左 1 右 3': 'Left 1, Right 3',
  '左 2 右 1': 'Left 2, Right 1',
  '左 2 右 2': 'Left 2, Right 2',
  '左 3': 'Left 3',
  '左 3 右 1': 'Left 3, Right 1',
  '左切角胸袋': 'Left Angled Pocket',
  '左切角胸袋+切角袋盖+锁眼钉扣': 'Left Angled Pocket + Angled Flap + Button',
  '左前片下腰口': 'Left Front Below Waistband',
  '左前腰部（第 4 个纽扣左侧）': 'Left Front Waist (Left of 4th Button)',
  '左单开线袋+锁眼钉扣': 'Left Single Besom + Buttonhole & Button',
  '左单开线袋（无眼无扣）': 'Left Single Besom (No Buttonhole)',
  '左双开线袋+圆扣袢+锁眼钉扣': 'Left Double Besom + Round Tab + Buttonhole & Button',
  '左双开线袋+桃型袋盖': 'Left Double Besom + Curved Flap',
  '左双开线袋+菱形袋盖': 'Left Double Besom + Diamond Flap',
  '左双开线袋+锁眼钉扣': 'Left Double Besom + Buttonhole & Button',
  '左双开线袋（无眼无扣）': 'Left Double Besom (No Buttonhole)',
  '左右切角胸袋': 'Both Angled Pockets',
  '左右切角胸袋+切角袋盖+锁眼钉扣': 'Both Angled Pockets + Angled Flap + Button',
  '左右圆胸袋': 'Both Round Pockets',
  '左右圆角胸袋+圆角袋盖+锁眼钉扣': 'Both Round Pockets + Round Flap + Button',
  '左右宝剑头调节袢': 'Side Adjusters (Sword)',
  '左右小弧形调节袢': 'Side Adjusters (Curved)',
  '左右尖角胸袋': 'Both Pointed Pockets',
  '左右工字褶贴袋': 'Both Box Pleated Patch Pockets',
  '左右工字褶贴袋（无袋盖）': 'Both Box Pleat Patch Pocket (No Flaps)',
  '左右工字褶贴袋（桃型袋盖+钉扣）': 'Both Box Pleat Patch Pockets(Rounded Flaps + Buttons)',
  '左右工字褶贴袋（直袋盖）': 'Both Box Pleat Patch Pocket (Straight Flaps)',
  '左右方角胸袋': 'Both Square Pockets',
  '左右方角胸袋+切角袋盖+锁眼钉扣': 'Both Square Pockets + Angled Flap + Button',
  '左右方角胸袋+尖角袋盖+锁眼钉扣': 'Both Square Pockets + Pointed Flap + Button',
  '左右方角胸袋+方角袋盖+锁眼钉扣': 'Both Square Pockets + Square Flap + Button',
  '左右暗风琴褶贴袋': 'Both Hidden Accordion Pleated Patch Pockets',
  '左右暗风琴褶贴袋（无袋盖）': 'Both Bellows Patch Pocket (No Flaps)',
  '左右暗风琴褶贴袋（桃型袋盖+钉扣）': 'Both Bellows Patch Pocket (Rounded Flaps + Button)',
  '左右暗风琴褶贴袋（直袋盖）': 'Both Bellows Patch Pocket (Straight Flaps)',
  '左右驳头眼': 'Both Lapels',
  '左商标+右面料标': 'Brand Label Left + Fabric Label Right',
  '左商标+右面料标+领标': 'Brand Left + Fabric Right + Collar Label',
  '左商标右面料标': 'Brand Left, Fabric Right',
  '左圆胸袋': 'Left Round Pocket',
  '左圆角胸袋+圆角袋盖+锁眼钉扣': 'Left Round Pocket + Round Flap + Button',
  '左尖角胸袋': 'Left Pointed Pocket',
  '左工字褶贴袋': 'Left Box Pleated Patch Pocket',
  '左工字褶贴袋（无袋盖）': 'Left Box Pleat Patch Pocket (No Flap)',
  '左工字褶贴袋（桃型袋盖+钉扣）': 'Left Box Pleat Patch Pocket (Rounded Flap + Button)',
  '左工字褶贴袋（直袋盖）': 'Left Box Pleat Patch Pocket (Straight Flap)',
  '左手腕': 'Left Wrist',
  '左挂面袋上居中': 'Left Facing Pocket',
  '左方角胸袋': 'Left Square Pocket',
  '左方角胸袋+切角袋盖+锁眼钉扣': 'Left Square Pocket + Angled Flap + Button',
  '左方角胸袋+尖角袋盖+锁眼钉扣': 'Left Square Pocket + Pointed Flap + Button',
  '左方角胸袋+方角袋盖+锁眼钉扣': 'Left Square Pocket + Square Flap + Button',
  '左暗风琴褶贴袋': 'Left Hidden Accordion Pleated Patch Pocket',
  '左暗风琴褶贴袋（无袋盖）': 'Left Bellows Patch Pocket (No Flap)',
  '左暗风琴褶贴袋（桃型袋盖+钉扣）': 'Left Bellows Patch Pocket (Rounded Flap + Button)',
  '左暗风琴褶贴袋（直袋盖）': 'Left Bellows Patch Pocket (Straight Flap)',
  '左标准明贴袋（无袋盖）': 'Left Patch Pocket (No flap)',
  '左标准明贴袋（桃形袋盖+钉扣）': 'Left Patch Pocket (Rounded Flap + Button)',
  '左标准明贴袋（桃形袋盖）': 'Left Patch Pocket (Curved flap)',
  '左标准明贴袋（直袋盖）': 'Left Patch Pocket with Straight Flap',
  '左胸前': 'Left Chest',
  '左胸弧形贴袋': 'Left Curved Patch Pocket',
  '左胸弧形贴袋（无袋盖）': 'Left Curved Patch Pocket (No Flap)',
  '左腰里刺绣': 'Left Waistband Inside Embroidery',
  '左腰里订商标': 'Brand Label – Left Waistband Inside',
  '左腰里订面料标': 'Fabric Label – Left Waistband Inside',
  '左袖口': 'Left Cuff',
  '左袖长': 'Left Sleeve Length',
  '左里袋上居中': 'Left Inner Pocket',
  '左面料标+右商标': 'Fabric Label Left + Brand Label Right',
  '左面料标右商标': 'Fabric Left, Brand Right',
  '左领尖绣字（顺边缘）': 'Left Collar Point (Edge)',
  '左驳头眼顺边绣': 'Left Lapel Buttonhole Edge Embroidery',
  '已付款': 'Paid',
  '已付金额': 'Paid Amount',
  '已发放': 'Issued',
  '已发货': 'Shipped',
  '已发货数量': 'Shipped',
  '已发货订单': 'Shipped Orders',
  '已发送': 'Sent',
  '已取消': 'Cancelled',
  '已完成': 'Completed',
  '已完成订单': 'Completed Orders',
  '已审核': 'Reviewed',
  '已提交': 'Submitted',
  '已提交订单': 'Submitted Orders',
  '已收货': 'Received',
  '已查看': 'Viewed',
  '已用额度': 'Used Credit',
  '已申请': 'Submitted',
  '已确认': 'Confirmed',
  '已签收': 'Received',
  '已读': 'Read',
  '已核对': 'Checked',
  '已作废': 'Voided',
  '已质检': 'Inspected',
  '已送达': 'Delivered',
  '已选择': 'Selected',
  '已采购': 'Purchased',
  '已驳回': 'Rejected',
  '已通过': 'Approved',
  'AI 建议': 'AI Suggestion',
  '常规': 'Standard',
  '常规加厚肩（垫肩 1.2cm + 有棉条）': 'Heavy Regular Shoulder (1.2cm pad + wadding)',
  '常规款': 'Standard',
  '常规纽扣': 'Standard Buttons',
  '常规肩（垫肩 0.8cm + 有棉条）': 'Regular Shoulder (0.8cm pad + wadding)',
  '常规薄肩（垫肩 0.5cm + 有棉条）': 'Light Padded Shoulder (0.5cm pad + wadding)',
  '常规超薄肩（垫肩 0.1cm + 有棉条）': 'Ultra Light Shoulder (0.1cm pad + wadding)',
  '常规里袋 + 一字笔袋': 'Standard Inside Pocket + Straight Pen Pocket',
  '常规里袋 + 一字笔袋 + 卡袋': 'Standard Inside Pocket + Straight Pen + Card Pocket',
  '常规里袋 + 水滴笔袋': 'Standard Inside Pocket + Teardrop Pen Pocket',
  '常规里袋 + 水滴笔袋 + 卡袋': 'Standard Inside Pocket + Teardrop Pen + Card Pocket',
  '常规里袋+一字笔袋': 'Standard Inner Pocket + Pen Pocket',
  '常规里袋+一字笔袋+卡袋': 'Standard Inner Pocket + Pen Pocket + Card Pocket',
  '常规里袋+水滴笔袋': 'Standard Inner Pocket + Teardrop Pen Pocket',
  '常规里袋+水滴笔袋+卡袋': 'Standard Inner Pocket + Teardrop Pen Pocket + Card Pocket',
  '幅宽(cm)': 'Width(cm)',
  '平台服务费': 'Service Fee',
  '平腰头+暗钩': 'Flat Waistband + Hook & Bar',
  '平腰头+锁眼钉扣': 'Flat Waistband + Button',
  '平袋盖（直角）': 'Straight Flap (Square)',
  '平角青果领': 'Square Shawl Lapel',
  '平驳领': 'Notch Lapel',
  '年度税后利润': 'Annual Net Profit (CNY)',
  '库存不足，请选择其他物料或联系客服。': 'Out of stock. Please choose another option or contact us.',
  '库存流水': 'Inventory Log',
  '库存管理': 'Inventory',
  '库存调整': 'Adjust Stock',
  '应付总金额': 'Total Due',
  '应发工资': 'Gross Salary',
  '度假系列': 'Resort',
  '开始生产前需支付50%定金。': 'A 50% deposit is required before production begins.',
  '异常': 'Abnormal',
  '异常冻结': 'On Hold',
  '异常订单': 'Exceptions',
  '弧形工字褶贴袋': 'Curved Box Pleat Patch Pocket',
  '弧形工字褶贴袋（桃型袋盖）': 'Curved Box Pleat Patch Pocket (Rounded Flap)',
  '弧形工字褶贴袋（直袋盖）': 'Curved Box Pleat Patch Pocket(Straight Flap)',
  '弧形戗驳领': 'Curved Peak Lapel',
  '弧形暗风琴褶贴袋': 'Curved Hidden Accordion Pleated Patch Pocket',
  '弧形暗风琴褶贴袋（桃型袋盖）': 'Curved Bellows Patch Pocket (Rounded Flap)',
  '弧形暗风琴褶贴袋（直袋盖）': 'Curved Bellows Patch Pocket (Straight Flap)',
  '弧形胸袋': 'Curved Chest Pocket',
  '弧形贴袋': 'Curved Patch Pocket',
  '弧形贴袋+ 右袋中袋': 'Curved Patch Pocket with Right Ticket Pocket',
  '弧形贴袋（时尚贴袋）': 'Curved Patch Pocket (Barchetta)',
  '弯挂面': 'Curved Facing',
  '当前在线门店': 'Stores Online',
  '当前库存': 'In Stock',
  '当前页面': 'Current Page',
  '录入失败': 'Save failed',
  '待付款': 'Unpaid',
  '待付金额': 'Unpaid Amount',
  '待初审': 'First Review',
  '待初审订单': 'First Review',
  '待办': 'To Do',
  '待发货': 'Pending Shipment',
  '待处理': 'Pending',
  '待处理售后': 'After Sales',
  '待复审': 'Second Review',
  '待复审订单': 'Second Review',
  '待审核': 'Pending',
  '待审核订单': 'Pending Review',
  '待审核订单总数': 'Pending Review',
  '待推送': 'Pending Push',
  '待推送订单': 'Pending Push',
  '待提交订单': 'Temp Orders',
  '待确认': 'Pending',
  '待确认付款': 'Pending Payments',
  '待终审': 'Pending Final Review',
  '待终审订单': 'Finance Review',
  '待财务审核': 'Finance Review',
  '待质检': 'Pending QC',
  '待采购': 'Pending Purchase',
  '待采购面料': 'Fabric Pending Purchase',
  '心型': 'Heart Shape Milanese',
  '忘记密码': 'Forgot Password',
  '快速搜索': 'Quick Search',
  '性别': 'Gender',
  '总肩宽': 'Shoulder Width',
  '您有未保存的更改，是否继续编辑？': 'You have unsaved changes. Leave without saving?',
  '意式圆形 1 扣': 'Italian Round 1-Button',
  '意式圆形 2 扣': 'Italian Round 2-Button',
  '意式直型 1 扣': 'Italian Straight 1-Button',
  '意式直型 2 扣': 'Italian Straight 2-Button',
  '意式长双宝剑头+锁眼钉扣': 'Italian Double Sword Extension + Button Fastening',
  '意式长圆头+锁眼钉扣': 'Italian Round Extension + Button Fastening',
  '意式长方头+锁眼钉扣': 'Italian Square Extension + Button Fastening',
  '成分': 'Composition',
  '成本分析': 'Cost Analysis',
  '成本明细': 'Cost details',
  '成本预警': 'Cost Alert',
  '成衣商城': 'Ready-to-Wear',
  '成衣尺寸': 'Finished',
  '审核成衣尺寸': 'Audit Finished Size',
  '我的客户': 'Clients',
  '我的物料': 'Materials',
  '我的订单': 'Orders',
  '我的设计专员': 'My Designer',
  '我的账号': 'Account',
  '所属门店': 'Store',
  '所有价格以美元（USD）计算，自报价日起30天内有效。': 'All prices are in USD and valid for 30 days from the date of quotation.',
  '所有服装均为量身定制，不接受退换。': 'All garments are made-to-measure and non-returnable.',
  '所有订单': 'All Orders',
  '所有订单管理': 'All Orders',
  '所选物料在当前工厂不可用。': 'This material isn\'t available at the selected factory.',
  '手动发送公告': 'Send Announcement',
  '手动同步状态': 'Sync Status',
  '手工同步状态': 'Manual Sync',
  '手工圆头锁眼': 'Handmade Function Buttonhole',
  '手工米兰眼不开刀': 'Handmade Non-function Milanese',
  '手工米兰眼开刀': 'Handmade Function Milanese',
  '手工调价': 'Adjust Price',
  '打印': 'Print',
  '扣减': 'Deduction',
  '扣款合计': 'Total Deduction',
  '批量价格表': 'Bulk Price List',
  '批量发送邮件': 'Email All',
  '批量导出': 'Batch Export',
  '批量打印面单': 'Batch Print Labels',
  '批量折扣': 'Bulk Discount',
  '批量操作': 'Bulk Actions',
  '投产工厂': 'Production Factory',
  '投诉与反馈': 'Complaints & Feedback',
  '投诉与反馈邮箱': 'Feedback Email',
  '折扣': 'Discount',
  'RTW批量折扣': 'RTW Bulk Discounts',
  '数量区间': 'Quantity Range',
  '折': 'Off',
  '手续费': 'Handling Fee',
  '转账手续费': 'Transfer Fee',
  '报价工具': 'Quote Tool',
  '报价总额（USD）': 'Grand Total (USD)',
  '报价日期': 'Quote Date',
  '报废': 'Scrap',
  '报表中心': 'Reports',
  '拖拽排序': 'Drag to reorder',
  '挂面款式': 'Facing Style',
  '按业务员': 'By Designer',
  '按件': 'Per Piece',
  '按功能分类': 'By Function',
  '按单': 'Per Order',
  '按周': 'By Week',
  '按图设计': 'Custom Design',
  '按图设计款': 'Custom Design',
  '按场合分类': 'By Occasion',
  '按天': 'By Day',
  '按字': 'Per Character',
  '按字母': 'Per Letter',
  '按季节分类': 'By Season',
  '按月': 'By Month',
  '按订单': 'Per Order',
  '按门店': 'By Store',
  '挺缝线压线 0.2cm': 'Front Line Topstitch 0.2cm',
  '挺胸体': 'Prominent Chest',
  '接口地址': 'API Endpoint',
  '接收角色': 'Recipient Roles',
  '推送': 'Push',
  '推送失败': 'Push Failed',
  '推送工厂': 'Push to Factory',
  '批量推送工厂': 'Batch Push to Factory',
  '批量生成采购单': 'Batch Generate Purchase Order',
  '条订单': 'order(s)',
  '面料明细预览': 'Fabric Detail Preview',
  '成功生成': 'Successfully generated',
  '条采购记录': 'purchase record(s)',
  '条订单生成失败': 'order(s) failed to generate',
  '只能推送待推送状态的订单': 'Only orders in "Pending Push" status can be pushed',
  '成功推送': 'Successfully pushed',
  '条订单到工厂': 'order(s) to factory',
  '条订单推送失败': 'order(s) failed to push',
  '确认推送': 'Confirm Push',
  '选择工厂': 'Select Factory',
  '推送成功': 'Push Successful',
  '提交': 'Submit',
  '提交订单': 'Place Order',
  '提成合计': 'Total Commission',
  '提成明细': 'Commission Details',
  '提成规则配置': 'Commission Rules',
  '提成金额': 'Commission Amount',
  '提示：如果是数据库表不存在等后端错误，请检查后端服务是否已正确初始化数据库。': 'Tip: If it is a backend error such as a missing database table, please check if the backend service has correctly initialized the database.',
  '搜索': 'Search',
  '搜索编号 / 颜色': 'Search Fabric/Color',
  '摆围': 'Hem',
  '撞色设计': 'Contrast Design',
  '撞色面料': 'Contrast Fabric',
  '操作': 'Actions',
  '操作人': 'Operator',
  '操作内容': 'Action',
  '操作失败': 'Something went wrong',
  '操作成功': 'Done',
  '操作日志': 'Operation Logs',
  '操作时间': 'Time',
  '支纱': 'Yarn Count',
  '收支明细': 'Transaction Details',
  '收货单': 'Receiving Note',
  '收货地点': 'Ship To',
  '收货管理': 'Receiving',
  '收费系列': 'Charged Lining',
  '放松量': 'Fit Allowance',
  '数据看板': 'Dashboard',
  '数量': 'Quantity',
  '整个袖口撞色': 'Full Cuffs Contrast',
  '整个领子和袖口撞色': 'Full Collar + Cuffs Contrast',
  '整个领子撞色': 'Full Collar Contrast',
  '文字': 'Text',
  '料卡': 'Fabric Books',
  '斜双开线口袋': 'Slanted Double Besom Pocket',
  '斜插袋': 'Slanted Pocket',
  '斜袋': 'Slant Pocket',
  '斜袋：单线袋': 'Slanted+  Single Besom',
  '斜袋：双线大袋（有袋盖）+一字票袋（无袋盖）': 'Slanted: Flapped Double Besom + Welt Ticket Pocket',
  '斜袋：双线大袋（有袋盖）+双线票袋（无袋盖）': 'Slanted: Flapped Double Besom + Double Besom Ticket (No Flap)',
  '斜袋：双线大袋（有袋盖）+双线票袋（有袋盖）': 'Slanted+ Flapped Double Besom + Ticket Pocket (Flap)',
  '斜袋：双线大袋（直角袋盖）+双线票袋（直角袋盖）': 'Slanted: Double Besom (Square Flap) + Double Besom Ticket (Square Flap)',
  '斜袋：双线袋+小圆直袋盖': 'Slanted + Double Besom + Small Round Flap',
  '斜袋：双线袋无袋盖': 'Slanted+ Double Besom without Flap',
  '斜袋：双线袋（无盖）+双线票袋（无盖）': 'Slanted: Double Besom (No Flap) + Double Besom Ticket (No Flap)',
  '斜袋：平袋盖（直角）': 'Slanted: Flat Flap (Square)',
  '斜角青果领': 'Angled Shawl Lapel',
  '斜里襟+内小圆头裤袢': 'French Bearer + Small Round Inner Tab',
  '斜里襟+内小宝剑头裤袢': 'French Bearer + Small Sword Inner Tab',
  '斜里襟+内小方头裤袢': 'French Bearer + Small Square Inner Tab',
  '断货': 'Out of Stock',
  '新品上架': 'New Arrivals',
  '新增付款记录': 'Add Payment',
  '新增客户': 'Add Client',
  '新增尺寸': 'Add Measurement',
  '新增返修单': 'New Alteration',
  '新建订单': 'New Order',
  '新款发布': 'New Arrivals',
  '新金额': 'New Amount',
  '无': 'None',
  '无刺绣': 'No Embroidery',
  '无叉': 'No Vent',
  '无口袋': 'No Pockets',
  '无开口': 'No Opening',
  '无开衩': 'No Vent',
  '无弧度戗驳领（JD 直戗驳领）': 'Straight Peak Lapel',
  '无挺缝线': 'No Crease',
  '无插片': 'No Collar Stays',
  '无数据': 'No data',
  '无标': 'No Label',
  '无款式配置': 'No style config',
  '无省': 'No Darts',
  '无结构无胸衬': 'Unstructured',
  '无背带扣': 'No Suspender Buttons',
  '无胸袋': 'No Chest Pocket',
  '无胸袋+下单开线袋': 'No Chest Pocket + Single Besom Lower',
  '无胸袋+下双开线袋': 'No Chest Pocket + Double Besom Lower',
  '无胸袋+下贴袋': 'No Chest Pocket + Patch Lower',
  '无腰带': 'No Back Belt',
  '无腰设计': 'No Waistband',
  '无色丁': 'No Satin',
  '无表袋': 'No Watch Pocket',
  '无衬': 'No Interlining',
  '无袋': 'No Pocket',
  '无袋盖': 'No Flap',
  '无袖叉': 'No Vent',
  '无裤袢': 'No Belt Loops',
  '无褶': 'Flat Front',
  '无褶双省': 'No Pleats + Double Darts',
  '无褶无褶': 'No Pleats',
  '无贡针': 'No Pick Stitch',
  '无里布': 'Unlined',
  '无锁眼无纽扣': 'No Buttonhole, No Button',
  '无驳头眼': 'No Lapel Buttonhole',
  '日常通知': 'General Notifications',
  '日志管理': 'Logs',
  '时尚档': 'STYLISH',
  '时尚档（高）': 'STYLISH (High)',
  '时间/维度': 'Time / Dimension',
  '明门襟 3.5cm': 'Standard Placket 3.5cm',
  '明门襟 3cm': 'Standard Placket 3cm',
  '春秋': 'Spring/Autumn',
  '是否余料': 'Leftover Fabric',
  '是否加急': 'Rush',
  '加急状态': 'Rush Status',
  '显示 / 隐藏': 'Show / Hide',
  '普通': 'Normal',
  '普通工字褶贴袋': 'Standard Box Pleat Patch Pocket',
  '普通工字褶贴袋（桃型袋盖）': 'Standard Box Pleat Patch Pocket (Rounded Flap)',
  '普通工字褶贴袋（直袋盖）': 'Standard Box Pleat Patch Pocket(Straight Flap)',
  '普通暗风琴褶贴袋': 'Standard Hidden Accordion Pleated Patch Pocket',
  '普通暗风琴褶贴袋（桃型袋盖）': 'Standard Bellows Patch Pocket (Rounded Flap)',
  '普通暗风琴褶贴袋（直袋盖）': 'Standard Bellows Patch Pocket (Straight Flap)',
  '普通贴袋': 'Standard Patch Pocket',
  '普通贴袋+右袋中袋': 'Patch Pocket with Right Ticket Pocket',
  '暂存': 'Temp Save',
  '暂存单数量': 'Temp Orders',
  '暂存订单': 'Save Draft',
  '暂无付款记录': 'No payment records',
  '暂无发票记录': 'No invoice records',
  '暂无同步记录': 'No sync records',
  '暂无售后记录': 'No after-sales records',
  '暂无在线门店': 'No online stores',
  '暂无客户，点击 “新增客户” 创建。': 'No clients yet. Add your first client.',
  '暂无数据': 'No data',
  '暂无订单': 'No orders',
  '暂无订单，点击 “创建新订单” 开始。': 'No orders yet. Start by creating a new order.',
  '暂无通知': 'No notifications',
  '暗门襟 3.5cm': 'Hidden Placket 3.5cm',
  '暗门襟 3cm': 'Hidden Placket 3cm',
  '更多': 'More',
  '更多设计': 'More Options',
  '更新失败': 'Update failed',
  '更新订单': 'Update Order',
  '最新面料': 'New Fabrics',
  '最近下单日期': 'Last Order',
  '最近订单': 'Recent Orders',
  '月份': 'Period',
  '月处理订单量': 'Monthly Admin Order Count',
  '月牙袋+右双线零钱袋': 'Curved Denim Pocket + Right Double Welt Coin Pocket',
  '月牙袋+右零钱贴袋': 'Curved Denim Pocket  + Right Coin Patch Pocket',
  '月负责订单金额': 'Monthly Tracked Order Amount',
  '月销售额': 'Monthly Sales',
  '有效期至': 'Valid Until',
  '长期有效': 'Long-term Valid',
  '有背带扣': 'With Suspender Buttons',
  '有货': 'In Stock',
  '服务暂时不可用，请稍后重试。': 'We\'re having some trouble. Please try again later.',
  '服务项目': 'Service',
  '未付款': 'Unpaid',
  '未付款提醒': 'Unpaid Reminder',
  '未分配': 'Unassigned',
  '未发送': 'Not Sent',
  '未找到结果，请尝试其他关键词。': 'No matches found. Try a different search term.',
  '未来之星': 'Future Star',
  '未知': 'Unknown',
  '未读': 'Unread',
  '未核对': 'Unchecked',
  '本人团单销售额': 'Personal RTW Sales',
  '本人定制单销售额': 'Personal MTM Sales',
  '本人权重点数': 'Personal Weight',
  '本布光样': '2nd Finished Basted Fitting',
  '本布光样手工': 'Handmade Finished Basted Fitting',
  '本布手工毛样': 'Handmade Basted Fitting',
  '本布毛样': 'Basted Fitting',
  '本月新单': 'New This Month',
  '本期余额': 'Current Balance',
  '机器假眼不开刀': 'Machine Non-function Buttonhole',
  '机器假眼开刀': 'Machine Function Buttonhole',
  '机器圆头锁眼不开刀': 'Machine Non-function Rounded Buttonhole',
  '机器圆头锁眼开刀': 'Machine Function Rounded Buttonhole',
  '权限': 'Permissions',
  '权限分配': 'Permissions',
  '条': 'items',
  '条款与条件': 'Terms & Conditions',
  '来图设计': 'Custom Design',
  '来料加工': 'Customer\'s Own Material (CMT)',
  '来料加工 (CMT)': 'Cut-Make-Trim (CMT)',
  '来料加工价格': 'CMT Price',
  '来料加工价格表': 'CMT Price List',
  '查看': 'View',
  '查看全部通知': 'View all',
  '查看发票': 'View Invoice',
  '查看合并发票': 'View Combined Invoice',
  '查看订单': 'View Orders',
  '查看详情': 'View',
  '标准价格表': 'Standard Price List',
  '标准体': 'Standard',
  '标准八字领': 'Classic Spread Collar',
  '标准圆角': 'Standard Round',
  '标准工艺': 'Standard',
  '标准腰带': 'Standard Back Belt',
  '标准贡针': 'Standard Pick Stitch',
  '标准（14 天）': 'Standard (14 days)',
  '标签搜索': 'Tags',
  '标记异常': 'Flag Issue',
  '标题': 'Title',
  '样本册': 'Sample Book',
  '核对并提交': 'Review & Submit',
  '档位面料价（USD/m）': 'Grade Price (USD/m)',
  '检索标签': 'Search Tags',
  '款号': 'Style No.',
  '款式名称': 'Style Name',
  '款式配置': 'Style Config',
  '款式配置汇总': 'Style Summary',
  '款式风格': 'Style',
  '正常': 'Regular',
  '正常腰头': 'Standard Waistband',
  '正式': 'Formal',
  '正面图': 'Front',
  '此字段为必填项。': 'This field is required.',
  '每件': 'Per Item',
  '每单': 'Per Order',
  '每字': 'Per Letter',
  '毛利': 'Gross Profit',
  '毛利率': 'Gross Margin',
  '毛边 10cm': 'Unfinished Hem (10cm extra)',
  '毛边 7cm': 'Unfinished Hem (7cm extra)',
  '汇款': 'Transfer',
  '汗贴造型': 'Dress Shield',
  '沟通': 'Communication',
  '沟通态度': 'Communication',
  '法式切角': 'French Angled',
  '法式圆角': 'French Rounded',
  '法式斜里襟': 'French Bearer',
  '法式直角': 'French Square',
  '注册时间': 'Registered Date',
  '活动系列': 'Events',
  '活跃': 'Active',
  '测试连接': 'Test Connection',
  '海鸥型': 'Seagull Shape Milanese',
  '消息中心': 'Messages',
  '消息评论': 'Comments',
  '消费': 'Purchase',
  '消费者管理': 'Consumers',
  '消费金额': 'Amount Spent',
  '添加体型特征': 'Add Profile',
  '清除缓存': 'Clear Cache',
  '温莎领（内弧）': 'Windsor Collar',
  '灰色里布': 'Grey Lining',
  '灰色防滑腰里': 'Grey Anti-slip',
  '烟斗型': 'Pipe Shape Milanese',
  '熨烫挺缝线': 'Pressed Crease',
  '版型': 'Pattern Making',
  '版型 / 款式库': 'Style Library',
  '版型/款式库': 'Style Library',
  '版型参数': 'Pattern Parameters',
  '物料供应商': 'Material Suppliers',
  '物料分类': 'Material Type',
  '物料寄出管理': 'Materials Shipped',
  '物料明细': 'Items',
  '物料管理': 'Material Management',
  '物料编号': 'Material Code',
  '物流公司': 'Shipping Company',
  '物流单号': 'Tracking #',
  '物流单号格式错误。': 'Tracking number format is incorrect.',
  '物流方式': 'Shipping Method',
  '物流费': 'Shipping',
  '物流轨迹': 'Tracking History',
  '特急（5 天）': 'Express (5 days)',
  '特殊纽扣': 'Special Buttons',
  '特殊设计': 'Special Design',
  '特殊设计费': 'Special Design',
  '额外面料费': 'Extra Fabric',
  '特殊里衬': 'Special Lining',
  '状态': 'Status',
  '状态变更': 'Status Change',
  '状态变更时间线': 'Status Timeline',
  '状态同步记录': 'Sync Records',
  '状态映射': 'Status Mapping',
  '现款设计': 'Ready-made Design',
  '现金': 'Cash',
  '生产中': 'Producing',
  '推送中': 'Pushing to Factory',
  '生产中数量': 'In Production',
  '生产中订单': 'In Production',
  '生产中订单总数': 'In Production',
  '生成发票': 'Generate Invoice',
  '批量复制': 'Batch Copy',
  '批量复制订单': 'Batch Copy Orders',
  '确认复制': 'Confirm Copy',
  '将把选中的': 'Will copy the selected',
  '个订单复制成新的草稿订单（订单号与出货期重新生成，其余信息完整复制）。完成后可在全部订单列表中逐单检查或编辑。是否继续？': 'order(s) into new draft orders (order no. and delivery date are regenerated; all other information is copied in full). Afterwards you can review or edit each one in the order list. Continue?',
  '个订单，均为草稿状态': 'order(s), all in draft status',
  '批量复制完成（部分失败）': 'Batch copy finished (partially failed)',
  '生成报价单': 'Generate Quotation',
  '用户': 'User',
  '用户名': 'Username',
  '用户名或密码错误。': 'Login failed. Please check your email and password.',
  '用户管理': 'Users',
  '申请售后': 'Request After-sales',
  '申请折扣率': 'Requested Discount Rate',
  '申请时间': 'Requested At',
  '电子邮件': 'Email',
  '电话': 'Phone',
  '男': 'Male',
  '男女': 'Unisex',
  '界面风格配置': 'Theme Config',
  '登出': 'Sign Out',
  '登录': 'Sign In',
  '登录失败': 'Sign in failed',
  '登录成功': 'Sign in successful',
  '门店账号不能登录管理后台': 'Store account cannot access the admin portal',
  '白色无防滑腰里': 'White Standard',
  '白色里布': 'White Lining',
  '白色防滑腰里': 'White Anti-slip',
  '皮鞋': 'Shoes',
  '盘亏': 'Stock Out',
  '盘盈': 'Stock In',
  '目标工厂': 'Target Factory',
  '直下摆': 'Straight Hem',
  '直属上级': 'Direct Supervisor',
  '直开口': 'Straight Opening',
  '直开口+手工套结': 'Straight Opening + Hand Bartack',
  '直挂面': 'Straight Facing',
  '直挂面 + 小宝剑头': 'Straight Facing + Small Sword',
  '直挂面+小宝剑头': 'Simple Straight Facing + Small Sword Tip',
  '直摆': 'Straight Hem',
  '直摆+五角布贴': 'Straight Hem + Pentagon Gusset',
  '直袋': 'Straight Pocket',
  '直角 1 眼 2 扣': 'Square 1-Buttonhole 2-Buttons',
  '直角 2 眼 2 扣': 'Square 2-Buttonholes 2-Buttons',
  '直角两用': 'Square Convertible Cuff',
  '直角立体贴袋 + 桃型袋盖': '3D Patch Pocket (Curvedflap)',
  '直角立体贴袋 + 直袋盖': '3D Patch Pocket (Straight flap)',
  '直角立体贴袋+桃型袋盖': 'Square 3D Patch Pocket + Rounded Flap',
  '直角立体贴袋+直袋盖': 'Square 3D Patch Pocket + Straight Flap',
  '直贴布中褶': 'Straight Placket – Medium Tuck',
  '直贴布大褶': 'Straight Placket – Large Tuck',
  '直贴布小褶（塔克）': 'Straight Placket – Small Tuck',
  '直门襟': 'Straight Fly',
  '真实姓名': 'Real Name',
  '真袖叉': 'Working Vent',
  '真袖叉圆弧翻边（4.5cm）': 'Functional Vent + Functional Buttonhole + Curved Turn-up 4.5cm',
  '真袖叉圆弧翻边（7.5cm）': 'Functional Vent + Functional Buttonhole + Curved Turn-up 7.5cm',
  '真袖叉直翻边（4.5cm）': 'Functional Vent + Functional Buttonhole + Straight Turn-up 4.5cm',
  '真袖叉直翻边（7.5cm）': 'Functional Vent + Functional Buttonhole + Straight Turn-up 7.5cm',
  '短款': 'Short',
  '短袖': 'Short Sleeve',
  '短袖假翻边': 'Short Sleeve with Mock Turn-up',
  '短袖内折边': 'Short Sleeve with Turned Hem',
  '码标订后复势': 'Size Label on Back Yoke',
  '硬衬': 'Hard Interlining',
  '确定删除该记录吗？此操作不可撤销。': 'Deleting... This action cannot be undone.',
  '确认': 'Confirm',
  '确认到账': 'Confirm Receipt',
  '确认取消订单？': 'Confirm cancel order?',
  '确认取消该订单？取消后无法恢复。': 'Confirm cancellation? This cannot be reversed.',
  '确认提交': 'Place Order',
  '确认提成': 'Confirm Commission',
  '确认收货': 'Confirm Received',
  '确认收货？此操作不可撤销。': 'Confirm receipt? This action cannot be undone.',
  '确认订单': 'Confirm Order',
  '确认订单后，生产周期为4–6周。': 'Production lead time is 4–6 weeks after order confirmation.',
  '磅': 'lb',
  '礼服系列': 'Formal Wear',
  '礼服门襟 3.5cm（4 个 STUDS）': 'Dress Placket 3.5cm (4 Studs)',
  '礼服门襟 3.5cm（所有都是 STUDS）': 'Dress Placket 3.5cm (All Studs)',
  '礼服门襟 3cm（4 个 STUDS）': 'Dress Placket 3cm (4 Studs)',
  '礼服门襟 3cm（所有都是 STUDS）': 'Dress Placket 3cm (All Studs)',
  '礼服领': 'Wing Collar',
  '社会保险': 'Social Insurance',
  '禁忌 / 特殊要求': 'Special Requests',
  '禁用': 'Disabled',
  '穿着风格偏好': 'Style Preference',
  '筛选': 'Filter',
  '米数': 'Meters',
  '粘合衬厚胸衬': 'Fused (Firm)',
  '粘合衬薄胸衬': 'Fused (Soft)',
  '粘衬': 'Fused / Glued',
  '精准算料': 'Calculate',
  '系列': 'Series',
  '系统': 'System',
  '系统发生错误': 'System Error',
  '系统图片': 'System Image',
  '系统更新': 'System Updates',
  '系统消息': 'Notifications',
  '管理系统消息通知及公告发布': 'Manage system messages and announcements',
  '消息发送成功': 'Message sent successfully',
  '消息详情': 'Message Detail',
  '消息列表': 'Messages',
  '消息统计': 'Statistics',
  '消息统计概览': 'Message Statistics',
  '消息类型': 'Type',
  '发送': 'Send',
  '发送公告': 'Send Announcement',
  '发送对象': 'Target',
  '封面': 'Cover',
  '设为封面': 'Set as cover',
  '无季节': 'No season',
  '点缩略图右上角星标可指定该页作为样本册封面，默认第1页': 'Click the star icon on a thumbnail to set that page as the sample book cover (page 1 by default)',
  '正文图片': 'Body Images',
  '添加图片': 'Add Image',
  '上传封面': 'Upload Cover',
  '替换封面': 'Replace Cover',
  '上传成功': 'Uploaded',
  '用户 ID': 'User ID',
  '请输入门店 ID': 'Store ID',
  '请输入用户 ID': 'User ID',
  '请输入公告标题': 'Announcement title',
  '请输入公告内容': 'Announcement content',
  '全部标记为已读': 'Mark all as read',
  '标记全部已读': 'Mark all read',
  '加载中': 'Loading',
  '全部用户': 'All users',
  '指定用户': 'Specific user',
  '待办消息': 'To-do',
  '告警消息': 'Alerts',
  '未读消息': 'Unread',
  '目标': 'Target',
  '系统设置': 'Settings',
  '系统面料': 'In Stock',
  '紧急': 'Urgent',
  '紧身': 'Tight',
  '累计消费金额': 'Total Spent',
  '累计订单': 'Total Orders',
  '纽扣': 'Buttons',
  '线号': 'Thread',
  '组件堆栈详情（开发人员查看）': 'Component Stack Details (Developer View)',
  '织法/特征': 'Weave',
  '终端消费者': 'End Consumers',
  '经典尖领': 'Classic Point Collar',
  '经典戗驳领': 'Classic Peak Lapel',
  '结果': 'Result',
  '结算': 'Checkout',
  '绩效': 'Performance Bonus',
  '编辑': 'Edit',
  '编辑价格体系': 'Edit Pricing',
  '网络错误': 'Network error',
  '网络错误，请检查连接后重试。': 'Connection lost. Please check your network.',
  '羊毛系列': 'Wool',
  '美元金额': '$X,XXX.XX',
  '考勤扣款': 'Attendance Deduction',
  '考核指标': 'KPI',
  '耸肩袖（标配垫肩 + 有棉条）': 'Roped Shoulder (Standard padded)',
  '联系人': 'Contact',
  '联系电话': 'Contact Phone',
  '肚围': 'Large Belly',
  '股东分红比例': 'Shareholder Dividend Ratio',
  '肥大': 'Loose',
  '肩型': 'Shoulder',
  '肩宽': 'Shoulder Width',
  '背带扣': 'Suspender Buttons',
  '背面图': 'Back',
  '胸围': 'Chest',
  '胸袋上刺绣': 'Chest Pocket Embroidery',
  '脚口': 'Hem',
  '脚口型': 'Bottom Style',
  '腰围': 'Waist',
  '腰面+侧缝顺色哑光色丁 1.5cm': 'Waistband + Side Matching Matte Satin 1.5cm',
  '腰面+侧缝顺色哑光色丁 2.5cm': 'Waistband + Side Matching Matte Satin 2.5cm',
  '腰面+侧缝黑色哑光色丁 1.5cm': 'Waistband + Side Black Matte Satin 1.5cm',
  '腰面+侧缝黑色哑光色丁 2.5cm': 'Waistband + Side Black Matte Satin 2.5cm',
  '腰面顺色哑光色丁': 'Waistband Matching Matte Satin',
  '腰面黑色哑光色丁': 'Waistband Black Matte Satin',
  '腿根围': 'Thigh',
  '膝围': 'Knee',
  '膝盖围': 'Knee',
  '臀围': 'Hips',
  '自动调整刺绣高度': 'Auto Height',
  '节节高升': 'Rising Success',
  '英尺': 'ft/in',
  '英文': 'English',
  '草稿': 'Draft',
  '获取订单数据失败': 'Failed to fetch order data',
  '藏青里布': 'Navy Lining',
  '行政人员': 'Admin Staff',
  '行政提成（元/单）': 'Admin Commission (CNY/order)',
  '表袋设计': 'Watch Pocket Design',
  '衬衫': 'Dress Shirt',
  '衬衫下摆造型': 'Shirt Hem Style',
  '衬衫其它设计': 'Other Shirt Options',
  '衬衫刺绣位置': 'Shirt Embroidery Placement',
  '衬衫商标': 'Shirt Label',
  '衬衫撞色': 'Shirt Contrast',
  '衬衫胸袋设计': 'Shirt Chest Pocket',
  '衬衫袖口设计': 'Shirt Cuff Style',
  '衬衫设计': 'Shirt Design',
  '衬衫门襟设计': 'Shirt Placket',
  '袖口': 'Cuff',
  '袖口款式': 'Cuff Style',
  '袖口钉扣线': 'Cuff Button Thread',
  '袖口锁眼线': 'Cuff BH Thread',
  '袖口高度': 'Cuff Height',
  '袖型': 'Sleeve Type',
  '袖笼合缝': 'Sleeve Attachment',
  '袖肥': 'Biceps',
  '袖里': 'Sleeve Lining',
  '袖长': 'Sleeve Length',
  '裤侧缝贡针': 'Side Seam Pick Stitch',
  '裤侧袋': 'Side Pockets',
  '裤内长': 'Inseam',
  '裤后口袋': 'Back Pockets',
  '裤子刺绣位置': 'Trouser Embroidery Placement',
  '裤子撞色部位': 'Trouser Contrast Placement',
  '裤子款式习惯': 'Trousers Style Habit',
  '裤子订扣线': 'Trouser Button Thread',
  '裤子订标位置': 'Trouser Label Placement',
  '裤子贡针': 'Trouser Pick Stitch',
  '裤子锁眼线': 'Trouser Buttonhole Thread',
  '裤脚': 'Pant Hem',
  '裤腰头': 'Waistband Front',
  '裤腰里': 'Waistband Lining',
  '裤腰面': 'Waistband Facing',
  '裤腰高': 'Waistband Height',
  '裤褶': 'Pleats',
  '裤调节袢': 'Belt Loops',
  '裤里位置': 'Lining Placement',
  '裤里布': 'Trouser Lining',
  '裤长': 'Pant Length',
  '裤门襟': 'Fly',
  '西装上衣': 'Jacket',
  '西裤': 'Trousers',
  '西裤 + 马甲': 'Trousers + Vent',
  '要求交期': 'Requested Date',
  '规格': 'Specification',
  '角色管理': 'Roles',
  '警戒库存': 'Minimum',
  '计算公式': 'Formula',
  '计算失败': 'Calculation failed',
  '计费单位': 'Unit',
  '计费方式': 'Charge Type',
  '订单不存在或已删除': 'Order not found or deleted',
  '订单中心': 'Orders',
  '订单价格表': 'Order Price List',
  '订单创建成功': 'Order created successfully',
  '订单取消': 'Order Cancelled',
  '订单号': 'Order No',
  '订单总额': 'Total Amount',
  '订单报表': 'Order Report',
  '订单提交失败，请稍后重试。': 'Something went wrong. Please try again.',
  '订单数量': 'Quantity',
  '订单流水': 'Transaction History',
  '订单消耗': 'Used in Order',
  '订单状态': 'Order Status',
  '订单确认': 'Review & Place',
  '订单记录': 'Order History',
  '订单详情': 'Order Detail',
  '订单详情时间': 'MM/DD/YYYY, h:mm A',
  '订单金额': 'Amount',
  '订单需求': 'For Order',
  '订单面料': 'Fabric',
  '订单驳回': 'Order Rejected',
  '订标位置': 'Label Placement',
  '订标线': 'Label Thread',
  '订标线颜色': 'Label Thread Color',
  '让步接收': 'Concession',
  '记录时间': 'Recorded At',
  '设为常用': 'Set as Default',
  '设计师评分': 'Rate My Designer',
  '设计风格': 'Design Style',
  '试身要求': 'Fitting Type',
  '试身尺寸': 'Trial Fitting Size',
  '试身费': 'Fitting Fee',
  '该操作当前订单状态不允许。': 'This action isn\'t available right now.',
  '语言': 'Language',
  '语言配置': 'Language Config',
  '请仔细核对订单信息，提交后将进入审核流程': 'Please review carefully. Order will enter review flow after submission.',
  '请假扣款': 'Leave Deduction',
  '请填写驳回原因。': 'Please provide a reason for rejection.',
  '请求失败，请稍后重试': 'Request failed, please try again later',
  '请确认所有信息后再提交。': 'Please review all details before placing your order.',
  '请输入凭证或参考号': 'Please enter reference number',
  '请输入密码': 'Please enter password',
  '请输入新金额': 'Please enter new amount',
  '请输入用户名': 'Please enter username',
  '请输入调价原因': 'Please enter reason',
  '请输入驳回原因': 'Please enter reject reason',
  '请选择一个订单复制。': 'Select an order to duplicate.',
  '请选择付款方式': 'Select payment method',
  '请选择目标工厂': 'Select target factory',
  '请选择门店': 'Select store',
  '调价原因': 'Reason',
  '调价金额不能大于订单总额。': 'Adjustment cannot exceed order total.',
  '调整原因': 'Reason',
  '调整失败': 'Adjustment failed',
  '调整记录': 'Adjustment History',
  '调整额度': 'Adjust Limit',
  '负责门店': 'Assigned Stores',
  '贡针位置': 'Pick Stitch Placement',
  '贡针针宽': 'Pick Stitch Width',
  '财务审核通过': 'Finance Review Passed',
  '财务待确认': 'Pending Finance',
  '财务管理': 'Finance',
  '账单管理': 'Bills',
  '账号余额': 'Balance',
  '账号余额明细': 'Balance Details',
  '账号已锁定，请 1 小时后重试。': 'Too many failed attempts. Please try again in 1 hour.',
  '账户余额': 'Account Balance',
  '货期': 'Lead Time',
  '质检员': 'Inspector',
  '质检管理': 'QC',
  '质检记录录入成功': 'QC record saved',
  '质检通过': 'QC Passed',
  '购买记录': 'Purchase History',
  '购物车': 'Cart',
  '超时提醒': 'Timeout Alert',
  '超时时间': 'Timeout (s)',
  '跟单员': 'Order Tracker',
  '跟单提成率': 'Tracker Commission Rate',
  '身高': 'Height',
  '身高超出正常范围，请检查修改。': 'Height seems unusual. Please double-check.',
  '转移原因': 'Transfer Reason',
  '转移工厂': 'Transfer Factory',
  '软衬': 'Soft Interlining',
  '辅料': 'Accessory',
  '辅料编号/里布/纽扣': 'Accessory No./Lining/Button',
  '辅料采购标记': 'Accessory Purchase Mark',
  '辅料采购备注': 'Accessory Purchase Remark',
  '标记不可延期的出货期': 'Mark Non-deferrable Delivery Date',
  '保存标记': 'Save Mark',
  '已采': 'Purchased',
  '待采': 'To Purchase',
  '不可延期': 'Non-deferrable',
  '暂无备注': 'No remark',
  '请输入辅料采购备注（里布/纽扣等）': 'Enter accessory purchase remark (lining/button etc.)',
  '选择出货期': 'Select delivery date',
  '已标记不可延期': 'Marked as non-deferrable',
  '辅料采购标记已保存': 'Accessory purchase mark saved',
  '缺少订单ID': 'Missing order ID',
  '已标记为已采购': 'Marked as purchased',
  '输入量体数据': 'Enter measurements',
  '运费': 'Shipping Cost',
  '运输中': 'In Transit',
  '运输要求': 'Shipping Method',
  '返修': 'Repair',
  '返修中': 'Repairing',
  '返修内容': 'Issue Description',
  '返修出货期': 'Expected Return Date',
  '返修单数量': 'Alterations',
  '返修完成': 'Repaired',
  '返修订单': 'Alteration Orders',
  '返回': 'Go Back',
  '返回上一步': 'Previous Step',
  '返回修改': 'Back to Edit',
  '返回订单列表': 'Back to orders',
  '返回首页': 'Back to Home',
  '返工': 'Rework',
  '返现': 'Cashback',
  '违规项数': 'Violation Count',
  '退出全屏': 'Exit Fullscreen',
  '退出登录': 'Sign Out',
  '退款': 'Refund',
  '选择款式': 'Select Style',
  '通底贴布中褶': 'Full-length Placket – Medium Tuck',
  '通底贴布大褶': 'Full-length Placket – Large Tuck',
  '通底贴布小褶（塔克）': 'Full-length Placket – Small Tuck',
  '通底贴布无褶': 'Full-length Placket – No Tuck',
  '通档': 'Crotch',
  '通用模版配置': 'Templates',
  '通知中心': 'Notifications',
  '通过': 'Pass',
  '那不勒斯肩（垫肩 0.1cm + 单层棉条 + 小碎褶）': 'Neapolitan (0.1cm pad, light pleats)',
  '那不勒斯肩（无垫肩 + 无棉条 + 小碎褶）': 'Neapolitan (No padding, light pleats)',
  '邮箱': 'Email',
  '邮编': 'ZIP',
  '部位': 'Body Part',
  '部分付款': 'Partially Paid',
  '部分付款记录': 'Partial Payments',
  '部分发货': 'Partially Shipped',
  '部分退款': 'Partial Refund',
  '配饰': 'Accessories',
  '采购入库': 'Material Received',
  '采购单号': 'PO #',
  '采购单状态': 'PO Status',
  '采购申请': 'Purchase Apply',
  '采购申请提交成功。': 'Request submitted.',
  '采购目的': 'Purpose',
  '采购管理': 'Purchase',
  '采购类型': 'Material Type',
  '采购记录': 'Purchase Orders',
  '里布': 'Lining',
  '里布材质': 'Lining',
  '里袋撞色': 'Inner Pocket Contrast',
  '里门襟竖向刺绣': 'Inner Fly Vertical Embroidery',
  '重新推送': 'Retry Push',
  '重置': 'Clear',
  '重置筛选': 'Reset Filter',
  '重试': 'Retry',
  '重试次数': 'Retry Count',
  '量体人': 'Measured By',
  '量体定制': 'Made-to-Measure (MTM)',
  '量体定制 (MTM)': 'Made-to-Measure (MTM)',
  '量体尺寸': 'Measurements',
  '量体日期': 'Measured On',
  '金属裤钩': 'Metal Hook & Bar',
  '金额': 'Amount',
  '金额汇总': 'Amount Summary',
  '银行转账': 'Wire Transfer',
  '销售业绩统计': 'Sales Performance',
  '销售价格体系配置': 'Price System',
  '销售价格表': 'Sales Price List',
  '销售价（USD）': 'Sale Price (USD)',
  '销售报表': 'Sales Report',
  '错缝上袖': 'Offset Set-in Sleeve',
  '错误信息：': 'Error Info:',
  '长圆头廓尔格腰头（单向）': 'Long Round Gurkha Extension (Single-side)',
  '长圆头拉廓尔格腰头（双向）': 'Long Round Gurkha Extension (Both-sides)',
  '长小圆头廓尔格腰头（单向）': 'Long Small Round Gurkha Extension (Single-side)',
  '长小圆头拉廓尔格腰头（双向）': 'Long Small Round Gurkha Extension (Both-sides)',
  '长款': 'Long',
  '长袖': 'Long Sleeve',
  '长青系列': 'Evergreen',
  '门幅': 'Width',
  '门店': 'Store',
  '门店 ID': 'Store ID',
  '门店信息': 'Store Info',
  '门店列表': 'Store List',
  '门店名称': 'Store Name',
  '门店对账单': 'Store Bills',
  '门店管理': 'Stores',
  '门店编号': 'Store Code',
  '门店订单管理系统': 'Order Management',
  '门店详情': 'Store Detail',
  '备忘录': 'Memo',
  '新增备忘': 'Add Memo',
  '备忘类别': 'Memo Category',
  '备忘主题': 'Memo Subject',
  '备忘内容': 'Memo Content',
  '记录日期': 'Record Date',
  '暂无备忘记录': 'No memo records',
  '无主题': 'No subject',
  '请选择备忘类别': 'Please select category',
  '请输入备忘主题': 'Please enter memo subject',
  '请输入备忘内容': 'Please enter memo content',
  '请输入主题': 'Please enter subject',
  '请输入内容': 'Please enter content',
  '请输入回访记录、寄出物品记录等内容': 'Enter follow-up notes, shipped items, etc.',
  '请选择记录日期': 'Please select record date',
  '最多上传20张图片，单张不超过10MB': 'Up to 20 images, max 10MB each',
  '专业度': 'Professionalism',
  '融洽度': 'Rapport',
  '回款率': 'Payment Collection',
  '回到页头': 'Back to Top',
  '订单信息': 'Order Info',
  '面辅料': 'Fabric & Trim',
  '不良信息': 'Issue Info',
  '其它备注': 'Other Notes',
  '门襟+袋侧缝+裤侧缝贡针': 'Fly + Pocket + Side Seam Pick Stitch',
  '门襟+袋侧缝贡针': 'Fly + Pocket Side Pick Stitch',
  '门襟扣数': 'Front Buttons',
  '门襟钉扣线': 'Front Button Thread',
  '门襟锁眼线': 'Front BH Thread',
  '问题解决': 'Problem-Solving Ability',
  '防静电浅色条': 'Anti-static Light Stripe',
  '防静电深色条': 'Anti-static Dark Stripe',
  '随货发': 'Ship with Order',
  '零剪价格': 'Cut Price',
  '需修改': 'Changes Needed',
  '需处理': 'Action Required',
  '面料': 'Fabric',
  '撞色缎': 'Contrast Satin',
  '方巾': 'Pocket Square',
  '拉链': 'Zipper',
  '装饰条': 'Trim',
  '水晶': 'Crystal',
  '松紧带': 'Elastic Band',
  '其它': 'Other',
  '面料名称': 'Fabric Name',
  '客供面料': 'My Fabric',
  '面料品牌': 'Fabric Brand',
  '面料编号': 'Fabric Code',
  '面料号': 'Fabric No.',
  '收货工厂': 'Receiving Factory',
  '面料纹路': 'Fabric Pattern',
  '面料幅宽（cm）': 'Fabric Width (cm)',
  '运输公司名称': 'Shipping Company',
  '运单号': 'Waybill No',
  '寄件日期': 'Shipping Date',
  '面料图案': 'Fabric Pattern',
  '面料图片': 'Image',
  '面料库存': 'Fabric Inventory',
  '面料归类规则': 'Fabric Grading Rules',
  '面料成本': 'Fabric Cost',
  '面料标 + 领标': 'Fabric + Neck Label',
  '面料标+领标': 'Fabric Label + Collar Label',
  '面料标在右': 'Fabric Label Right',
  '面料标在左': 'Fabric Label Left',
  '面料标订下里襟': 'Fabric Label on Under Placket',
  '面料标订后复势': 'Fabric Label on Back Yoke',
  '面料标订后复势+商标订下里襟': 'Fabric on Back Yoke + Brand on Under Placket',
  '面料款式数': 'Fabric Styles',
  '面料选择': 'Fabric Selection',
  '面料颜色': 'Fabric Color',
  '页面出错了': 'Page Error',
  '项': 'Item(s)',
  '顺丰国际': 'SF Express International',
  '顺色无防滑腰里': 'Matching Standard',
  '顺色防滑腰里': 'Matching Anti-slip',
  '顺面料色': 'Match Fabric',
  '预计交期': 'Estimated Delivery',
  '预计发货日期': 'Est. Ship Date',
  '预计完成日期': 'MM/DD/YYYY',
  '领、袖衬': 'Collar & Cuff Interlining',
  '领围': 'Neck',
  '领型': 'Collar',
  '领型设计': 'Collar Style',
  '领子+驳头': 'Collar + Lapel',
  '领子+驳头+下口袋牙边': 'Collar + Lapel + Pocket Piping',
  '领子+驳头+下口袋牙边+外翻袖口': 'Collar + Lapel + Pocket Piping+ Turn-back Cuff',
  '领子+驳头+下口袋牙边+胸口袋': 'Collar + Lapel + Pocket Piping+ Chest Pocket',
  '领尖双层订暗扣': 'Collar Point Double Layer Hidden Button',
  '领尖小袢订暗扣': 'Collar Point Tab + Hidden Button',
  '领尖款式': 'Collar Point Style',
  '领尖订明扣': 'Collar Point Button (Visible)',
  '领尖长': 'Collar Point Length',
  '领带': 'Ties',
  '领底尼': 'Under Collar Felt',
  '领座设计': 'Collar Stand',
  '领结': 'Bow Ties',
  '领针锁圆头眼': 'Collar Pin Buttonhole',
  '颜色': 'Color',
  '颜色/色系': 'Color',
  '位置': 'Position',
  '高度': 'Height',
  '图片刺绣': 'Image Embroidery',
  '颜色详细描述': 'Color Detail',
  '额外奖励': 'Extra Bonus',
  '额外收费': '+ Extra',
  '首扣距离': 'First Button Position',
  '首页': 'Home',
  '马甲': 'Waistcoat / Vest',
  '马甲下摆设计': 'Vest Hem',
  '马甲侧叉': 'Vest Side Vent',
  '马甲口袋': 'Vest Pockets',
  '马甲后背腰带': 'Back Belt',
  '马甲后领': 'Vest Back Collar',
  '马甲商标': 'Vest Label',
  '马甲设计': 'Vest Design',
  '马甲贡针': 'Vest Pick Stitch',
  '马甲贡针线': 'Vest Pick Stitch Thread',
  '马甲门襟扣数': 'Vest Front Buttons',
  '马甲驳头型': 'Vest Lapel',
  '马甲驳头宽度': 'Vest Lapel Width',
  '马蹄脚口': 'Horseshoe Hem',
  '驳回': 'Reject',
  '添加关联订单': 'Add Linked Order',
  '请输入订单号': 'Enter order no.',
  '已添加关联订单': 'Order linked',
  '仅可添加同门店、未开票、未付款且已审核的订单。新行运费/关税/折扣默认为0，手续费自动计算。': 'Only same-store, uninvoiced, unpaid and reviewed orders can be added. New line shipping/tariff/discount default to 0; handling fee is calculated automatically.',
  '驳回订单': 'Reject Order',
  '驳头': 'Lapel',
  '驳头+下口袋牙边': 'Lapel + Pocket Piping',
  '驳头+下口袋牙边+胸袋': 'Lapel + Pocket Piping+ Chest Pocket',
  '驳头型': 'Lapel Style',
  '驳头宽': 'Lapel Width',
  '驳头眼锁眼线': 'Lapel BH Thread',
  '驳头眼长度': 'Lapel BH Length',
  '高端档': 'HIGH-END',
  '高端档（高）': 'HIGH-END (High)',
  '高级工艺': 'Premium',
  '黑名单': 'Blacklisted',
  '黑色无防滑腰里': 'Black Standard',
  '黑色里布': 'Black Lining',
  '黑色防滑腰里': 'Black Anti-slip',
  '默认合缝上袖': 'Standard Set-in Sleeve',
  '默认工厂': 'Primary Factory',
  '默认左驳头眼': 'Left Lapel Only',
  '龙角型': 'Dragon Horn Shape Milanese',
  '刺绣': 'Embroidery',
  '半麻衬': 'Half Canvas',
  '全麻衬': 'Full Canvas',
  '粘合衬': 'Fused Interlining',
  '扣型': 'Button Style',
  '前门襟': 'Front Placket',
  '米兰眼': 'Milanese Buttonhole',
  '手工扣眼': 'Hand-stitched Buttonhole',
  '花眼': 'Decorative Buttonhole',
  '基础配置': 'Basic Configuration',
  '运输方式': 'Shipping Method',
  '正常14天': 'Normal 14 Days',
  '优先10天': 'Priority 10 Days',
  '加急7天': 'Urgent 7 Days',
  '加急5天': 'Urgent 5 Days',
  '标准成衣试身': 'Standard Fitting',
  '无需试身': 'No Fitting Required',
  '试身回': 'Fitting Complete',
  '手工试毛样': 'Handmade Basted Fitting',
  '顺丰': 'SF Express',
  '代理': 'Agent',
  'CMT加工费': 'CMT Processing Fee',
  'RTW数量折扣': 'RTW Volume Discount',
  '优惠合计': 'Discount Total',
  '个性收费合计': 'Custom Charges Total',
  '个性收费项': 'Custom Charges',
  '个行项目': 'line items',
  '个订单': 'orders',
  '个订单生成发票': 'orders to generate invoice',
  '临时': 'Temp',
  '临时面料已添加': 'Temporary fabric added',
  '件': 'pcs',
  '估算': 'Estimate',
  '全部门店': 'All Stores',
  '内部备注（不显示在报价单）': 'Internal Remarks (not shown on invoice)',
  '加载中...': 'Loading...',
  '发票已生成': 'Invoice Generated',
  '发票总额': 'Invoice Total',
  '发票日期': 'Invoice Date',
  '发票生成': 'Invoice Generation',
  '发票生成成功': 'Invoice generated successfully',
  '发票编号': 'Invoice No.',
  '合计': 'Total',
  '名称': 'Name',
  '品类数：': 'Categories:',
  '基于订单生成发票，可调整单价': 'Generate invoice from orders, unit price adjustable',
  '填写后自动作为当前行面料': 'Auto-assigned as current line fabric after filling',
  '备注（内部用，不显示在报价单）': 'Remarks (internal, not shown on invoice)',
  '如：S / M / L / XL': 'e.g. S / M / L / XL',
  '如：TEMP-001': 'e.g. TEMP-001',
  '如：共5位客户，面料已确认，需加急...': 'e.g. 5 customers, fabric confirmed, urgent...',
  '如：深蓝色 / 细条纹 / 客户A': 'e.g. Dark Blue / Pinstripe / Customer A',
  '如：深蓝色羊毛': 'e.g. Dark Blue Wool',
  '如：自定义品牌': 'e.g. Custom Brand',
  '客户：': 'Customer:',
  '客户看到：品类 + 工艺 + 单价 + 数量 + 小计': 'Customer sees: Category + Craft + Unit Price + Qty + Subtotal',
  '客户门店': 'Customer Store',
  '导入订单信息失败': 'Failed to import order info',
  '将为': 'Will generate invoice for',
  '小计': 'Subtotal',
  '已开票': 'Invoiced',
  '已选收费项': 'Selected Charges',
  '总套数：': 'Total Sets:',
  '总额': 'Total Amount',
  '报价模式': 'Quote Mode',
  '报价汇总': 'Quote Summary',
  '报价计算成功': 'Quote calculated successfully',
  '搜索订单号/客户名...': 'Search order no./customer name...',
  '搜索订单号/客户名/门店编号/备注': 'Search order no./customer/store no./remarks',
  '搜索门店名称或编号...': 'Search store name or no...',
  '数量（件）': 'Qty (pcs)',
  '数量折扣': 'Volume Discount',
  '数量折扣：': 'Volume Discount:',
  '新加': 'Add New',
  '新增临时面料': 'Add Temporary Fabric',
  '新建门店': 'New Store',
  '更换订单': 'Change Order',
  '最近使用': 'Recently Used',
  '服装基础价格': 'Clothing Base Price',
  '服装小计': 'Clothing Subtotal',
  '未开票': 'Not Invoiced',
  '标准报价': 'Standard Quote',
  '混合订单': 'Mixed Order',
  '添加品类行': 'Add Category Line',
  '物流': 'Shipping',
  '生成发票失败': 'Generate invoice failed',
  '生成失败': 'Generation failed',
  '码数（选填）': 'Size (optional)',
  '确认生成': 'Confirm Generate',
  '确认生成发票': 'Confirm Generate Invoice',
  '确认选择': 'Confirm Selection',
  '绑定订单号': 'Bind Order No.',
  '耗料量（米）': 'Fabric Usage (m)',
  '联系邮箱': 'Contact Email',
  '获取订单失败': 'Failed to fetch orders',
  '获取订单详情失败': 'Failed to fetch order details',
  '订单': 'Order',
  '订单信息已导入': 'Order info imported',
  '订单明细': 'Order Details',
  '订单类型': 'Order Type',
  '请为每个订单行绑定真实订单号': 'Please bind a real order no. for each line',
  '请先填写下方临时面料信息': 'Please fill in the temporary fabric info below first',
  '请先选择门店': 'Please select a store first',
  '请先选择门店客户': 'Please select a store customer first',
  '请完善品类信息': 'Please complete category info',
  '请至少选择一个订单': 'Please select at least one order',
  '请输入面料编号': 'Please enter fabric code',
  '请选择': 'Please select',
  '请选择...': 'Please select...',
  '请选择价格档': 'Please select price tier',
  '请选择门店，然后选择未开票的订单': 'Please select a store, then select uninvoiced orders',
  '输入地址': 'Enter address',
  '输入编号/品牌/颜色搜索...': 'Search by code/brand/color...',
  '输入联系人姓名': 'Enter contact name',
  '输入联系电话': 'Enter phone',
  '输入门店名称': 'Enter store name',
  '输入门店编号': 'Enter store no.',
  '返回门店选择': 'Back to Store Selection',
  '适用范围：开发 / 财务 / 业务团队': 'For: Dev / Finance / Sales Team',
  '选择门店': 'Select Store',
  '已选门店': 'Selected Stores',
  '暂未选择门店': 'No stores selected',
  '透明报价': 'Transparent Quote',
  '门店创建成功': 'Store created successfully',
  '门店客户': 'Store Customer',
  '附加费用': 'Additional Fees',
  '附加费用合计': 'Additional Fees Total',
  '面料编号已存在': 'Fabric code already exists',
  '必填': 'Required',
  'CMT仅含工艺费 (USD)': 'CMT Labor Only (USD)',
  'CMT — 仅含工艺费，不含面料成本。以下价格仅涵盖裁剪、缝制及整烫工艺费用，客户须自行提供所有面料，面料成本不包含在此报价中。': 'CMT — Labor only, fabric not included. Prices cover cutting, sewing and pressing only. Customer must provide all fabrics.',
  'CMT 价格表': 'CMT Price List',
  'USD · 含面料及工艺费，不含关税': 'USD · Includes fabric and labor, excludes tariff',
  '上衣+马甲': 'Jacket + Vest',
  '个性收费表': 'Custom Charges Table',
  '个性收费项目': 'Custom Charge Items',
  '付款条款': 'Payment Terms',
  '价格区间': 'Price Range',
  '分享': 'Share',
  '分享功能开发中': 'Share feature is under development',
  '分享报价单': 'Share Quote',
  '分享链接有效期 30 天，外部客户无需登录即可查看': 'Share link valid for 30 days, no login required for external customers',
  '分类': 'Category',
  '刷新预览': 'Refresh Preview',
  '加载失败': 'Loading failed',
  '重新加载': 'Reload',
  '加载客户列表失败': 'Failed to load customer list',
  '加载报价单': 'Loading quote',
  '加载报价单失败': 'Failed to load quote',
  '单价(USD)': 'Unit Price (USD)',
  '历史': 'History',
  '发票不存在或已被删除': 'Invoice does not exist or has been deleted',
  '发票总金额已包含PayPal手续费和运费，不包含进口关税。': 'Invoice total includes PayPal fees and shipping, excludes import duties.',
  '发票明细': 'Invoice Details',
  '含面料及工艺费，不含关税': 'Includes fabric and labor, excludes tariff',
  '客户信息已更新': 'Customer info updated',
  '客户信息已设置': 'Customer info set',
  '客户已选择': 'Customer selected',
  '客户未设置': 'Customer not set',
  '客户 / 门店': 'Customer / Store',
  '导出 Excel': 'Export Excel',
  '导出Excel': 'Export Excel',
  '导出Excel功能开发中': 'Export Excel feature is under development',
  '导出Excel失败': 'Export Excel failed',
  '导出 PDF': 'Export PDF',
  '导出PDF': 'Export PDF',
  '导出PDF功能开发中': 'Export PDF feature is under development',
  '导出PDF失败': 'Export PDF failed',
  '已从面料库存导入': 'Imported from fabric inventory',
  '开始生产前需支付 50% 定金。': '50% deposit required before production.',
  '形式发票': 'Proforma Invoice',
  '成衣 (RTW)': 'Ready-to-Wear (RTW)',
  '我们的交付时间为收到订单、付款并确认一切正确后的15天内。特殊设计和手工工艺将在3周内完成。运输时间根据物流公司约为4天。': 'Delivery time is 15 days after order, payment and confirmation. Special designs and handwork take 3 weeks. Shipping takes approx. 4 days.',
  '所有价格以美元（USD）计算，自报价日起 30 天内有效。': 'All prices are in USD, valid for 30 days from quote date.',
  '打印 / 存PDF': 'Print / Save PDF',
  '报价单': 'Quotation',
  '报价单生成': 'Generate Quotation',
  '报价总额': 'Quote Total',
  '报价查看': 'View Quote',
  '报价自报价日起30天内有效。所有价格均以美元计算，除非另有说明，不含进口关税及税费。': 'Quote valid for 30 days. All prices in USD unless stated otherwise, excluding import duties and taxes.',
  '搜索客户名称...': 'Search customer name...',
  '收到服装后请及时确认。如有任何问题请在7天内联系我们。超过7天我们将视为服装合格，不可退换。': 'Please confirm receipt promptly. Contact us within 7 days for any issues. After 7 days, garments are considered accepted.',
  '收到服装后请及时确认，如有任何问题请在7天内联系我们。超过7天我们将视为服装合格，不可退换。': 'Please confirm receipt promptly. Contact us within 7 days for any issues. After 7 days, garments are considered accepted.',
  '新建客户': 'New Customer',
  '无效的分享链接或链接已过期': 'Invalid or expired share link',
  '显示列': 'Display Columns',
  '显示工艺': 'Crafts',
  '暂无 CMT 价格数据': 'No CMT price data',
  '暂无个性收费项目': 'No custom charge items',
  '暂无客户数据': 'No customer data',
  '暂无报价数据': 'No quote data',
  '未找到报价数据，请先保存报价': 'Quote data not found, please save quote first',
  '本报价属机密文件，仅供指定收件人参考，未经授权不得对外泄露。': 'This quotation is confidential and for designated recipients only. Unauthorized disclosure is prohibited.',
  '条记录': 'records',
  '条面料': 'fabrics',
  '个品牌': ' brands',
  '基础报价单': 'Base Quote',
  '历史报价单': 'Quote History',
  '请先选择面料': 'Please select fabrics first',
  '来料加工（CMT）价格表': 'CMT Price List',
  '标准交期为收到定金后25-35个工作日，加急订单视情况而定。': 'Standard lead time is 25-35 working days after deposit. Rush orders subject to availability.',
  '生成分享链接失败': 'Failed to generate share link',
  '确认新建': 'Confirm Create',
  '确认订单后，生产周期为 4–6 周。': 'Production lead time is 4-6 weeks after order confirmation.',
  '确认订单需支付50%定金，剩余款项在发货前结清。': '50% deposit required upon confirmation, balance due before shipment.',
  '获取详情失败': 'Failed to get details',
  '西裙': 'Skirt',
  '设置客户信息': 'Set Customer Info',
  '请先保存报价单': 'Please save the quote first',
  '转为发票': 'Convert to Invoice',
  '输入客户名称': 'Enter customer name',
  '输入邮箱地址': 'Enter email address',
  '返回价格计算器': 'Back to Price Calculator',
  '返回发票列表': 'Back to Invoice List',
  '返回报价单': 'Back to Quotation',
  '进口关税、清关费用及当地税费由买方承担，除非另有书面协议。': 'Import duties, customs clearance and local taxes are borne by the buyer unless otherwise agreed in writing.',
  '选择客户': 'Select Customer',
  '链接已复制': 'Link copied',
  '附加费用（物流/关税等）': 'Additional Fees (Shipping/Tariff etc.)',
  '面料供应受布料库存限制，如所选面料无货，我方保留建议同等替代品的权利。': 'Fabric availability is subject to stock. We reserve the right to suggest equivalent alternatives if selected fabric is unavailable.',
  '面料报价': 'Fabric Quote',
  '面料编号 / 品牌': 'Fabric Code / Brand',
  '个品类': 'categories',
  '价格计算器': 'Price Calculator',
  '保存并生成报价单': 'Save & Generate Quote',
  '保存草稿': 'Save Draft',
  '功能开发中': 'Feature under development',
  '加载': 'Load',
  '历史草稿': 'Draft History',
  '导入订单': 'Import Order',
  '导入订单失败': 'Failed to import order',
  '成衣': 'Ready-to-Wear',
  '保存报价单': 'Save Quote',
  '保存报价单失败': 'Failed to save quote',
  '显示RTW批量折扣': 'Show RTW Bulk Discount',
  '报价单已保存': 'Quote saved',
  '暂无草稿': 'No drafts',
  '暂无草稿/提交状态的订单': 'No draft/submitted orders',
  '生成分享链接': 'Generate Share Link',
  '草稿已保存': 'Draft saved',
  '草稿已删除': 'Draft deleted',
  '草稿已加载': 'Draft loaded',
  '获取订单列表失败': 'Failed to fetch order list',
  '订单导入成功，已填充报价参数': 'Order imported successfully, quote parameters filled',
  '该订单没有明细项': 'This order has no detail items',
  '编号': 'No.',
  '客供纽扣': 'Client-supplied Buttons',
  '纹路/花色': 'Pattern/Color',
  '幅宽（cm）': 'Width (cm)',
  '选择同步数据库': 'Select Sync Database',
  '同步到品类项': 'Sync to Category Items',
  '同步选项到品类项': 'Sync Options to Category Items',
  '源数据库': 'Source Database',
  '目标分类项': 'Target Category',
  '请选择目标分类项': 'Please select target category',
  '目标设计项': 'Target Design Items',
  '选择要同步的设计项（可多选）': 'Select design items to sync (multiple)',
  '源选项': 'Source options',
  '无源选项': 'No source options',
  '已选择 {{count}} 个目标设计项，将同步源数据库中编码对应的设计项选项，重复编码的选项将自动跳过': '{{count}} target design items selected. Options from source database with matching codes will be synced; duplicate option codes will be skipped.',
  '同步成功，共 {{count}} 个设计项，新增 {{added}} 个选项': 'Sync successful: {{count}} design items, {{added}} new options added',
  '没有成功同步的设计项，请检查源品类中是否存在对应编码的设计项': 'No design items were synced. Please check if matching design items exist in the source category.',
  '请至少选择一个目标设计项': 'Please select at least one target design item',
  '选择同步仓库': 'Select Sync Warehouse',
  '管理仓库': 'Manage Warehouses',
  '同步仓库管理': 'Sync Warehouse Management',
  '仓库列表': 'Warehouse List',
  '仓库名称': 'Warehouse Name',
  '仓库编码': 'Warehouse Code',
  '暂无仓库': 'No warehouses',
  '选项管理': 'Option Management',
  '新建选项': 'New Option',
  '编辑选项': 'Edit Option',
  '请先选择左侧仓库': 'Please select a warehouse on the left',
  '源仓库': 'Source Warehouse',
  '将同步仓库中的选项到目标设计项，重复编码的选项将自动跳过': 'Warehouse options will be synced to target design items; duplicate option codes will be skipped.',
  '请选择同步仓库': 'Please select a sync warehouse',
  '没有成功同步的设计项，请检查仓库中是否存在选项': 'No design items were synced. Please check if the warehouse has options.',
  '无权限访问工作台': 'No permission to access workbench',
  '当前账号没有权限访问首页，请联系管理员': 'Current account has no permission to access the homepage, please contact the administrator',
  '服务器暂时不可用，请稍后重试': 'Server is temporarily unavailable, please try again later',
  '服务器内部错误，请联系管理员': 'Server internal error, please contact the administrator',
  '请求接口不存在': 'Requested interface does not exist',
  '发票管理': 'Invoice Management',
  '门店账号': 'Store Accounts',
  '客户注册审核': 'Customer Registration Audit',
  '通过并分配门店': 'Approve & Assign Store',
  '修改门店': 'Modify Store',
  '确认拒绝该账号？': 'Confirm reject this account?',
  '请选择或输入门店': 'Please select or enter a store',
  '门店来源': 'Store Source',
  '选择已有门店': 'Select Existing Store',
  '输入新门店': 'Enter New Store',
  '新门店名称': 'New Store Name',
  '请输入新门店名称，不存在则自动创建': 'Enter new store name; it will be created if not exists',
  '当前门店': 'Current Store',
  '待创建': 'To be Created',
  '搜索用户名/姓名/电话/邮箱': 'Search username/name/phone/email',
  '价格体系配置': 'Price System Config',
  '基础订单配置': 'Base Order Config',
  '团队管理': 'Team Management',
  '团队成员管理': 'Team Members',
  '团队订单': 'Team Orders',
  '提成计算器': 'Commission Calculator',
  '工资计算器': 'Salary Calculator',
  '工资汇总': 'Salary Summary',
  '年终分红': 'Year-end Bonus',
  '折扣审批': 'Discount Approval',
  '角色权限': 'Roles & Permissions',
  '切换用户': 'Switch User',
  '系统配置': 'System Config',
  '生产完成': 'Production Completed',
  '作废': 'Voided',
  '系统里布': 'System Lining',
  '系统纽扣': 'System Button',
  '3粒': '3',
  '5粒': '5',
  '6粒': '6',
  'A字裙': 'A-Line Skirt',
  '上衣设计': 'Jacket Design',
  '上衣设计尺寸': 'Jacket Design Size',
  '中长款': 'Mid-Length',
  '中长裙': 'Midi Skirt',
  '亚麻': 'Linen',
  '低腰': 'Low Rise',
  '半身裙': 'Skirt',
  '单开衩': 'Single Vent',
  '单扣袖口': 'Single Button',
  '单褶': 'Single Pleat',
  '厚羊毛': 'Heavy Wool',
  '及膝': 'Knee',
  '双开线袋': 'Jetted Pocket',
  '双开衩': 'Double Vent',
  '双褶': 'Double Pleat',
  '大衣设计': 'Coat Design',
  '大衣设计尺寸': 'Coat Design Size',
  '工艺类型': 'Craftsmanship',
  '带盖口袋': 'Flap Pocket',
  '平脚': 'Plain Hem',
  '平驳头': 'Notch Lapel',
  '戗驳头': 'Peak Lapel',
  '标准领': 'Point Collar',
  '棕色法兰绒': 'Brown Flannel',
  '法式袖口': 'French Cuff',
  '深藏青羊毛': 'Dark Navy Wool',
  '深藏青羊毛裙料': 'Dark Navy Wool Skirt',
  '深藏青羊毛裤料': 'Dark Navy Wool Trouser',
  '温莎领': 'Spread Collar',
  '灰色精纺': 'Grey Worsted',
  '牛角扣': 'Horn Button',
  '珍珠母贝': 'Mother of Pearl',
  '白色纯棉': 'White Cotton',
  '百褶裙': 'Pleated Skirt',
  '真丝红色': 'Red Silk',
  '短裙': 'Short Skirt',
  '纽扣数': 'Buttons',
  '纽扣领': 'Button-down Collar',
  '羊绒': 'Cashmere',
  '翻边': 'Turn-up',
  '蓝色纯棉': 'Blue Cotton',
  '衬衫设计尺寸': 'Shirt Design Size',
  '裙型': 'Skirt Style',
  '裙子': 'Skirt',
  '裙装设计尺寸': 'Skirt Design Size',
  '裙长': 'Skirt Length',
  '裤装设计尺寸': 'Trouser Design Size',
  '西服上衣': 'Jacket',
  '西裤+马甲': 'Trousers + Vest',
  '西裤设计': 'Trouser Design',
  '贴袋': 'Patch Pocket',
  '铅笔裙': 'Pencil Skirt',
  '长度': 'Length',
  '长裙': 'Long Skirt',
  '青果领': 'Shawl Lapel',
  '马甲专用料': 'Vest Fabric',
  '马甲设计尺寸': 'Vest Design Size',
  '高腰': 'High Rise',
  '待采面料': 'To-be-purchased Fabric',
  '邮寄面料': 'Mailed Fabric',
  '米': 'meters',
  '顺丰快递': 'SF Express',
  '平肩': 'Straight Shoulder',
  '溜肩': 'Sloping Shoulder',
  '衣长': 'Coat Length',
  '图文': 'Image & Text',
  '码': 'yards',
  '英寸': 'inches',
  '颗': 'pieces',
  '包': 'packages',
  '订单列表': 'Order List',
  '本月订单量': 'This Month Orders',
  '浏览报价': 'Browse Quote',
  '查看账单': 'View Bills',
  '离线': 'Offline',
  '在线客户': 'Online Customers',
  '加载基础数据失败': 'Failed to load base data',
  '档位': 'Tier',
  '销售额区间 (USD)': 'Sales Range (USD)',
  '提成比例': 'Commission Rate',
  '该档最大提成': 'Max Commission for Tier',
  '各档提成分布': 'Commission Distribution by Tier',
  '提成阶梯参考表': 'Commission Tier Reference',
  '成员A': 'Member A',
  '成员B': 'Member B',
  '业务经理提成计算器': 'Sales Manager Commission Calculator',
  '团队管理提成阶梯': 'Team Management Commission Tiers',
  '团队月销售额区间 (USD)': 'Team Monthly Sales Range (USD)',
  '管理提成比例': 'Management Commission Rate',
  '定制订单（业务员）': 'Custom Order (Designer)',
  '定制订单提成计算': 'Custom Order Commission Calculation',
  '团单（业务员）': 'RTW Order (Designer)',
  '团单提成计算': 'RTW Order Commission Calculation',
  '输入销售额，实时计算各档提成金额，超额累进分段计算': 'Enter sales amount to calculate commission by tier in real time',
  '姓名': 'Name',
  '类型': 'Type',
  '原价': 'Original Price',
  '折后价': 'Discounted Price',
  '待审批': 'Pending Approval',
  '已拒绝': 'Rejected',
  '全部状态': 'All Statuses',
  '暂无记录': 'No Records',
  '需要审批': 'Approval Required',
  '无需审批': 'No Approval Needed',
  '删除成功': 'Deleted',
  '状态已更新': 'Status Updated',
  '确定删除？': 'Confirm Delete?',
  '可选备注': 'Optional Remarks',
  '提成损失': 'Commission Loss',
  '原价提成': 'Original Commission',
  '折后提成': 'Discounted Commission',
  '管理折扣申请及审批流程': 'Manage discount applications and approvals',
  '需要审批，折扣过低': 'Approval required, discount too low',
  '无需审批，折扣合规': 'No approval required, discount compliant',
  '保存折扣审批记录': 'Save discount approval record',
  '确认保存': 'Confirm Save',
  '修改记录': 'Modification History',
  '暂无修改记录': 'No modification records',
  '编辑历史': 'Edit History',
  '编辑前快照': 'Pre-edit Snapshot',
  '修改前': 'Before',
  '修改后': 'After',
  '款式项': 'Style Item',
  '暂无变更': 'No changes',
  '交付物流': 'Delivery & Logistics',
  '交货天数': 'Delivery Days',
  '交货日期': 'Delivery Date',
  '快递方式': 'Shipping Method',
  '送货地址': 'Shipping Address',
  '试身': 'Fitting',
  '个性定制': 'Special Design',
  '折扣金额': 'Discount Amount',
  '下口袋': 'Lower Pockets',
  '下摆造型': 'Hem Style',
  '侧叉': 'Side Vent',
  '内贡针线': 'Inner Pick Stitch Thread',
  '后背款式': 'Back Style',
  '后背腰带': 'Back Belt',
  '撞色部位': 'Contrast Placement',
  '纽扣选择': 'Button Selection',
  '线色号': 'Thread Color Code',
  '胸口袋': 'Chest Pocket',
  '胸袋设计': 'Chest Pocket Design',
  '腰带袢': 'Back Belt Loop',
  '袖口订扣线': 'Cuff Button Thread',
  '袖口设计': 'Cuff Design',
  '袖扣数量': 'Sleeve Buttons',
  '订扣线': 'Button Thread',
  '调节袢/裤袢': 'Belt Loops / Side Adjusters',
  '贡针': 'Pick Stitch',
  '贡针线': 'Pick Stitch Thread',
  '里布选择': 'Lining Selection',
  '锁眼线': 'Buttonhole Thread',
  '门襟款式': 'Front Style',
  '门襟订扣线': 'Front Button Thread',
  '门襟设计': 'Placket Style',
  '领尖插片': 'Collar Stays',
  '领底呢': 'Felt Under Collar',
  '领袖衬': 'Collar & Cuff Interlining',
  '驳头宽度': 'Lapel Width',
  '驳头眼': 'Lapel Buttonhole',
  '驳头眼数量': 'Lapel Buttonholes',
  '后腰带': 'Back Belt',
  '待计算': 'To be calculated',
  '待设置': 'To be set',
  '（参考价格，最终以正式发票为准）': '(Reference price, subject to the official invoice)',
  '下一步确认': 'Confirm in next step',
  '正在导出...': 'Exporting...',
  '预估总价': 'Estimated Total',
  '此价格为预估价格，不含运费和可能存在的其它费用，最终以正式发票为准': 'This is an estimated price, excluding shipping and other possible fees. The final price is subject to the official invoice.',
  '此价格为预估价格，最终以正式发票为准': 'This is an estimated price. The final price is subject to the official invoice.',
  '订单提醒': 'Order Reminder',
  '系统升级': 'System Upgrade',
  '待办事宜': 'To-Do',
  '发票更新': 'Invoice Update',
  '催款提醒': 'Payment Reminder',
  '折扣消息': 'Discount Notice',
  '限时折扣': 'Flash Sale',
  '日常消息': 'Daily Notice',
  '模板管理': 'Template Manager',
  '模板已保存': 'Template saved',
  '模板已载入': 'Template loaded',
  '载入模板': 'Load Template',
  '消息模板管理': 'Message Template Manager',
  '模板标题': 'Template Title',
  '模板内容': 'Template Content',
  '删除模板': 'Delete Template',
  '保存模板': 'Save Template',
  '该类型暂无模板': 'No template for this type',
  '已配置': 'Configured',
  '确认删除该模板?': 'Delete this template?',
  '发送消息': 'Send Message',
  '请输入消息标题': 'Please enter title',
  '例如：您的订单已进入生产阶段': 'e.g., Your order is now in production',
  '审核操作': 'Review Actions',
  '耗料计算': 'Fabric Calc',
  '尺寸加放': 'Ease Allowance',
  '面料编号及默认用量': 'Fabric No. & Default Usage',
  '耗料': 'Fabric Usage',
  '面料价格档': 'Fabric Price Tier',
  '重新计算价格': 'Recalculate',
  '价格已重新计算': 'Price recalculated',
  '重新计算失败': 'Recalculation failed',
  '请先填写面料价格档': 'Please set fabric price tier first',
  // Ease Rule Config
  '加放规则维护': 'Ease Rule Config',
  '版型库': 'Patterns',
  '尺码表': 'Size Chart',
  '加放规则': 'Ease Rules',
  '版型名称': 'Pattern Name',
  '版型编码': 'Pattern Code',
  '参考款式图': 'Reference Images',
  '参考款式图 URL(每行一个)': 'Reference Image URLs (one per line)',
  '新增版型': 'New Pattern',
  '编辑版型': 'Edit Pattern',
  '来源': 'Source',
  '全部品类': 'All Categories',
  '规格编码': 'Spec Code',
  '主索引尺寸': 'Key Size',
  '体型码': 'Body Type',
  '选择版型查看尺码点': 'Select pattern to view size rows',
  '请选择版型': 'Please select a pattern',
  '西服上衣加放(常规)': 'Jacket Ease (Regular Belly)',
  '西服上衣加放(大肚)': 'Jacket Ease (Big Belly)',
  '马甲加放': 'Vest Ease',
  '西裤加放(基础)': 'Trouser Ease (Base)',
  '西裤褶型/腰高调整': 'Trouser Pleat / Waist Height Adjustments',
  '衬衫加放(在西服成品上追加)': 'Shirt Ease (added on top of jacket finished)',
  '大衣加放(在虚拟西服上追加)': 'Coat Ease (added on top of virtual jacket)',
  '合体度': 'Fit',
  '紧身裤褶调整(臀围)': 'Slim Pleat Adj. (Hip)',
  '其它合体度褶调整(臀围)': 'Other Fit Pleat Adj. (Hip)',
  '大腿褶加量': 'Thigh Pleat Add',
  '立裆褶加量': 'Rise Pleat Add',
  '腰高立裆加量': 'Waist Height Rise Add',
  '以下规则来源于《审单操作说明.md v4.3》，暂为程序内硬编码；后续可迁移到数据库配置。':
    'Rules below come from Audit Manual v4.3, currently hardcoded in the engine. Can be migrated to DB config later.',
  '大肚体形判定：西服上衣胸围-肚围<0；马甲胸围-肚围<8；或 BMI≥28。判为大肚时切换到大肚规则表。':
    'Big-belly detection: (chest - belly) < 0 for jacket, < 8 for vest, or BMI ≥ 28. Switches to big-belly rule table.',
  '半 cm 取整：所有推算结果向下取到最接近的 0.5cm。':
    'Half-cm rounding: all derived results are floored to the nearest 0.5cm.',
  '本订单小计': 'Order Subtotal',
  '回收站': 'Recycle Bin',
  '永久删除': 'Delete Permanently',
  '删除时间': 'Deleted At',
  '删除人': 'Deleted By',
  '仅管理员可访问': 'Admin only',
  '搜索订单号/客户/门店': 'Search order no / customer / store',
  '搜索发票号/门店': 'Search invoice no / store',
  '恢复': 'Restore',
  '已恢复': 'Restored',
  '已永久删除': 'Permanently deleted',
  '恢复失败': 'Restore failed',
  '确认恢复此订单？': 'Restore this order?',
  '确认恢复此发票？': 'Restore this invoice?',
  '永久删除后无法恢复，确认？': 'This will delete permanently and cannot be undone. Confirm?',
  '已采购的记录不可删除': 'Purchased records cannot be deleted',
  '关键词搜索': 'Keyword search',
  '门店编号/发票编号/关联订单号': 'Store no / Invoice no / Order no',

  '(自定义)': '(Custom)',
  'AI 渲染预览': 'AI Render Preview',
  'AI校验请求失败': 'AI Validation Request Failed',
  'AI校验请求已发送': 'AI Validation Request Sent',
  'YYYYMMDD': 'YYYYMMDD',
  'a': 'a',
  '、': ', ',
  '上衣尺寸': 'Jacket Measurements',
  '中格【1-3cm】': 'Medium Check [1-3cm]',
  '人字纹宽条': 'Wide Herringbone',
  '人字纹细条': 'Fine Herringbone',
  '仅已发货或已完成的订单可发起售后': 'Only shipped or completed orders can initiate after-sales',
  '付款': 'Payment',
  '付款日期': 'Payment Date',
  '付款记录已添加': 'Payment Record Added',
  '价格档已更新': 'Price Tier Updated',
  '体型和款式图': 'Body Type & Style Images',
  '保存审核备注失败': 'Failed to Save Review Note',
  '关联发票': 'Linked Invoice',
  '关联订单': 'Linked Order',
  '净色': 'Solid Color',
  '凭证图片': 'Receipt Image',
  '出入库': 'Stock In/Out',
  '加急': 'Rush',
  '动作': 'Action',
  '千鸟格中格': 'Medium Houndstooth',
  '千鸟格大格': 'Large Houndstooth',
  '千鸟格细格': 'Fine Houndstooth',
  '单号': 'Order No.',
  '博亚返回值': 'Boya Response',
  '原因': 'Reason',
  '发票': 'Invoice',
  '发票文件': 'Invoice File',
  '发票详情': 'Invoice Details',
  '发票金额': 'Invoice Amount',
  '发货失败': 'Shipment Failed',
  '发货成功': 'Shipment Successful',
  '发货日期': 'Shipping Date',
  '发货时间': 'Shipping Time',
  '后台': 'Backend',
  '售后原因': 'After-Sales Reason',
  '售后图片': 'After-Sales Images',
  '售后处理中': 'After-Sales In Progress',
  '售后已完成': 'After-Sales Completed',
  '售后服务': 'After-Sales Service',
  '售后状态': 'After-Sales Status',
  '售后申请已提交': 'After-Sales Request Submitted',
  '售后类型': 'After-Sales Type',
  '售后详情': 'After-Sales Details',
  '售后说明': 'After-Sales Description',
  '商品': 'Product',
  '回滚失败': 'Rollback Failed',
  '图片上传失败': 'Image Upload Failed',
  '图片上传成功': 'Image Upload Successful',
  '处理售后工单': 'Process After-Sales Ticket',
  '处理成功': 'Processed Successfully',
  '处理结果': 'Processing Result',
  '处理说明': 'Processing Notes',
  '备注已对门店可见': 'Note is now visible to store',
  '备注已隐藏': 'Note is now hidden',
  '复核通过': 'Review Approved',
  '大格【大于3cm】': 'Large Check [>3cm]',
  '大衣尺寸': 'Overcoat Measurements',
  '字体': 'Font',
  '审核': 'Review',
  '审核记录': 'Review Records',
  '客供纽扣（代采）': 'Client Buttons (Sourced)',
  '客供纽扣（客供）': 'Client Buttons (Supplied)',
  '客供里布（代采）': 'Client Lining (Sourced)',
  '客供里布（客供）': 'Client Lining (Supplied)',
  '客供面料（代采）': 'Client Fabric (Sourced)',
  '客供面料（客供）': 'Client Fabric (Supplied)',
  '宽条纹【大于0.6cm】': 'Wide Stripe [>0.6cm]',
  '对门店不可见，点击显示': 'Hidden from store, click to show',
  '对门店可见，点击隐藏': 'Visible to store, click to hide',
  '左对齐': 'Left Align',
  '居中': 'Center',
  '右对齐': 'Right Align',
  '对齐': 'Alignment',
  '工单号': 'Ticket No.',
  '工厂订单号': 'Factory Order No.',
  '工厂转移成功': 'Factory Transfer Successful',
  '工厂预计交期': 'Factory Est. Delivery',
  '已付清': 'Paid in Full',
  '已回滚到待推送': 'Rolled Back to Pending Push',
  '已确认到账': 'Payment Confirmed',
  '开始生产': 'Production Started',
  '开票日期': 'Invoice Date',
  '当前状态': 'Current Status',
  '成衣尺寸（AI建议）': 'RTW Size (AI Suggested)',
  '所选品类': 'Selected Category',
  '推送不提交': 'Push Without Submit',
  '推送不提交结果': 'Push Without Submit Result',
  '推送工厂成功': 'Push to Factory Successful',
  '推送并提交': 'Push & Submit',
  '推送并提交结果': 'Push & Submit Result',
  '提花': 'Jacquard',
  '搜索价格档': 'Search Price Tier',
  '撤回推送': 'Withdraw Push',
  '无体型和款式图': 'No Body Type & Style Images',
  '无体型特征记录': 'No Body Type Feature Records',
  '时间': 'Time',
  '暂无备注信息': 'No Notes Available',
  '暂无审核记录': 'No Review Records',
  '暂无操作日志': 'No Operation Logs',
  '暂无款式配置，请在Step1中选择': 'No style config, please select in Step 1',
  '暂无物流记录': 'No Shipping Records',
  '未付余额': 'Unpaid Balance',
  '未付金额': 'Unpaid Amount',
  '未生成发票': 'No Invoice Generated',
  '标准': 'Standard',
  '标码值': 'Standard Size Value',
  '标记完成': 'Mark Complete',
  '正在生成中...': 'Generating...',
  '测试推送': 'Test Push',
  '测试推送结果': 'Test Push Result',
  '添加备注': 'Add Note',
  '物流信息': 'Shipping Info',
  '物流截图': 'Shipping Screenshot',
  '状态同步成功': 'Status Synced Successfully',
  '用量': 'Usage',
  '确定要删除这条备注吗？': 'Are you sure you want to delete this note?',
  '确认删除': 'Confirm Delete',
  '确认失败': 'Confirmation Failed',
  '确认成功': 'Confirmation Successful',
  '确认标记完成': 'Confirm Mark Complete',
  '确认通过': 'Confirm Approve',
  '类别': 'Category',
  '细条纹【小于0.6cm】': 'Fine Stripe [<0.6cm]',
  '细格【小于1cm】': 'Fine Check [<1cm]',
  '耗料计算失败': 'Fabric Usage Calculation Failed',
  '耗料计算完成': 'Fabric Usage Calculation Complete',
  '耗料计算超时，请稍后重试': 'Fabric usage calculation timeout, please retry later',
  '腰高': 'Waist Height',
  '舒适': 'Comfortable',
  '获取AI建议': 'Get AI Suggestion',
  '获取发票详情失败': 'Failed to Get Invoice Details',
  '衬衫尺寸': 'Shirt Measurements',
  '裤子尺寸': 'Trouser Measurements',
  '订单发货': 'Order Shipment',
  '订单尺寸汇总': 'Order Measurements Summary',
  '订单已被驳回': 'Order Rejected',
  '订单标记完成后将流转到已完成状态，是否继续？': 'Marking the order as complete will change its status to Completed. Continue?',
  '订单费用': 'Order Charges',
  '请输入付款金额': 'Please enter payment amount',
  '请输入售后原因': 'Please enter after-sales reason',
  '请输入处理说明': 'Please enter processing notes',
  '请输入审核备注': 'Please enter review note',
  '请输入转移原因': 'Please enter transfer reason',
  '请输入驳回原因，将同步给门店': 'Please enter rejection reason (will be synced to store)',
  '请选择交易日期': 'Please select transaction date',
  '请选择发货日期': 'Please select shipping date',
  '请选择售后类型': 'Please select after-sales type',
  '请选择工厂': 'Please select factory',
  '账号': 'Account',
  '货币单位：USD': 'Currency: USD',
  '费用汇总': 'Charge Summary',
  '返回列表': 'Back to List',
  '采购': 'Procurement',
  '重新提交': 'Resubmit',
  '长短': 'Length',
  '门店/业务员': 'Store/Sales Rep',
  '附件': 'Attachment',
  '面料用量已更新': 'Fabric Usage Updated',
  '预计完成': 'Est. Completion',
  '马甲尺寸': 'Vest Measurements',
  '驳回图片': 'Rejection Images',
  '20米以上': 'Over 20m',
  '20米以上价格（人民币）': 'Price for Over 20m (CNY)',
  '60米以上': 'Over 60m',
  '60米以上价格（人民币）': 'Price for Over 60m (CNY)',
  'AI 校验建议': 'AI Validation Suggestion',
  'AI 正面': 'AI Front View',
  'AI 识别入库': 'AI Recognition Inbound',
  'AI校验功能开发中': 'AI Validation Feature In Development',
  'AI预览图生成失败': 'AI Preview Generation Failed',
  'AI预览图生成请求已发送': 'AI Preview Generation Request Sent',
  'API对接': 'API Integration',
  'API配置已保存': 'API Config Saved',
  'B端客户信息填写配置': 'B2B Client Info Configuration',
  'CMT加工费($USD)': 'CMT Processing Fee ($USD)',
  'CMT来料加工费': 'CMT Processing Fee',
  'CMT来料加工费（对门店）：客户提供面料时，门店向客户收取的加工费，单位 $USD，按品类+工艺组合定价': 'CMT Processing Fee (for Store): Processing fee charged by store when client supplies fabric, in $USD, priced by category + craft combination',
  'Excel 导出成功': 'Excel Export Successful',
  'HP 名': 'HP Name',
  'HP 尺寸部位名': 'HP Measurement Part Name',
  'HP品类': 'HP Category',
  'HP工艺项编码': 'HP Craft Item Code',
  'HP工艺项（推送字段）': 'HP Craft Item (Push Field)',
  'HP推送项（名称 [编码]）—— 点击行展开明细': 'HP Push Item (Name [Code]) — Click row to expand',
  'HP编码（若有）': 'HP Code (if any)',
  'HP选项中文名': 'HP Option Chinese Name',
  'HP选项名称': 'HP Option Name',
  'HP选项名称 [编码]': 'HP Option Name [Code]',
  'HP选项编码': 'HP Option Code',
  'HP选项编码 (factory_itemid)': 'HP Option Code (factory_itemid)',
  'IP地址': 'IP Address',
  'JD品类': 'JD Category',
  'JD工艺项 [编码]': 'JD Craft Item [Code]',
  'PDF 导出成功': 'PDF Export Successful',
  'RTW 成衣折扣阶梯，按套数区间设置折扣系数（1.0 = 无折扣，0.9 = 九折）': 'RTW Discount Tiers, set discount rate by quantity range (1.0 = no discount, 0.9 = 10% off)',
  'RTW折扣': 'RTW Discount',
  'TOP10 门店': 'Top 10 Stores',
  '① 物流单识别（自动填入物流单号，可编辑）': '① Shipping Label Recognition (auto-fills tracking number, editable)',
  '② 工厂单据识别（自动匹配订单号 / 工厂单号）': '② Factory Document Recognition (auto-matches order/factory number)',
  '上传物流单': 'Upload Shipping Label',
  '个订单已生成发票，已自动过滤': ' orders already have invoices, auto-filtered',
  '仅已采购状态可标记已发货': 'Only purchased orders can be marked as shipped',
  '付款参考号': 'Payment Reference No.',
  '付款总金额': 'Total Payment Amount',
  '付款总额': 'Total Payment',
  '个设计项': ' design items',
  '以下设计项尚未选择：': 'The following design items are not selected:',
  '个面料': ' fabrics',
  '低库存': 'Low Stock',
  '保存面料耗量失败': 'Failed to Save Fabric Usage',
  '修改面料耗量': 'Edit Fabric Usage',
  '其它里布': 'Other Lining',
  '其它面料': 'Other Fabric',
  '一键复制成衣尺寸': 'Copy RTW Size with One Click',
  '删除后订单将从列表中移除，数据仍会保留': 'After deletion, order will be removed from list but data will be retained',
  '删除采购申请（管理员）': 'Delete Purchase Request (Admin)',
  '利润占比': 'Profit Share',
  '利润报表': 'Profit Report',
  '刷新缓存': 'Refresh Cache',
  '刺绣单价设置': 'Embroidery Price Setting',
  '刺绣类型': 'Embroidery Type',
  '刺绣配置': 'Embroidery Config',
  '刺绣颜色': 'Embroidery Color',
  '前端分类项绑定': 'Frontend Category Binding',
  '前端直接展示': 'Frontend Direct Display',
  '剩余总额': 'Remaining Total',
  '加价': 'Surcharge',
  '加入时间': 'Joined Date',
  '加工费(¥CNY)': 'Processing Fee (¥CNY)',
  '加收费': 'Extra Charge',
  '加收费(USD)': 'Extra Charge (USD)',
  '加放': 'Ease Allowance',
  '加载发票失败': 'Failed to Load Invoice',
  '加载销售价格表失败': 'Failed to Load Sales Price Table',
  '包含子品类': 'Including Sub-categories',
  '单品': 'Single Item',
  '即将对': 'About to',
  '参考号': 'Reference No.',
  '参考图片': 'Reference Image',
  '参考版型': 'Reference Pattern',
  '发票形式': 'Invoice Type',
  '发票形式：': 'Invoice Type:',
  '发票总额（USD）': 'Invoice Total (USD)',
  '发票状态': 'Invoice Status',
  '发货备注': 'Shipping Note',
  '发货录入成功': 'Shipping Record Added',
  '发货明细': 'Shipping Details',
  '发货确认失败': 'Shipping Confirmation Failed',
  '发货确认成功': 'Shipping Confirmation Successful',
  '取消/驳回原因': 'Cancel/Rejection Reason',
  '变动类型': 'Change Type',
  '变动金额': 'Change Amount',
  '变量': 'Variable',
  '口袋巾 (Pocket Square)': 'Pocket Square',
  '只能编辑草稿发票': 'Can only edit draft invoices',
  '可手工输入或点击下方候选': 'Can manually input or click candidate below',
  '可编辑': 'Editable',
  '可能额外收费': 'May incur extra charges',
  '可输入': 'Input Allowed',
  '可选': 'Optional',
  '可选，或粘贴面单图后自动识别': 'Optional, or paste shipping label for auto-recognition',
  '各自价格档': 'Individual Price Tier',
  '各订单付款金额之和不等于付款总金额': 'Sum of order payments does not equal total payment amount',
  '合格率': 'Pass Rate',
  '同步': 'Sync',
  '同步到线色号': 'Sync to Thread Color',
  '同步备注': 'Sync Note',
  '同步工厂状态': 'Sync Factory Status',
  '同步成功': 'Sync Successful',
  '同步成功，共同步 {count} 条颜色': 'Sync successful, {count} colors synced',
  '同步状态': 'Sync Status',
  '同步订单状态': 'Sync Order Status',
  '否': 'No',
  '命中': 'Matched',
  '品牌内样本册按排序号升序显示，越小越靠前': 'Swatch books sorted by order number in ascending order within brand',
  '品牌排序': 'Brand Sort Order',
  '品牌排序已保存': 'Brand Sort Order Saved',
  '品牌数': 'Brand Count',
  '品类代码': 'Category Code',
  '品类名称': 'Category Name',
  '品类映射': 'Category Mapping',
  '品类筛选': 'Category Filter',
  '品类管理': 'Category Management',
  '品类配置与价格': 'Category Config & Pricing',
  '售价': 'Selling Price',
  '售后单号': 'After-Sales No.',
  '售后沟通': 'After-Sales Communication',
  '商品列表': 'Product List',
  '商品创建成功': 'Product Created',
  '商品名称': 'Product Name',
  '商品图片': 'Product Images',
  '商品基础信息': 'Product Basic Info',
  '商品描述': 'Product Description',
  '回填失败': 'Backfill Failed',
  '回填审核成品尺寸': 'Backfill Reviewed Garment Size',
  '团队名称': 'Team Name',
  '固定默认值': 'Fixed Default Value',
  '国家': 'Country',
  '图标': 'Icon',
  '图片URL': 'Image URL',
  '图片地址': 'Image URL',
  '场景': 'Scenario',
  '基于面料库存 × 品类 × 工艺组合，实时计算销售价格': 'Calculate sales price in real-time based on fabric inventory × category × craft',
  '基础价': 'Base Price',
  '基础围度已完成': 'Base Girth Completed',
  '基础销售价': 'Base Sales Price',
  '基础销售价 = 促销固定价（优先）或 (归档面料单价 ÷ 汇率 × 耗料量 + 归档加工费(工厂端)¥CNY ÷ 汇率) × 毛利率': 'Base Sales Price = Promo Fixed Price (priority) or (Archived Fabric Unit Price ÷ Exchange Rate × Usage + Archived Processing Fee (Factory) ¥CNY ÷ Exchange Rate) × Markup Rate',
  '增加采购记录': 'Add Procurement Record',
  '处理中...': 'Processing...',
  '处理客户提交的售后申请与退换修服务': 'Process after-sales requests and return/repair services',
  '备注 & 图片': 'Notes & Images',
  '备注与特殊说明': 'Notes & Special Instructions',
  '备注信息（选填）': 'Notes (Optional)',
  '备注（交代事项）': 'Notes (Instructions)',
  '备注（选填）': 'Notes (Optional)',
  '备货/其它用途请前往「采购管理-申请采购」处理': 'For stocking/other purposes, go to Procurement Management - Request Purchase',
  '复制': 'Copy',
  '复制失败': 'Copy Failed',
  '点击复制': 'Click to Copy',
  '已复制': 'Copied',
  '加工商对账': 'Supplier Reconciliation',
  '加工商': 'Supplier',
  '对账单号': 'Recon No.',
  '结账状态': 'Settlement',
  '未结': 'Unsettled',
  '已结清': 'Settled',
  '部分结清': 'Partially Settled',
  '追加付款': 'Add Payment',
  '账单截图': 'Bill Images',
  '结账金额': 'Settle Amount',
  '汇总金额': 'Total Amount',
  '对账工费(USD)': 'Recon Fee (USD)',
  '工费金额(USD)': 'Processing Fee (USD)',
  '已结': 'Settled',
  '已结(USD)': 'Settled (USD)',
  '对账总额': 'Recon Total',
  '出货日期': 'Ship Date',
  '可粘贴/拖拽图片': 'Paste / drag images',
  '单号 / 门店': 'Order / Store',
  '工费金额': 'Processing Fee',
  '复审订单': 'Second Review Order',
  '复审驳回': 'Second Review Rejected',
  '多个用逗号分隔，如: JKT,TRS': 'Multiple values separated by commas, e.g.: JKT,TRS',
  '多级审核，确保订单准确': 'Multi-level review to ensure order accuracy',
  '多选项框（按来源选项数量生成）': 'Multi-select (generated by source option count)',
  '大批量优惠': 'Bulk Discount',
  '大肚体形': 'Large Belly Body Type',
  '失效日期': 'Expiry Date',
  '套装类型': 'Suit Type',
  '如 100% Wool': 'e.g. 100% Wool',
  '如 80.25': 'e.g. 80.25',
  '如 90.95': 'e.g. 90.95',
  '如 AW2024': 'e.g. AW2024',
  '如 FAB-001': 'e.g. FAB-001',
  '如 Navy Blue #000080': 'e.g. Navy Blue #000080',
  '如 Twill(K), Dobby': 'e.g. Twill(K), Dobby',
  '如 深藏青': 'e.g. Dark Navy',
  '如 经典系列 / 彩色系列': 'e.g. Classic Series / Color Series',
  '如: 100% Cotton, Merino Wool': 'e.g. 100% Cotton, Merino Wool',
  '如: 100-150': 'e.g. 100-150',
  '如: 38-45': 'e.g. 38-45',
  '如: Design Style': 'e.g. Design Style',
  '如: HALF_CANVAS, FULL_CANVAS': 'e.g. HALF_CANVAS, FULL_CANVAS',
  '如: HIGH-END': 'e.g. HIGH-END',
  '如: Hermès, Dunhill': 'e.g. Hermès, Dunhill',
  '如: JKT, TRS, SUIT_2P': 'e.g. JKT, TRS, SUIT_2P',
  '如: MILANESE, MONOGRAM': 'e.g. MILANESE, MONOGRAM',
  '如: PEAK_01': 'e.g. PEAK_01',
  '如: STYLISH/100': 'e.g. STYLISH/100',
  '如: SUIT_2P': 'e.g. SUIT_2P',
  '如: ["coat","pant"]': 'e.g. ["coat","pant"]',
  '如: ["measure_up","measure_down"]': 'e.g. ["measure_up","measure_down"]',
  '如: design_style': 'e.g. design_style',
  '如: warehouse / Factory A': 'e.g. warehouse / Factory A',
  '如: 个、件、字': 'e.g. piece, item, character',
  '如: 商务西装': 'e.g. Business Suit',
  '如: 客户姓名': 'e.g. Client Name',
  '如: 尖驳头': 'e.g. Peak Lapel',
  '如: 米兰眼、刺绣': 'e.g. Milanese Buttonhole, Embroidery',
  '如: 设计风格': 'e.g. Design Style',
  '如: 顾客姓名': 'e.g. Customer Name',
  '如: 高端': 'e.g. High-End',
  '如: 黑色、棕色': 'e.g. Black, Brown',
  '如: 黑色、白色': 'e.g. Black, White',
  '如员工误操作等': 'e.g. staff operational error',
  '如有不合格项，请说明原因': 'If any items fail inspection, please explain the reason',
  '如袖扣数量': 'e.g. sleeve button count',
  '如需修改请到订单页操作': 'To modify, please go to the order page',
  '如：S / M / L': 'e.g. S / M / L',
  '如：前衣长': 'e.g. Front Jacket Length',
  '如：基础款': 'e.g. Basic Style',
  '如：推荐': 'e.g. Recommended',
  '如：推送到照片反馈"刺绣xxx:颜色：xxx"': 'e.g. Push to photo feedback "Embroidery xxx: Color: xxx"',
  '字体颜色（线色号）': 'Font Color (Thread Color No.)',
  '字段代码': 'Field Code',
  '字段分类': 'Field Category',
  '字段映射': 'Field Mapping',
  '孟克鞋 (Monk)': 'Monk Shoes',
  '季节/年份': 'Season/Year',
  '完成日期': 'Completion Date',
  '完成率': 'Completion Rate',
  '审核和管理门店下的B端用户账号': 'Review and manage B2B user accounts under stores',
  '审核备注': 'Review Note',
  '审核尺寸': 'Review Measurements',
  '审核状态': 'Review Status',
  '审核门店付款及到账记录': 'Review store payment and receipt records',
  '客供': 'Client Supplied',
  '客供纽扣（CMT来料加工）：由客户自行提供纽扣，发票中纽扣费用为零，仅计工艺加工费。请填写每包纽扣的物流信息。': 'Client Supplied Buttons (CMT): Client provides buttons, invoice button cost is zero, only processing fee charged. Please fill in shipping info for each button package.',
  '客供里布（CMT来料加工）：由客户自行提供里布，发票中里布费用为零，仅计工艺加工费。请填写每块里布的物流信息。': 'Client Supplied Lining (CMT): Client provides lining, invoice lining cost is zero, only processing fee charged. Please fill in shipping info for each lining piece.',
  '客户信息': 'Client Info',
  '客户信息 & 款式设计': 'Client Info & Style Design',
  '客户列表': 'Client List',
  '客户已确认收货，订单流程已完结': 'Client confirmed receipt, order process completed',
  '客户成衣': 'Client RTW',
  '客户档案保存失败，请重试': 'Failed to save client profile, please retry',
  '客户详情功能开发中': 'Client Details Feature In Development',
  '客服': 'Customer Service',
  '密码至少6位': 'Password must be at least 6 characters',
  '密码重置成功': 'Password Reset Successful',
  '对初审通过订单进行技术复核，确认量体数据与工艺要求': 'Technical review of first-approved orders, confirm measurement data and craft requirements',
  '对应前端左侧导航的二级分类（如驳头型、肩型等），可配置排序和默认显示状态': 'Corresponds to frontend left navigation sub-categories (e.g. lapel, shoulder type), configurable sorting and default display',
  '对应文件：JD-HP推送映射完整对照表-Final.xlsx（旧版）': 'Corresponding file: JD-HP Push Mapping Complete Table-Final.xlsx (old version)',
  '对应文件：JD设计选项V1.6.4.xlsx（当前版本）': 'Corresponding file: JD Design Options V1.6.4.xlsx (current version)',
  '对接 HP 系统使用的名称，为空则同部位名': 'Name used for HP system integration, defaults to measurement part name if empty',
  '对提交订单进行初步审核，确认信息完整性与规范性': 'Preliminary review of submitted orders, confirm information completeness and compliance',
  '对订单价格与支付信息进行财务审核确认': 'Financial review of order pricing and payment information',
  '导入Excel': 'Import Excel',
  '导入历史': 'Import History',
  '导入失败': 'Import Failed',
  '导入成功': 'Import Successful',
  '导出失败': 'Export Failed',
  '导出失败：': 'Export Failed:',
  '导出成功': 'Export Successful',
  '导出报表': 'Export Report',
  '导出日志': 'Export Log',
  '封面图': 'Cover Image',
  '封面图片': 'Cover Image',
  '将审核通过的订单推送至工厂生产系统': 'Push approved orders to factory production system',
  '将第一个选项同步到其它选项': 'Sync first option to other options',
  '尖驳头': 'Peak Lapel',
  '尺寸加放推算': 'Size Ease Allowance Calculation',
  '尺码范围': 'Size Range',
  '展开导航': 'Expand Navigation',
  '展开设计项后可为选项设置工艺代码，支持批量设置': 'Expand design items to set craft codes for options, batch setting supported',
  '展示推送失败、审核驳回及已取消的异常订单': 'Display failed push, review rejected, and cancelled abnormal orders',
  '工厂API配置已更新': 'Factory API Config Updated',
  '工厂ID': 'Factory ID',
  '工厂、门店、物流信息实时更新': 'Factory, store, and shipping info updated in real-time',
  '工厂字段': 'Factory Field',
  '工厂字段显示名': 'Factory Field Display Name',
  '工厂成本 (USD)': 'Factory Cost (USD)',
  '工厂料号': 'Factory Material No.',
  '工厂料名': 'Factory Material Name',
  '工厂来货物流单号': 'Factory Inbound Tracking No.',
  '工艺为空 = 该品类所有工艺通配；指定工艺 = 仅对该品类+工艺组合生效': 'Empty craft = applies to all crafts in this category; specified craft = only applies to this category + craft combination',
  '工艺代码': 'Craft Code',
  '工艺单': 'Craft Sheet',
  '工艺单已导出': 'Craft Sheet Exported',
  '工艺成本': 'Craft Cost',
  '工艺映射': 'Craft Mapping',
  '工艺映射管理': 'Craft Mapping Management',
  '工艺说明': 'Craft Notes',
  '工艺（空=通配该品类所有工艺）': 'Craft (empty = applies to all crafts)',
  '工艺（空=通配）': 'Craft (empty = wildcard)',
  '已': '',
  '已付完': 'Fully Paid',
  '已付金额 (USD)': 'Paid Amount (USD)',
  '已作废的发票无法编辑': 'Voided invoices cannot be edited',
  '已停用': 'Disabled',
  '已入库': 'Stocked In',
  '已分配权限': 'Permissions Assigned',
  '已勾选': 'Selected',
  '已发货待客户确认收货的订单': 'Shipped orders awaiting client receipt confirmation',
  '已启用': 'Enabled',
  '已回填审核成衣尺寸': 'Reviewed garment size backfilled',
  '已复制成衣尺寸到审核列': 'RTW size copied to review column',
  '已复制订单': 'Order Copied',
  '已复用客户信息': 'Client info reused',
  '已复用款式信息': 'Style info reused',
  '已撤回': 'Withdrawn',
  '已更新': 'Updated',
  '已标记已采购': 'Marked as Purchased',
  '已用额度 (USD)': 'Used Credit (USD)',
  '已禁用': 'Disabled',
  '已绑定共享设计项': 'Shared design item bound',
  '已自动识别单号': 'Tracking number auto-recognized',
  '已转入发票工具，请挑选订单绑定后生成草稿发票': 'Transferred to Invoice Tool, please select orders and generate draft invoice',
  '已选择 {{count}} 个目标设计项，将同步仓库中的选项到目标设计项，重复编码的选项将自动跳过': 'Selected {{count}} target design items, will sync warehouse options to targets, duplicate codes will be skipped',
  '已选择现款设计': 'Cash design selected',
  '已重置为默认主题': 'Reset to default theme',
  '已重置为默认配置': 'Reset to default config',
  '幅宽': 'Width',
  '库存': 'Stock',
  '库存数量': 'Stock Quantity',
  '开始导入': 'Start Import',
  '异常状态': 'Abnormal Status',
  '归属门店': 'Assigned Store',
  '归档加工费(工厂端)': 'Archived Processing Fee (Factory)',
  '归档加工费（工厂端）：工厂实际收取的加工费，单位 ¥CNY，按品类+工艺组合定价，用于标准报价公式计算基础销售价': 'Archived Processing Fee (Factory): Actual processing fee charged by factory, in ¥CNY, priced by category + craft, used in standard pricing formula',
  '归类单价(CNY)': 'Classified Unit Price (CNY)',
  '当前仅支持一种刺绣类型：文字 + 参考图片。B 端下单时需同时填写绣字内容并上传参考图片。': 'Currently only one embroidery type supported: Text + Reference Image. B2B orders require both embroidery text and reference image.',
  '当前估算价格': 'Current Estimated Price',
  '当前品类没有可复制的成衣尺寸': 'No RTW sizes available to copy for this category',
  '当前继承上衣客供面料': 'Currently inheriting jacket client-supplied fabric',
  '当前订单保存为草稿时才可以生成 AI预览图，是否保存？': 'AI preview can only be generated when order is saved as draft. Save now?',
  '当前额度': 'Current Credit',
  '当订单已发放提成后发生以下情况，系统自动追回或扣减': 'When the following occurs after commission is paid, system will auto-recover or deduct',
  '录入发货信息': 'Enter Shipping Info',
  '录入工厂来货': 'Record Factory Inbound',
  '录入质检记录': 'Record QC Inspection',
  '待付总额': 'Total Amount Due',
  '待付款总额': 'Total Pending Payment',
  '待付款金额': 'Pending Payment Amount',
  '德比鞋 (Derby)': 'Derby Shoes',
  '德邦': 'Deppon',
  '总成本': 'Total Cost',
  '总营收': 'Total Revenue',
  '总计': 'Total',
  '总金额': 'Total Amount',
  '总金额合计': 'Total Amount (All)',
  '共 {n} 张': '{n} invoices',
  '恢复自动': 'Restore Auto',
  '您的账号尚未通过门店审核，暂时无法下单': 'Your account has not been approved by the store yet, cannot place orders',
  '成员数': 'Member Count',
  '成本(USD)': 'Cost (USD)',
  '成本价': 'Cost Price',
  '成本基准价': 'Cost Base Price',
  '成本报表': 'Cost Report',
  '成衣分类': 'RTW Category',
  '成衣商城管理': 'RTW Mall Management',
  '所属分类': 'Category',
  '所属设计项': 'Design Item',
  '所属项': 'Parent Item',
  '所有比例、阶梯阈值均支持后台配置，可随时调整。修改后点击"保存配置"生效，配置持久化到数据库并记录修改日志。': 'All ratios and tier thresholds are configurable in backend. Click "Save Config" to apply, configurations are persisted to database with modification logs.',
  '所选订单均已生成发票': 'All selected orders already have invoices',
  '所选采购单供应商不一致，无法批量修改供应商': 'Selected purchase orders have different suppliers, cannot batch modify',
  '打开分享链接': 'Open Sharing Link',
  '打开详情页': 'Open Details',
  '扣减规则': 'Deduction Rules',
  '执行时机': 'Execution Timing',
  '批量': 'Batch',
  '批量付款': 'Batch Payment',
  '批量付款备注': 'Batch Payment Note',
  '批量付款失败': 'Batch Payment Failed',
  '批量付款成功': 'Batch Payment Successful',
  '批量优惠': 'Batch Discount',
  '批量修改供应商': 'Batch Modify Supplier',
  '批量入库': 'Batch Stock In',
  '批量入库成功': 'Batch Stock In Successful',
  '批量出库': 'Batch Stock Out',
  '批量出库成功': 'Batch Stock Out Successful',
  '批量同步': 'Batch Sync',
  '批量同步完成': 'Batch Sync Complete',
  '批量导入': 'Batch Import',
  '批量撤销入库': 'Batch Undo Stock In',
  '批量撤销出库': 'Batch Undo Stock Out',
  '批量采购': 'Batch Procurement',
  '批量采购分享成功': 'Batch Procurement Sharing Successful',
  '批量采购分享链接': 'Batch Procurement Sharing Link',
  '批量采购单号': 'Batch Procurement No.',
  '批量采购只能选择相同供应商的采购单': 'Batch procurement only supports same supplier',
  '批量采购失败': 'Batch Procurement Failed',
  '折 / ': ' Off / ',
  '折扣单价': 'Discounted Unit Price',
  '折扣审批模拟可在「折扣审批」页面测试': 'Discount approval simulation available on Discount Approval page',
  '折扣率': 'Discount Rate',
  '折扣说明': 'Discount Description',
  '报价单数据为空（items_snapshot 缺失）': 'Quote data is empty (items_snapshot missing)',
  '报价编号': 'Quote No.',
  '报表导出成功': 'Report Export Successful',
  '抽检总数': 'Total Inspected',
  '抽检结果': 'Inspection Result',
  '拼图': 'Collage',
  '拼图模板': 'Collage Template',
  '指定适用品类，多选': 'Specify applicable categories, multi-select',
  '指定部位': 'Specified Part',
  '按品类合并': 'Merge by Category',
  '按年分组': 'Group by Year',
  '按类型查看': 'View by Type',
  '按钮文字': 'Button Text',
  '换算公式': 'Conversion Formula',
  '排序号': 'Sort Order',
  '接口对接管理': 'API Integration Management',
  '推送失败重试': 'Retry Failed Push',
  '推送待确认': 'Push Pending Confirmation',
  '推送方式': 'Push Method',
  '推送至HP时，哪些工艺选项需要在此品类组合中额外推送': 'When pushing to HP, which craft options need additional push in this category combination',
  '推送配置': 'Push Configuration',
  '提交初审': 'Submit First Review',
  '提交成功': 'Submit Successful',
  '提交日期': 'Submit Date',
  '提成计算器(模拟)': 'Commission Calculator (Simulation)',
  '搜索品牌名': 'Search Brand Name',
  '搜索工厂名': 'Search Factory Name',
  '搜索物料': 'Search Material',
  '搜索纽扣': 'Search Button',
  '搜索里布': 'Search Lining',
  '搜索面料': 'Search Fabric',
  '搜索面料编号': 'Search Fabric Code',
  '搜索颜色名': 'Search Color Name',
  '撤回': 'Withdraw',
  '撤回全部': 'Withdraw All',
  '撤回失败': 'Withdraw Failed',
  '撤回成功': 'Withdraw Successful',
  '撤销': 'Undo',
  '撤销入库': 'Undo Stock In',
  '撤销入库成功': 'Undo Stock In Successful',
  '撤销出库': 'Undo Stock Out',
  '撤销出库成功': 'Undo Stock Out Successful',
  '撤销成功': 'Undo Successful',
  '收件人': 'Recipient',
  '收货数量': 'Received Quantity',
  '收费类型': 'Charge Type',
  '收费项': 'Charge Item',
  '收费项名称': 'Charge Item Name',
  '收费项管理': 'Charge Item Management',
  '敬请期待': 'Coming Soon',
  '数据类型': 'Data Type',
  '文字颜色': 'Text Color',
  '斜纹': 'Twill',
  '新密码': 'New Password',
  '新增工厂': 'Add Factory',
  '新增工艺': 'Add Craft',
  '新增打印模版': 'Add Print Template',
  '新增批量折扣': 'Add Bulk Discount',
  '新增收货': 'Add Receipt',
  '新增收费项': 'Add Charge Item',
  '新增映射': 'Add Mapping',
  '新增服装': 'Add Garment',
  '新增样本册': 'Add Swatch Book',
  '新增档位': 'Add Tier',
  '新增模版': 'Add Template',
  '新增毛利率配置': 'Add Markup Rate Config',
  '新增消费者': 'Add Consumer',
  '新增物料供应商': 'Add Material Supplier',
  '新增特征项': 'Add Feature Item',
  '新增用户': 'Add User',
  '新增皮鞋': 'Add Leather Shoes',
  '新增短信模版': 'Add SMS Template',
  '新增纽扣': 'Add Button',
  '新增线号': 'Add Thread Color',
  '新增角色': 'Add Role',
  '新增设计选项': 'Add Design Option',
  '新增设计项': 'Add Design Item',
  '新增词条': 'Add Entry',
  '新增质检记录': 'Add QC Record',
  '新增选项': 'Add Option',
  '新增选项值': 'Add Option Value',
  '新增邮件模版': 'Add Email Template',
  '新增配置类型': 'Add Config Type',
  '新增配饰': 'Add Accessory',
  '新增里布': 'Add Lining',
  '新增门店': 'Add Store',
  '新增面料': 'Add Fabric',
  '新增面料映射': 'Add Fabric Mapping',
  '新增颜色': 'Add Color',
  '新增高度': 'Add Height',
  '新备注': 'New Note',
  '新建': 'Create',
  '新建物料供应商': 'Create Material Supplier',
  '新建角色': 'Create Role',
  '新建采购单': 'Create Purchase Order',
  '新额度': 'New Credit Limit',
  '无关联订单': 'No Linked Orders',
  '无明细': 'No Details',
  '无法创建的采购项': 'Unable to Create Purchase Items',
  '无采购记录': 'No Procurement Records',
  '无需发票': 'No Invoice Needed',
  '日期': 'Date',
  '时区': 'Timezone',
  '时间范围：': 'Time Range:',
  '明细': 'Details',
  '是': 'Yes',
  '是否将该成员从团队中移除？': 'Remove this member from the team?',
  '是否组合': 'Is Combination',
  '显示模式': 'Display Mode',
  '普票': 'General Invoice',
  '普通成员': 'Regular Member',
  '智能审核系统': 'Intelligent Review System',
  '暂无余额变动记录': 'No Balance Change Records',
  '暂无关联订单': 'No Linked Orders',
  '暂无分类': 'No Categories',
  '暂无刺绣配置': 'No Embroidery Config',
  '暂无审核备注': 'No Review Notes',
  '暂无成员': 'No Members',
  '暂无明细': 'No Details',
  '暂无标签': 'No Tags',
  '暂无样本册数据': 'No Swatch Book Data',
  '暂无消息，开始沟通吧': 'No messages yet, start a conversation',
  '暂无设计项，请点击「从预设初始化」或「新增设计项」': 'No design items, click "Initialize from Preset" or "Add Design Item"',
  '暂无账号数据': 'No Account Data',
  '暂无选项': 'No Options',
  '暂无选项类型': 'No Option Types',
  '暂无配置': 'No Configuration',
  '暂无采购记录': 'No Procurement Records',
  '暂无量体数据': 'No Measurement Data',
  '暂无面料': 'No Fabrics',
  '更多设计项': 'More Design Items',
  '更多（需点击展开）': 'More (click to expand)',
  '更新': 'Update',
  '更新成功': 'Update Successful',
  '最低价(CNY)': 'Min Price (CNY)',
  '最低套数': 'Min Quantity',
  '最后入库': 'Last Stock In',
  '最后出库': 'Last Stock Out',
  '最大数量': 'Max Quantity',
  '最小数量': 'Min Quantity',
  '最终价格以发票为准': 'Final price subject to invoice',
  '最高价(CNY)': 'Max Price (CNY)',
  '最高套数': 'Max Quantity',
  '月度目标 (USD)': 'Monthly Target (USD)',
  '未付': 'Unpaid',
  '未付完': 'Partially Paid',
  '未付款总金额': 'Total Unpaid Amount',
  '未付金额 (USD)': 'Unpaid Amount (USD)',
  '未作废': 'Not Voided',
  '未分类': 'Uncategorized',
  '未分配门店': 'Unassigned Store',
  '未匹配到任何待入库订单，请核对识别结果': 'No pending inbound orders matched, please verify recognition result',
  '未匹配到待入库订单': 'No pending inbound orders matched',
  '未启用': 'Not Enabled',
  '未知错误': 'Unknown Error',
  '未识别到候选号码': 'No candidate numbers recognized',
  '未选择门店': 'No Store Selected',
  '未采购': 'Not Purchased',
  '本地字段': 'Local Field',
  '本地字段显示名': 'Local Field Display Name',
  '本地工艺项': 'Local Craft Item',
  '本地工艺项 [编码]': 'Local Craft Item [Code]',
  '本地工艺项名': 'Local Craft Item Name',
  '本地选项中文名': 'Local Option Chinese Name',
  '本地选项名': 'Local Option Name',
  '本地选项编码': 'Local Option Code',
  '本批次采购单已全部完成采购或发货': 'All purchase orders in this batch have been completed or shipped',
  '本次付款': 'This Payment',
  '本次付款合计': 'This Payment Total',
  '本订单历史采购记录': 'Order Purchase History',
  '本页': 'This Page',
  '权限不足，无法操作': 'Insufficient permissions',
  '权限矩阵': 'Permission Matrix',
  '权限矩阵功能开发中': 'Permission Matrix Feature In Development',
  '条件推送': 'Conditional Push',
  '条申请失败': ' requests failed',
  '条采购申请': ' purchase requests',
  '来源选项中决定数量的字段名，默认 linkage_count': 'Field name in source option that determines quantity, default: linkage_count',
  '枚举映射示例: {"mappings":{"顺丰快递":"顺丰"}}': 'Enum mapping example: {"mappings":{"SF Express":"SF"}}',
  '固定值示例: {"value":"xxx"}': 'Fixed value example: {"value":"xxx"}',
  '查看/编辑': 'View/Edit',
  '查看业务员销售业绩统计': 'View sales performance statistics',
  '查看全部订单': 'View All Orders',
  '查看利润统计及趋势': 'View profit statistics and trends',
  '查看团队关联的订单列表': 'View team-related order list',
  '查看成本分析及利润数据': 'View cost analysis and profit data',
  '查看订单统计及分析': 'View order statistics and analysis',
  '查看订单详情': 'View Order Details',
  '查看链接': 'View Link',
  '查看销售数据统计及趋势分析': 'View sales data statistics and trend analysis',
  '查看门店详细信息及订单记录': 'View store details and order records',
  '查询失败': 'Query Failed',
  '标码': 'Standard Size',
  '标签': 'Tag',
  '标签名称': 'Tag Name',
  '标签筛选': 'Filter by Tag',
  '标签配置': 'Tag Configuration',
  '标记失败': 'Mark Failed',
  '标记已发货': 'Mark as Shipped',
  '标记已采购': 'Mark as Purchased',
  '标记成功': 'Mark Successful',
  '标记生产完成': 'Mark Production Complete',
  '样册': 'Swatch Book',
  '样本册名称': 'Swatch Book Name',
  '样本册数': 'Swatch Book Count',
  '样本册管理': 'Swatch Book Management',
  '样本册配置': 'Swatch Book Configuration',
  '核对': 'Verify',
  '核对人': 'Verified By',
  '核对状态': 'Verification Status',
  '模块': 'Module',
  '模板配置': 'Template Configuration',
  '模糊搜索门店编号/订单号/客户名': 'Search by store code/order number/client name',
  '欢迎回来': 'Welcome Back',
  '款式': 'Style',
  '款面料': ' fabric(s)',
  '正在生成...': 'Generating...',
  '正常门店': 'Active Store',
  '正数增加, 负数减少': 'Positive to increase, negative to decrease',
  '此订单采购记录': 'Order Procurement Records',
  '毛利 (USD)': 'Gross Profit (USD)',
  '毛利润': 'Gross Profit',
  '毛利率支持按《品类》或《品类+工艺》组合配置，精确匹配优先于品类通配': 'Markup rate supports category or category + craft configuration, exact match takes priority',
  '毛利率配置': 'Markup Rate Configuration',
  '毛利率（如 1.4 = 40%）': 'Markup Rate (e.g. 1.4 = 40%)',
  '毛衣/针织衫': 'Sweater/Knitwear',
  '汇率、裂变奖励、人力成本红线等全局参数': 'Global parameters: exchange rate, referral bonus, labor cost threshold, etc.',
  '注意：撤销后将删除对应的出入库记录': 'Note: Undo will delete corresponding stock in/out records',
  '注：若当月提成不足以扣减，顺延至下月，直至扣完为止。系统需记录扣减明细。': 'Note: If monthly commission is insufficient for deduction, it will be carried forward to the next month until fully deducted. System records deduction details.',
  '消费者姓名': 'Consumer Name',
  '涉及': 'Involves',
  '添加': 'Add',
  '添加 Item': 'Add Item',
  '添加刺绣': 'Add Embroidery',
  '添加备注条目': 'Add Note Entry',
  '添加子项': 'Add Sub-item',
  '添加新的量体说明或客户特殊偏好...': 'Add measurement notes or client special preferences...',
  '添加特体': 'Add Body Feature',
  '添加纽扣': 'Add Button',
  '添加订单': 'Add Order',
  '添加货物明细': 'Add Cargo Details',
  '添加选项值': 'Add Option Value',
  '添加里布': 'Add Lining',
  '添加面料': 'Add Fabric',
  '清理旧日志': 'Clean Old Logs',
  '清除筛选': 'Clear Filters',
  '清除选择': 'Clear Selection',
  '点击展开查看历史版本': 'Click to expand and view history',
  '点击此区域后 Ctrl+V 粘贴工厂单图片，或用下方按钮上传': 'Click this area then Ctrl+V to paste factory document image, or use button below to upload',
  '点击此区域后 Ctrl+V 粘贴物流单图片，或用下方按钮上传': 'Click this area then Ctrl+V to paste shipping label image, or use button below to upload',
  '照片反馈': 'Photo Feedback',
  '照片反馈模板': 'Photo Feedback Template',
  '照片反馈模板内容': 'Photo Feedback Template Content',
  '父品类': 'Parent Category',
  '父品类代码': 'Parent Category Code',
  '牛津鞋 (Oxford)': 'Oxford Shoes',
  '物料ID': 'Material ID',
  '物料信息': 'Material Info',
  '物料成本': 'Material Cost',
  '物料类别': 'Material Type',
  '物流/关税': 'Shipping/Tariff',
  '物流公司（选填）': 'Shipping Company (Optional)',
  '物流单号（可选）': 'Tracking No. (Optional)',
  '物流单号（识别后自动填入，可修改）': 'Tracking No. (auto-filled after recognition, editable)',
  '物流单号（选填 / 可由下方图片识别或手工输入）': 'Tracking No. (optional / auto-recognized from image or manual input)',
  '物流单号（选填）': 'Tracking No. (Optional)',
  '物流备注': 'Shipping Note',
  '物流成本': 'Shipping Cost',
  '物流状态同步成功': 'Shipping Status Synced',
  '物流要求': 'Shipping Requirements',
  '物流要求：': 'Shipping Requirements:',
  '物流跟踪单号': 'Shipping Tracking No.',
  '物流面单图': 'Shipping Label Image',
  '特征分类': 'Feature Category',
  '特征项': 'Feature Item',
  '特征项名称': 'Feature Item Name',
  '特征项描述': 'Feature Item Description',
  '特征项英文名': 'Feature Item English Name',
  '生产中的订单': 'Orders in Production',
  '生产单号': 'Production No.',
  '生成AI预览图': 'Generate AI Preview',
  '生成报价单失败': 'Failed to Generate Quote',
  '生成时间': 'Generated Time',
  '生成正式发票': 'Generate Final Invoice',
  '生成草稿发票': 'Generate Draft Invoice',
  '生效日期': 'Effective Date',
  '用途': 'Purpose',
  '申请日期': 'Application Date',
  '申请记录': 'Application Records',
  '电子邮箱': 'Email',
  '皮带 (Belt)': 'Belt',
  '确认 & 提交': 'Confirm & Submit',
  '确认付款': 'Confirm Payment',
  '确认修改': 'Confirm Edit',
  '确认删除?': 'Confirm Delete?',
  '确认删除此选项？': 'Confirm delete this option?',
  '确认删除订单': 'Confirm Delete Order',
  '确认删除采购申请记录': 'Confirm delete purchase request record',
  '确认将该订单标记为生产完成？': 'Confirm mark this order as production complete?',
  '确认撤回': 'Confirm Withdraw',
  '确认撤回采购单': 'Confirm withdraw purchase order',
  '确认撤销': 'Confirm Undo',
  '确认移除': 'Confirm Remove',
  '礼服/晚装': 'Formal/Evening Wear',
  '移除失败': 'Remove Failed',
  '移除成功': 'Remove Successful',
  '第': 'No.',
  '等': 'etc.',
  '等级代码': 'Level Code',
  '等级名称': 'Level Name',
  '筛选条件': 'Filter Criteria',
  '管理B端客户信息、前端分类、体型特征、刺绣配置与设计尺寸': 'Manage B2B client info, frontend categories, body features, embroidery config and design measurements',
  '管理CMT来料加工费（对门店）、RTW折扣、毛利率等定价参数': 'Manage CMT processing fees (for store), RTW discounts, markup rates and other pricing parameters',
  '管理产品相关基础数据': 'Manage product-related base data',
  '管理前端展示分类': 'Manage frontend display categories',
  '管理合作门店信息及关联数据': 'Manage partner store info and related data',
  '管理员：点击价格单元格可设置促销固定价': 'Admin: Click price cell to set promotional fixed price',
  '管理团队信息、负责人及成员': 'Manage team info, managers and members',
  '管理团队成员，分配角色': 'Manage team members and assign roles',
  '管理工厂信息及API对接配置': 'Manage factory info and API integration config',
  '管理工厂来货收货及质检': 'Manage factory inbound receiving and QC',
  '管理成衣分类与商品': 'Manage RTW categories and products',
  '管理成衣质检及问题记录': 'Manage RTW QC inspection and issue records',
  '管理所有MTM定制订单，审核、推送、跟踪生产进度': 'Manage all MTM custom orders, review, push, and track production progress',
  '管理服装工艺类型及参数': 'Manage garment craft types and parameters',
  '管理本地设计选项与 HP 工厂工艺编码的推送映射关系': 'Manage push mapping between local design options and HP factory craft codes',
  '管理标签': 'Manage Tags',
  '管理物料供应商信息': 'Manage material supplier info',
  '管理系统多语言词条及默认语言配置': 'Manage system multilingual entries and default language config',
  '管理系统用户及角色分配': 'Manage system users and role assignments',
  '管理系统角色及权限分配': 'Manage system roles and permission assignments',
  '管理系统邮件、短信及打印模板': 'Manage system email, SMS, and print templates',
  '管理订单发票信息': 'Manage order invoice info',
  '管理订单发货及物流跟踪': 'Manage order shipping and logistics tracking',
  '管理选项类型': 'Manage Option Types',
  '管理门店消费者信息': 'Manage store consumer info',
  '管理门店账单及结算': 'Manage store bills and settlements',
  '管理面料及辅料采购申请流程': 'Manage fabric and material procurement request workflow',
  '管理面料基础信息及图片': 'Manage fabric base info and images',
  '管理面料编号、价格档、品牌信息': 'Manage fabric codes, price tiers, and brand info',
  '纽扣 ID': 'Button ID',
  '纽扣名称': 'Button Name',
  '纽扣品牌': 'Button Brand',
  '纽扣幅宽（cm）': 'Button Width (cm)',
  '纽扣管理': 'Button Management',
  '纽扣纹路': 'Button Pattern',
  '纽扣编号': 'Button Code',
  '组合': 'Combination',
  '组合ID': 'Combination ID',
  '组合分组ID（composite 时填，0=不分组）': 'Combination Group ID (for composite, 0 = no group)',
  '组合品类时填写，多个用逗号分隔，如: JKT,TRS': 'Fill for combination categories, multiple separated by commas, e.g.: JKT,TRS',
  '组合推送': 'Combination Push',
  '组长': 'Team Leader',
  '终审通过': 'Final Review Approved',
  '终审驳回': 'Final Review Rejected',
  '绑定共享设计项': 'Bind Shared Design Item',
  '绑定失败': 'Binding Failed',
  '绑定成功': 'Binding Successful',
  '统一价格档': 'Unified Price Tier',
  '绣字': 'Embroidery Text',
  '绣字内容': 'Embroidery Content',
  '缓存已刷新': 'Cache Refreshed',
  '编码': 'Code',
  '编码和中文名为必填项': 'Code and Chinese name are required',
  '编辑一级类型': 'Edit Level 1 Type',
  '编辑二级类型': 'Edit Level 2 Type',
  '编辑供应商': 'Edit Supplier',
  '编辑信息': 'Edit Info',
  '编辑分类': 'Edit Category',
  '编辑刺绣设计': 'Edit Embroidery Design',
  '编辑发票': 'Edit Invoice',
  '编辑品类': 'Edit Category',
  '编辑品类映射': 'Edit Category Mapping',
  '编辑商品': 'Edit Product',
  '编辑团队': 'Edit Team',
  '编辑字体': 'Edit Font',
  '编辑字段映射': 'Edit Field Mapping',
  '编辑尺寸项': 'Edit Size Item',
  '编辑工厂': 'Edit Factory',
  '编辑工艺': 'Edit Craft',
  '编辑收费项': 'Edit Charge Item',
  '编辑映射': 'Edit Mapping',
  '编辑服装': 'Edit Garment',
  '编辑样本册': 'Edit Swatch Book',
  '编辑档位': 'Edit Tier',
  '编辑模版': 'Edit Template',
  '编辑消费者': 'Edit Consumer',
  '编辑特征项': 'Edit Feature Item',
  '编辑用户': 'Edit User',
  '编辑皮鞋': 'Edit Leather Shoes',
  '编辑纽扣': 'Edit Button',
  '编辑线号': 'Edit Thread Color',
  '编辑草稿发票，修改后保存或转为正式发票': 'Edit draft invoice, save or convert to final invoice',
  '编辑角色': 'Edit Role',
  '编辑设计项': 'Edit Design Item',
  '编辑词条': 'Edit Entry',
  '编辑选项值': 'Edit Option Value',
  '编辑配置类型': 'Edit Config Type',
  '编辑配饰': 'Edit Accessory',
  '编辑里布': 'Edit Lining',
  '编辑门店信息': 'Edit Store Info',
  '编辑面料': 'Edit Fabric',
  '编辑面料映射': 'Edit Fabric Mapping',
  '编辑颜色': 'Edit Color',
  '编辑高度': 'Edit Height',
  '缝线管理': 'Thread Management',
  '缩略图URL': 'Thumbnail URL',
  '缩略图地址，为空则使用图片URL': 'Thumbnail URL, uses image URL if empty',
  '耗料(米)': 'Fabric Usage (m)',
  '耗量(米)': 'Usage (m)',
  '联动数量': 'Linked Quantity',
  '联动来源设计项编码': 'Linked Source Design Item Code',
  '联动模式': 'Linkage Mode',
  '肩斜度需复核': 'Shoulder slope needs review',
  '背带 (Suspenders)': 'Suspenders',
  '背心': 'Vest',
  '自动均分': 'Auto Distribute',
  '自动报价': 'Auto Quote',
  '自动：小计×0.045+0.3': 'Auto: Subtotal × 0.045 + 0.3',
  '自定义系统界面风格及显示效果': 'Customize system UI style and display',
  '自定义部位': 'Custom Part',
  '色值': 'Color Value',
  '英文名': 'English Name',
  '英文标签': 'English Label',
  '英语名': 'English Name',
  '获取成本数据失败': 'Failed to Get Cost Data',
  '衬衣领围': 'Shirt Collar Size',
  '袖扣 (Cufflinks)': 'Cufflinks',
  '规则配置': 'Rule Configuration',
  '规档面料价格': 'Classified Fabric Price',
  '角色代码': 'Role Code',
  '角色列表': 'Role List',
  '角色权限管理': 'Role Permission Management',
  '触发条件（JD工艺项 = 选项）': 'Trigger Condition (JD Craft Item = Option)',
  '计算结果': 'Calculation Result',
  '订单不存在或加载失败': 'Order does not exist or failed to load',
  '订单全流程管理': 'Order Full Process Management',
  '订单号（客户名称）': 'Order No. (Client Name)',
  '订单总数': 'Total Orders',
  '订单推送': 'Order Push',
  '订单数': 'Order Count',
  '订单编号 / 客户姓名 / 门店号': 'Order No. / Client Name / Store Code',
  '订单量体数据': 'Order Measurement Data',
  '订单金额 (USD)': 'Order Amount (USD)',
  '记录系统中所有用户的操作行为，可用于审计和问题追踪': 'Record all user actions in system for audit and issue tracking',
  '记录详情': 'Record Details',
  '设计尺寸配置': 'Design Size Configuration',
  '设计管理': 'Design Management',
  '设计选项配置': 'Design Option Configuration',
  '设计项': 'Design Item',
  '设计项加载中，请稍候': 'Loading design items, please wait',
  '访问密码': 'Access Password',
  '识别候选（点击填入）': 'Recognition Candidates (click to fill)',
  '识别到的所有候选（绿√=已匹配到订单）': 'All recognized candidates (green √ = matched to order)',
  '识别失败': 'Recognition Failed',
  '该品类的净体尺寸为空，无法推算': 'Body measurements for this category are empty, cannot calculate',
  '该用途请前往「采购管理-申请采购」处理': 'For this purpose, go to Procurement Management - Request Purchase',
  '该订单全部采购明细': 'All procurement details for this order',
  '该订单历史采购记录': 'Order procurement history',
  '该设计项下共': 'This design item has',
  '详情': 'Details',
  '详细地址': 'Detailed Address',
  '语言设置': 'Language Settings',
  '说明': 'Description',
  '说明：': 'Note:',
  '请供应商填写并确认发货': 'Supplier to fill in and confirm shipment',
  '请先分配门店': 'Please assign a store first',
  '请先推算预览': 'Please calculate preview first',
  '请先选择': 'Please select first',
  '请先选择产品品类': 'Please select product category first',
  '请先选择供应商': 'Please select a supplier first',
  '请先选择团队': 'Please select a team first',
  '请勾选至少一个订单': 'Please select at least one order',
  '请完善客户信息': 'Please complete client information',
  '请完善必填信息': 'Please complete required fields',
  '请把链接发送给供应商，供应商打开链接后可以查看合并后的采购单。': 'Send the link to supplier. Supplier can view the merged purchase order by opening the link.',
  '请把链接和密码发送给供应商，供应商打开链接后可以确认发货。': 'Send the link and password to supplier. Supplier can confirm shipment by opening the link.',
  '请登录您的管理后台账户': 'Please log in to your admin account',
  '请确认密码': 'Please confirm password',
  '请至少勾选一项订单': 'Please select at least one order',
  '请至少选择一个采购单': 'Please select at least one purchase order',
  '请输入付款总金额': 'Please enter total payment amount',
  '请输入付款总金额并勾选订单': 'Please enter total payment amount and select orders',
  '请输入供应商名称': 'Please enter supplier name',
  '请输入初始密码': 'Please enter initial password',
  '请输入单位': 'Please enter unit',
  '请输入名称': 'Please enter name',
  '请输入品牌': 'Please enter brand',
  '请输入品类代码': 'Please enter category code',
  '请输入商品名称': 'Please enter product name',
  '请输入商品描述': 'Please enter product description',
  '请输入团队名称': 'Please enter team name',
  '请输入备注': 'Please enter notes',
  '请输入字段代码': 'Please enter field code',
  '请输入工厂单号': 'Please enter factory order number',
  '请输入工厂名称': 'Please enter factory name',
  '请输入工艺代码': 'Please enter craft code',
  '请输入收件人': 'Please enter recipient',
  '请输入收件地址': 'Please enter shipping address',
  '请输入数量': 'Please enter quantity',
  '请输入新额度': 'Please enter new credit limit',
  '请输入标签名称': 'Please enter tag name',
  '请输入消息内容': 'Please enter message content',
  '请输入消息内容或上传图片': 'Please enter message or upload image',
  '请输入物料编号': 'Please enter material code',
  '请输入物流公司（可选）': 'Please enter shipping company (optional)',
  '请输入电话': 'Please enter phone number',
  '请输入系列': 'Please enter series',
  '请输入英文名称': 'Please enter English name',
  '请输入角色': 'Please enter role',
  '请输入调整原因（可选）': 'Please enter adjustment reason (optional)',
  '请输入身高': 'Please enter height',
  '请输入送货地址': 'Please enter delivery address',
  '请输入部位显示名': 'Please enter measurement part display name',
  '请输入门店名称': 'Please enter store name',
  '请输入零剪价格': 'Please enter cut-to-length price',
  '请输入需要交代给采购人员的事项': 'Please enter instructions for procurement staff',
  '请输入面料名称': 'Please enter fabric name',
  '请输入颜色': 'Please enter color',
  '请选择产品品类': 'Please select product category',
  '请选择付款状态': 'Please select payment status',
  '请选择作废状态': 'Please select void status',
  '请选择供应商': 'Please select supplier',
  '请选择供应商（可选）': 'Please select supplier (optional)',
  '请选择发票状态': 'Please select invoice status',
  '请选择同一门店的订单生成发票': 'Please select orders from the same store to generate invoice',
  '请选择品类': 'Please select category',
  '请选择团队': 'Please select team',
  '请选择快递方式': 'Please select shipping method',
  '请选择成衣分类': 'Please select RTW category',
  '请选择或输入字段代码': 'Please select or enter field code',
  '请选择推送方式': 'Please select push method',
  '请选择收货工厂': 'Please select receiving factory',
  '请选择样本册': 'Please select swatch book',
  '请选择核对状态': 'Please select verification status',
  '请选择物流公司': 'Please select shipping company',
  '请选择状态': 'Please select status',
  '请选择用户': 'Please select user',
  '请选择至少一个角色': 'Please select at least one role',
  '请选择角色': 'Please select role',
  '请选择订单': 'Please select order',
  '请选择负责人': 'Please select manager',
  '请选择运输公司（可选）': 'Please select shipping company (optional)',
  '请选择采购单': 'Please select purchase order',
  '请选择采购用途': 'Please select procurement purpose',
  '调整': 'Adjust',
  '调整信用额度': 'Adjust Credit Limit',
  '调整成功': 'Adjustment Successful',
  '调整提成阶梯、汇率及奖励参数，修改后实时生效于计算器': 'Adjust commission tiers, exchange rate, and reward parameters, effective immediately in calculator',
  '调整数量': 'Adjust Quantity',
  '负责人': 'Manager',
  '财务审核': 'Financial Review',
  '财务审核驳回': 'Financial Review Rejected',
  '账单总额': 'Bill Total',
  '账单月份': 'Bill Month',
  '货物明细': 'Cargo Details',
  '质检员姓名': 'QC Inspector Name',
  '质检时间': 'QC Time',
  '费用': 'Fee',
  '超过10MB限制': 'Exceeds 10MB limit',
  '跟踪已进入工厂生产环节的订单状态': 'Track orders that have entered factory production',
  '跳过(重复)': 'Skip (Duplicate)',
  '转成草稿发票': 'Convert to Draft Invoice',
  '转换类型': 'Conversion Type',
  '转换配置(JSON)': 'Conversion Config (JSON)',
  '转正式': 'Convert to Final',
  '转账手续费 (自动)': 'Transfer Fee (Auto)',
  '辅料管理': 'Accessory Material Management',
  '输入刺绣文字': 'Enter embroidery text',
  '输入图片URL': 'Enter image URL',
  '输入图片URL或上传': 'Enter image URL or upload',
  '输入客户姓名': 'Enter client name',
  '输入说明': 'Enter description',
  '输入门店编号或店名搜索': 'Enter store code or name to search',
  '运费(USD)': 'Shipping (USD)',
  '运费金额': 'Shipping Amount',
  '运输公司': 'Shipping Company',
  '返回映射管理': 'Back to Mapping Management',
  '返回编辑': 'Back to Edit',
  '适用品类': 'Applicable Categories',
  '适用性别': 'Applicable Gender',
  '选填': 'Optional',
  '选择': 'Select',
  '选择HP品类': 'Select HP Category',
  '选择JD品类': 'Select JD Category',
  '选择ordertype': 'Select Order Type',
  '选择体型特征': 'Select Body Feature',
  '选择作为数量来源的设计项，如 sleeve_button_count': 'Select design item as quantity source, e.g. sleeve_button_count',
  '选择共享数据中的设计项': 'Select design item from shared data',
  '选择共享数据中的设计项，绑定后选项将自动同步': 'Select design item from shared data, options will auto-sync after binding',
  '选择共享设计项': 'Select Shared Design Item',
  '选择关联的前端分类项品类': 'Select linked frontend category',
  '选择分类': 'Select Category',
  '选择品类': 'Select Category',
  '选择团队': 'Select Team',
  '选择图片': 'Select Image',
  '选择套装类型': 'Select Suit Type',
  '选择工厂字段': 'Select Factory Field',
  '选择工艺': 'Select Craft',
  '选择性别': 'Select Gender',
  '选择成衣分类': 'Select RTW Category',
  '选择收费类型': 'Select Charge Type',
  '选择收费项': 'Select Charge Item',
  '选择文件': 'Select File',
  '选择显示模式': 'Select Display Mode',
  '选择月份': 'Select Month',
  '选择本地字段': 'Select Local Field',
  '选择标签': 'Select Tag',
  '选择物流商': 'Select Logistics Provider',
  '选择目标分类项': 'Select Target Category',
  '选择类别': 'Select Category',
  '选择类型': 'Select Type',
  '选择系统面料（可选）': 'Select System Fabric (Optional)',
  '选择纽扣': 'Select Button',
  '选择联动模式': 'Select Linkage Mode',
  '选择订单': 'Select Order',
  '选择设计项自动填充': 'Select Design Item Auto-fill',
  '选择该选项后生成的联动选项框数量，如袖扣数量': 'Number of linked option boxes generated when this option is selected, e.g. sleeve button count',
  '选择转换类型': 'Select Conversion Type',
  '选择适用品类，可多选': 'Select applicable categories, multi-select',
  '选择选项': 'Select Option',
  '选择配饰类型': 'Select Accessory Type',
  '选择里布': 'Select Lining',
  '选择面料': 'Select Fabric',
  '选项值': 'Option Value',
  '选项列表': 'Option List',
  '选项名称': 'Option Name',
  '选项由共享数据自动同步，不可在此编辑': 'Options auto-synced from shared data, cannot be edited here',
  '选项类型': 'Option Type',
  '选项（联动填充）': 'Option (Linked Fill)',
  '透明报价：归档面料单价 ÷ 汇率 × 耗料量 + CMT加工费（不乘毛利率）': 'Transparent Quote: Archived fabric unit price ÷ exchange rate × usage + CMT processing fee (no markup)',
  '通过初审': 'First Review Approved',
  '通过复审': 'Second Review Approved',
  '通过终审': 'Final Review Approved',
  '通过财务审核': 'Financial Review Approved',
  '部位名': 'Part Name',
  '部位显示名': 'Part Display Name',
  '部分订单未撤销': 'Some orders not withdrawn',
  '配置保存成功': 'Configuration Saved',
  '配置名称': 'Config Name',
  '配置品类与设计项': 'Configure Categories & Design Items',
  '配置类型': 'Config Type',
  '配置系统API的基础设置和工厂对接接口': 'Configure system API base settings and factory integration interfaces',
  '配置说明': 'Config Description',
  '采购单创建成功': 'Purchase Order Created',
  '采购单备注：': 'Purchase Order Note:',
  '采购单详情': 'Purchase Order Details',
  '采购历史': 'Procurement History',
  '采购总金额': 'Total Procurement Amount',
  '采购日期': 'Procurement Date',
  '采购明细预览': 'Procurement Details Preview',
  '采购状态': 'Procurement Status',
  '采购用途': 'Procurement Purpose',
  '里布品牌': 'Lining Brand',
  '里布幅宽（cm）': 'Lining Width (cm)',
  '里布管理': 'Lining Management',
  '里布纹路': 'Lining Pattern',
  '里布编号': 'Lining Code',
  '里料 ID': 'Lining ID',
  '里料名称': 'Lining Name',
  '重置密码': 'Reset Password',
  '重试推送成功': 'Retry Push Successful',
  '重量(g)': 'Weight (g)',
  '量体字段(JSON)': 'Measurement Fields (JSON)',
  '量体数据预览': 'Measurement Data Preview',
  '金额 (USD)': 'Amount (USD)',
  '金额不匹配': 'Amount Mismatch',
  '金额信息': 'Amount Info',
  '销售业绩': 'Sales Performance',
  '销售价': 'Sales Price',
  '销售基准价': 'Sales Base Price',
  '销售趋势': 'Sales Trend',
  '销售额 (USD)': 'Sales (USD)',
  '键名': 'Key Name',
  '门店ID': 'Store ID',
  '门店不存在': 'Store Not Found',
  '门店已更新': 'Store Updated',
  '门店已被禁用，请联系管理员': 'Store has been disabled, please contact admin',
  '门店总数': 'Total Stores',
  '门店角色': 'Store Role',
  '门店账单': 'Store Bill',
  '门店账号管理': 'Store Account Management',
  '门店重新提交': 'Store Resubmit',
  '零剪价': 'Cut-to-Length Price',
  '零剪价(CNY)': 'Cut-to-Length Price (CNY)',
  '零剪价格（CNY/米）': 'Cut-to-Length Price (CNY/m)',
  '零剪价格（人民币/米）': 'Cut-to-Length Price (CNY/m)',
  '需点击展开': 'Click to expand',
  '面料 ID': 'Fabric ID',
  '面料价格区间': 'Fabric Price Range',
  '面料信息': 'Fabric Info',
  '面料列表按品牌排序号升序显示，越小越靠前；同号按品牌名称排序': 'Fabric list sorted by brand order number ascending, same number sorted by brand name',
  '面料单价（人民币/米）按区间归类到对应价格档，共 500 个档位': 'Fabric unit price (CNY/m) classified into price tiers, 500 tiers total',
  '面料原价': 'Fabric Original Price',
  '面料参数': 'Fabric Parameters',
  '面料库存管理': 'Fabric Inventory Management',
  '面料总数': 'Total Fabrics',
  '面料成分': 'Fabric Composition',
  '面料成本 (USD)': 'Fabric Cost (USD)',
  '面料数': 'Fabric Count',
  '面料映射': 'Fabric Mapping',
  '面料档位配置': 'Fabric Tier Configuration',
  '面料用量': 'Fabric Usage',
  '面料用量(米)': 'Fabric Usage (m)',
  '面料申请': 'Fabric Request',
  '面料管理': 'Fabric Management',
  '面料耗用量': 'Fabric Consumption',
  '面料详情': 'Fabric Details',
  '靴 (Boot)': 'Boots',
  '鞋子管理': 'Shoes Management',
  '项数': 'Item Count',
  '顺丰空运': 'SF Express Air',
  '顺丰陆运': 'SF Express Ground',
  '预估费用': 'Estimated Fee',
  '预置': 'Preset',
  '预览': 'Preview',
  '预计日期': 'Estimated Date',
  '预设初始化成功，共创建 {{count}} 项': 'Preset initialization successful, {{count}} items created',
  '领带 (Tie)': 'Tie',
  '领带夹 (Tie Clip)': 'Tie Clip',
  '领结 (Bow Tie)': 'Bow Tie',
  '风格偏好': 'Style Preference',
  '驳回初审订单': 'Reject First Review Order',
  '驳回复审订单': 'Reject Second Review Order',
  '驳回终审订单': 'Reject Final Review Order',
  '驳回财务审核订单': 'Reject Financial Review Order',
  '默认': 'Default',
  '默认/更多': 'Default/More',
  '默认放松量': 'Default Ease Allowance',
  '默认显示': 'Default Display',
  '默认显示项': 'Default Display Items',
  '默认（前端直接显示）': 'Default (Frontend Direct Display)',
  '，若订单状态为已发货(150)将回退至生产完成(142)。': ', if order status is Shipped (150), it will roll back to Production Complete (142).',
  '。若已存在出库记录，需要先撤销出库。': '. If stock-out records exist, undo stock-out first.',
  '上传失败，请检查网络': 'Upload failed, please check network',
  '个采购单标记为已采购': ' purchase orders marked as purchased',
  '仅已申请状态可标记已采购': 'Only requested orders can be marked as purchased',
  '体型照片已匹配': 'Body type photo matched',
  '作废状态': 'Void Status',
  '个采购单修改供应商': ' purchase orders supplier modified',
  '主题配置已保存': 'Theme Config Saved',
  '保存Webhook配置': 'Save Webhook Config',
  '保存商品': 'Save Product',
  '保存失败，请检查网络或权限': 'Save failed, please check network or permissions',
  '保存失败，请重试': 'Save failed, please retry',
  '保存草稿失败，无法生成AI预览图': 'Failed to save draft, cannot generate AI preview',
  '个性收费配置': 'Custom Charge Configuration',
  '价格信息': 'Price Info',
  '价格信息（人民币）': 'Price Info (CNY)',
  '下单总金额': 'Total Order Amount',
  '— 通配（所有工艺）': '— Wildcard (All Crafts)',

  'JD选项名': 'JD Option Name',
  'Polo衫': 'Polo Shirt',
  'ai建议范围': 'AI Suggestion Range',
  'tech_json包含品类(JSON)': 'tech_json Contains Categories (JSON)',
  '「默认」项在前端直接显示，「更多」项需点击展开才能看到': '"Default" items display directly on frontend, "More" items need click to expand',
  '一级类型': 'Level 1 Type',
  '上传工厂单': 'Upload Factory Document',
  '上架': 'Listed',
  '已上架': 'Listed',
  '已下架': 'Unlisted',
  '确认下架': 'Confirm Unlist',
  '下架后该样本册在下单/销售价格表中将不再可见，确认下架': 'After unlisting, this sample book will no longer appear in order creation or the sales price table. Confirm unlist',
  '批量上架': 'Batch List',
  '批量下架': 'Batch Unlist',
  '批量转移样本册': 'Batch Move to Sample Book',
  '条面料执行': 'fabric(s), execute',
  '操作，确认继续？': 'operation. Continue?',
  '请选择目标样本册': 'Please select target sample book',
  '将把': 'Will move',
  '款面料转移到目标样本册下（允许跨品牌）': 'fabric(s) to the target sample book (cross-brand allowed)',
  '下摆款式': 'Hem Style',
  '下架': 'Unlisted',
  '不展示': 'Hidden',
  '不是图片文件': 'Not an image file',
  '不限': 'Unlimited',
  '不限（最高档）': 'Unlimited (Highest Tier)',
  '专票': 'VAT Invoice',
  '业务员姓名/账号': 'Sales Rep Name/Account',
  '两次输入的密码不一致': 'Passwords do not match',
  '个': ' items',
  '个供应商': ' suppliers',
  '个性加价': 'Custom Surcharge',
  '个月': ' months',
  '个样本册': ' swatch books',
  '个类型': ' types',
  '个选项': ' options',
  '个采购单': ' purchase orders',
  '中文名': 'Chinese Name',
  '中文名称，如: 半麻衬': 'Chinese name, e.g. Half Canvas',
  '主账号': 'Main Account',
  '主题配置': 'Theme Configuration',
  '乐福鞋 (Loafer)': 'Loafer',
  '二级类型': 'Level 2 Type',
  '产品': 'Product',
  '产品品类': 'Product Category',
  '产品基础配置': 'Product Base Configuration',
  '从下单到交付，一站式追踪': 'One-stop tracking from order to delivery',
  '从预设初始化': 'Initialize from Preset',
  '付款截图': 'Payment Screenshot',
  '代码': 'Code',
  '以下订单未通过初审，无法发起采购': 'The following orders have not passed first review, cannot initiate procurement',
  '以下订单采购数量为 0，请先填写数量': 'The following orders have 0 procurement quantity, please fill in quantity first',
  '价格档数': 'Price Tier Count',
  '价格档模糊查询': 'Price Tier Search',
  '价格等级': 'Price Level',
  '价格计算公式': 'Price Calculation Formula',
  '价格计算成功': 'Price Calculation Successful',
  '任意数量': 'Any Quantity',
  '休闲夹克': 'Casual Jacket',
  '休闲衬衫': 'Casual Shirt',
  '体型照片数': 'Body Type Photo Count',
  '体型特征分析': 'Body Type Feature Analysis',
  '体型特征配置项': 'Body Type Feature Config Items',
  '体态与照片': 'Body Type & Photos',
  '体态特征': 'Body Features',
  '余额': 'Balance',
  '余额明细': 'Balance Details',
  '使用率': 'Utilization Rate',
  '例如：cutting / sewing / finishing': 'e.g. cutting / sewing / finishing',
  '供应商发货信息': 'Supplier Shipping Info',
  '保存设置': 'Save Settings',
  '保存配置': 'Save Config',
  '保持修改并提交': 'Keep Changes and Submit',
  '信用额度 (USD)': 'Credit Limit (USD)',
  '信用额度调整成功': 'Credit Limit Adjusted Successfully',
  '修改供应商': 'Modify Supplier',
  '修改供应商失败': 'Modify Supplier Failed',
  '修改日志': 'Change Log',
  '修改绑定': 'Modify Binding',
  '值': 'Value',
  '停用门店': 'Disable Store',
  '克重(g/m²)': 'Weight (g/m²)',
  '入库单号': 'Stock In No.',
  '入账审核': 'Payment Review',
  '全不选': 'Deselect All',
  '全局参数配置': 'Global Parameter Configuration',
  '全选': 'Select All',
  '全部收起': 'Collapse All',
  '全部品牌': 'All Brands',
  '全部工艺': 'All Crafts',
  '全部样本册': 'All Swatch Books',
  '全部档位': 'All Tiers',
  '全部类型': 'All Types',
  '全部角色': 'All Roles',
  '共享': 'Shared',
  '共享设计项编码': 'Shared Design Item Code',
  '关联订单号': 'Linked Order No.',
  '关联订单号（客户姓名）': 'Linked Order No. (Client Name)',
  '关联订单数': 'Linked Order Count',
  '关联订单（可选）': 'Linked Order (Optional)',
  '关联采购记录': 'Linked Procurement Records',
  '关键词（JD/HP 编码或名称，实时过滤）': 'Keyword (JD/HP code or name, real-time filter)',
  '其他备注信息': 'Other Notes',
  '其他服装管理': 'Other Garment Management',
  '其它纽扣': 'Other Buttons',
  '凭证号': 'Receipt No.',
  '凭证图片（可选，支持粘贴）': 'Receipt Image (Optional, paste supported)',
  '出入库状态': 'Stock In/Out Status',
  '出库单号': 'Stock Out No.',
  '分享采购单': 'Share Purchase Order',
  '分享链接（30天内有效）': 'Share Link (valid for 30 days)',
  '分类名称': 'Category Name',
  '分类英文名': 'Category English Name',
  '列表': 'List',
  '创建': 'Create',
  '创建客户失败': 'Failed to Create Client',
  '创建成功': 'Created Successfully',
  '创建成衣商品': 'Create RTW Product',
  '初审订单': 'First Review Order',
  '初审驳回': 'First Review Rejected',
  '删除后不可恢复，是否继续？': 'Cannot be recovered after deletion. Continue?',
  '删除后将同步将关联订单的采购状态回滚为「待采购」，操作不可恢复。是否继续？': 'Deletion will roll back linked order procurement status to "Pending Purchase", this action cannot be undone. Continue?',
  '勾选': 'Check',
  '拒绝': 'Reject',
  '按件收费': 'Per Item',
  '按单收费': 'Per Order',
  '按字收费': 'Per Character',
  '按标签筛选': 'Filter by Tag',
  '按订单批量标记入库与出库': 'Batch mark stock in/out by order',
  '排序': 'Sort',
  '推算失败': 'Calculation Failed',
  '推算结果': 'Calculation Result',
  '推算预览': 'Calculation Preview',
  '提交审核': 'Submit for Review',
  '提交审核失败': 'Submit for Review Failed',
  '提交审核成功': 'Submit for Review Successful',
  '提成 (USD)': 'Commission (USD)',
  '提成回滚规则（只读参考）': 'Commission Rollback Rules (Read-only Reference)',
  '提示': 'Notice',
  '提示：可直接按 Ctrl+V 粘贴截图': 'Tip: Press Ctrl+V to paste screenshot directly',
  '搜索代码/名称': 'Search code/name',
  '搜索价格档...': 'Search price tier...',
  '搜索供应商': 'Search Supplier',
  '搜索关键词': 'Search Keyword',
  '搜索品牌/样本册名称': 'Search brand/swatch book name',
  '搜索售后单号/订单号': 'Search after-sales/order number',
  '搜索商品名称': 'Search product name',
  '搜索团队名称': 'Search team name',
  '搜索客户': 'Search Client',
  '搜索客户姓名/电话/门店': 'Search client name/phone/store',
  '搜索或输入品牌名称': 'Search or enter brand name',
  '搜索或输入样本册名称': 'Search or enter swatch book name',
  '搜索档位名称或价格...': 'Search tier name or price...',
  '搜索用户名/姓名': 'Search username/name',
  '搜索编号/名称': 'Search code/name',
  '搜索编号/名称/品牌': 'Search code/name/brand',
  '搜索编号/名称/类别': 'Search code/name/category',
  '搜索编号/名称/类型': 'Search code/name/type',
  '搜索编号/名称/颜色': 'Search code/name/color',
  '搜索编号、品牌、颜色、成分...': 'Search code, brand, color, composition...',
  '搜索订单号/客户名/门店编号/门店名称/备注': 'Search order no./client/store code/store name/notes',
  '搜索设计项...': 'Search design items...',
  '搜索门店': 'Search Store',
  '搜索门店编号/名称': 'Search store code/name',
  '搜索面料编号...': 'Search fabric code...',
  '搜索颜色...': 'Search color...',
  '撤回后将删除该采购申请记录，并把关联订单状态改回「待采购」，需业务重新提交。是否继续？': 'Withdrawing will delete this procurement request and change linked order status back to "Pending Purchase", requires business resubmission. Continue?',
  '撤回采购单': 'Withdraw Purchase Order',
  '撤销原因（选填）': 'Undo Reason (Optional)',
  '操作类型': 'Operation Type',
  '操作详情': 'Operation Details',
  '支付状态': 'Payment Status',
  '支持 JPG/PNG/WEBP，最大 5MB': 'Supports JPG/PNG/WEBP, max 5MB',
  '支持粘贴图片，自动尝试识别单号': 'Supports pasting images, auto-recognition of tracking numbers',
  '收件人姓名': 'Recipient Name',
  '收货备注': 'Receiving Note',
  '收货录入成功': 'Receiving Record Added',
  '收货日期': 'Receiving Date',
  '收货时间': 'Receiving Time',
  '收费': 'Charge',
  '收费代码': 'Charge Code',
  '收费项说明': 'Charge Item Description',
  '收起导航': 'Collapse Navigation',
  '放大': 'Zoom In',
  '数值': 'Value',
  '数字越小越靠前': 'Smaller number = higher priority',
  '数据加载失败': 'Data Loading Failed',
  '数据实时同步': 'Real-time Data Sync',
  '数据录入校验 (Checklist)': 'Data Entry Validation (Checklist)',
  '数量字段名': 'Quantity Field Name',
  '新增': 'Add',
  '新增一级类型': 'Add Level 1 Type',
  '新增二级类型': 'Add Level 2 Type',
  '新增价格等级': 'Add Price Level',
  '新增供应商': 'Add Supplier',
  '新增分类': 'Add Category',
  '新增刺绣设计': 'Add Embroidery Design',
  '新增发货': 'Add Shipment',
  '新增品类': 'Add Category',
  '新增品类映射': 'Add Category Mapping',
  '新增商品': 'Add Product',
  '新增团队': 'Add Team',
  '新增字体': 'Add Font',
  '新增字段映射': 'Add Field Mapping',
  '新增客户请通过门店详情页或订单创建入口操作': 'To add client, use store detail page or order creation entry',
  '新增尺寸项': 'Add Size Item',
  '状态更新成功': 'Status Updated Successfully',
  '部分支付': 'Partially Paid',
  '未支付': 'Unpaid',
  '关联订单数量': 'Related Orders Count',
  '待申请采购': 'Purchase Pending',
  '投产日期': 'Production Date',
  '跟单': 'Order Tracking',
  '工厂已备货，无需采购': 'In stock at factory, no purchase needed',
  '价格待确认：未设置面料价格档，当前基础价格不可信，请联系业务员设置价格档后重新计算': 'Price pending: No fabric price tier set. Current base price is unreliable. Please ask designer to set price tier and recalculate.',
  '价格待确认，未设置价格档': 'Price pending, no price tier set',
  '发票总额（最终对客金额）': 'Invoice Total (Final Client Amount)',
  '费用明细': 'Cost Breakdown',
  '附加费': 'Extra Charges',
  '该订单发票金额': 'Invoice Amount (This Order)',
  '关联发票总金额': 'Invoice Total (All Orders)',
  '含该发票所有订单': 'includes all orders on this invoice',
  '价格待确认：未设置面料价格档，当前价格仅含加工费，请设置价格档后重新计算': 'Price pending: No fabric price tier set. Current price only includes labour cost. Please set price tier and recalculate.',
  '合并生成采购单': 'Merge & Generate PO',
  '合并汇总': 'Merge Summary',
  '汇总数量': 'Total Qty',
  '请选择（可选）': 'Select (optional)',
  '没有可合并采购的订单': 'No orders available to merge',
  '张合并采购单': ' merged purchase order(s)',
  '张生成失败': ' failed to generate',
  '未过初审': 'not passed first review',
  '已经申请采购': 'already applied for purchase',
  '门店/面料编号不一致，已跳过': 'store/fabric number mismatch, skipped',
  '条合并汇总记录': ' merged summary record(s)',
  '将合并为': ' will merge into ',
  '可合并': ' can merge into ',
  '请选择工厂供应商': 'Please select factory supplier',
  '上架时间': 'Season',
  '季度': 'Season',
  '全部标签': 'All Tags',
  '适合品类': 'Suitable Category',
  '批量打标签': 'Batch Tag',
  '异议备注': 'Dispute Remark',
  '最多4张': 'Max 4',
  '异议情况备注结算（点下方「保存」后写入当月工资表）': 'Dispute remark for settlement (saved to monthly payslip after clicking Save)',
  '追加': 'Append',
  '替换': 'Replace',
  '设置方式': 'Mode',
  '请选择标签': 'Select tags',
  '设置失败': 'Failed to set',
  '已为': 'Set for ',
  '款面料设置标签': ' fabric(s)',
  '请选择具体面料（样本册合并行不支持批量标签）': 'Please select specific fabrics (merged sample-book rows are not supported)',
  '未知面料': 'Unknown fabric',
  '按门店+面料自动分组': 'auto-grouped by store + fabric',
  '以下订单未纳入合并': 'The following orders are not included in the merge',
  '合并订单明细': 'Merged Order Details',
  '（共': ' (',
  '个订单）': ' orders)',
  '未设置': 'Not set',
  '请为以下分组选择工厂供应商': 'Please select a factory supplier for the following groups',
  '编辑用量': 'Edit Usage',
  '点击编辑用量': 'Click to edit usage',
  '请输入用量': 'Enter usage',
  '用量已保存': 'Usage saved',
  'Excel清单': 'Excel List',
  'season': 'Season',
  'zip内文件名=面料编码，如 66012-01.jpg；上限500M': 'Zip filenames = fabric codes (e.g. 66012-01.jpg); max 500MB',
  '上传并预览': 'Upload & Preview',
  '下载模板': 'Download Template',
  '人工填写': 'Manual entry',
  '仅图片': 'Images only',
  '仅更新图片': 'Update images only',
  '价格档变动': 'Price tier change',
  '依据': 'Basis',
  '信息': 'Message',
  '入库失败': 'Import failed',
  '入库完成': 'Import completed',
  '其中跨档': 'of which tier-changed',
  '写入失败': 'Write failed',
  '写入编号': 'Write Numbers',
  '原价格档': 'Old tier',
  '可生成': 'Generatable',
  '图片匹配': 'Images matched',
  '填写信息并上传': 'Fill & Upload',
  '多余': 'extra',
  '如 NOBILITY 经典系列；不存在将自动创建样册': 'e.g. NOBILITY Classic; book created if missing',
  '如 SS2026 / FW2026': 'e.g. SS2026 / FW2026',
  '存在价格档变动，请先勾选确认': 'Tier changes exist, tick to confirm first',
  '存在跨价格档变动，将影响客户报价，请逐条核对后勾选确认': 'Cross-tier changes affect customer pricing. Review each row and tick to confirm.',
  '季节(选填)': 'Season (optional)',
  '季节字段': 'Season field',
  '导入完成': 'Import done',
  '导入模式': 'Import mode',
  '导入记录': 'Import History',
  '将调价': 'To repriced',
  '已写入': 'Written',
  '建议编号': 'Suggested No.',
  '张': 'pcs',
  '总行数': 'Total rows',
  '成功': 'Success',
  '或按品牌': 'or by brand',
  '执行失败': 'Execute failed',
  '执行调价': 'Apply Price Change',
  '批次号': 'Batch No.',
  '批次明细': 'Batch Detail',
  '批量调价': 'Batch Repricing',
  '新价': 'New price',
  '新价格档': 'New tier',
  '新增+更新': 'Insert+Update',
  '无可写入编号': 'Nothing to write',
  '本样册编号': ' book numbers',
  '条将发生价格档迁移': ' row(s) will migrate price tier',
  '条编号？仅更新编号列，不影响现有功能': ' number(s)? Only the number column is updated',
  '样册名称': 'Book Name',
  '样册导入': 'Book Import',
  '样册导入与价格档维护': 'Book Import & Price Tier',
  '样册编号': 'Book Numbers',
  '档变动': 'Tier chg',
  '模式': 'Mode',
  '模板下载失败': 'Template download failed',
  '现有编号': 'Current No.',
  '生成编号建议': 'Generate Number Suggestions',
  '确认写入': 'Confirm write',
  '确认应用价格档变动': 'Confirm tier changes',
  '确认执行批量调价？': 'Apply batch repricing?',
  '范围内面料': 'In scope',
  '行/增/改/败': 'Rows/Ins/Upd/Fail',
  '行号': 'Row',
  '覆盖': 'Overwrite',
  '覆盖更新价格': 'Overwrite prices',
  '解析失败': 'Parse failed',
  '请先勾选确认价格档变动': 'Tick tier-change confirm first',
  '请先选择Excel文件': 'Select Excel first',
  '请填写数值': 'Enter a value',
  '调价只按零剪价重算价格档；仅当调价导致价格档变化时才需要二次确认（价格档影响客户报价）': 'Repricing recalculates tier from piece price; confirm only when a tier change occurs.',
  '跨价格档': 'Cross-tier',
  '跳过': 'Skip',
  '选择Excel': 'Select Excel',
  '选择ZIP': 'Select ZIP',
  '选择品牌': 'Select brand',
  '选择样册(二选一)': 'Select book (either one)',
  '部分失败': 'Partial failed',
  '错误': 'Error',
  '零剪价=固定价': 'Piece price = fixed',
  '零剪价增减(元)': 'Piece price +/- (CNY)',
  '零剪价浮动%': 'Piece price +/- %',
  '需人工': 'Manual needed',
  '面料样册批量上架 / 季度调价 / 编号规范': 'Bulk book onboarding / quarterly repricing / numbering',
  '面料编码': 'Fabric Code',
  '预览失败': 'Preview failed',
  '预览影响': 'Preview Impact',
  '预览确认': 'Preview & Confirm',
  '失败': 'Failed',
  '图片压缩包(选填)': 'Image ZIP (optional)',
  '有': 'Have',
  '写入': 'Write',
  '确认入库': 'Confirm Import',
  '上传一张布卡照片，测试标签编码/价格能否被识别；识别不到编码的照片需重拍（对焦编码、正方形构图、无反光）': 'Upload one swatch photo to test OCR readability. Retake if code is not detected (focus on label, square, no glare)',
  '不可用：未识别到编码，请重拍': 'Not usable: no code detected, retake',
  '保留': 'Keep',
  '可用：识别到编码': 'Usable: code detected',
  '定稿失败': 'Finalize failed',
  '开始测试': 'Run Test',
  '开始识别': 'Start OCR',
  '拆页失败': 'Page split failed',
  '拍照测试': 'Photo Test',
  '拍照识别': 'Photo Recognition',
  '拍照识别测试': 'Photo OCR Test',
  '校对完成，生成预览': 'Proofread done, preview',
  '置信度': 'Confidence',
  '至少保留一行有效编码': 'Keep at least one valid code row',
  '色号': 'Color',
  '识别中': 'Recognizing',
  '识别完成': 'Done',
  '识别校对': 'OCR Proofread',
  '请选择PDF或图片包': 'Select PDF/ZIP first',
  '选择样册PDF/图片ZIP': 'Select Book PDF/ZIP',
  '选择照片': 'Choose Photo',
  '页': 'Page',
  '页提取到编码': ' page(s) got codes',
  '上传中': 'Uploading',
  '反面模式：当前页的编码/参数取自下一页照片顶部的标签；每页照片将裁掉顶部标签区，只保留布料': 'Back mode: code/specs come from the label on top of the NEXT photo; crop keeps only the fabric',
  '反面模式：最后一行（末页）的参数无法从下一页获得，请人工补填或取消勾选': 'Back mode: last row specs unavailable (no next photo) - fill manually or uncheck',
  '图': 'Img',
  '在图片上按住鼠标拖框，圈出布料区域（裁掉标签/反光/桌角等）；坐标按百分比应用到整本每一页': 'Drag a box over the fabric area (exclude label/glare); percentages apply to every page',
  '已按标准裁剪整本': 'Cropped whole book:',
  '应用整本': 'Apply to All',
  '标签位置': 'Label side',
  '标签在反面(出现在下一页照片顶部)': 'Label on back (top of next photo)',
  '标签在正面(本页)': 'Label on front (this page)',
  '裁剪失败': 'Crop failed',
  '设置截取标准': 'Set crop standard',
  '设置截取标准（以第1页为参考，应用到整本）': 'Set Crop Standard (reference page 1, apply to all)',
  '请先框选布料区域': 'Drag a box on the image first',
  '重新设置截取标准': 'Reset crop standard',
  '页提取到标签编码': ' page(s) with label codes',
  '编辑品牌': 'Edit Brand',
  '品牌名': 'Brand Name',
  '选择供应商': 'Select Supplier',
  '请输入品牌名': 'Please enter brand name',
  '品牌已保存': 'Brand saved',
  '封面上传成功': 'Cover uploaded',
  '暂无封面': 'No cover',
  '所选面料暂无价格数据': 'No price data for the selected fabrics',
  '所选面料缺少面料编号': 'Selected fabrics have no fabric code',
  '合作折扣 / 客户等级': 'Partner Discount / Customer Grade',
  '0.85 表示 8.5 折；此处设置会保存到该门店的折扣记录': "0.85 means 15% off; saved to this store's discount record",
  '复制失败，请手动选择链接复制': 'Copy failed, please select and copy the link manually',
  '导出CMT价格表 Excel': 'Export CMT Price List (Excel)',
  '导出CMT价格表 PDF': 'Export CMT Price List (PDF)',
  '导出个性收费表 Excel': 'Export Extra Charge List (Excel)',
  '导出个性收费表 PDF': 'Export Extra Charge List (PDF)',
  '正在汇总': 'Collecting',
  '条记录，请稍候…': 'records, please wait…',
  '请不要刷新页面，稍后会自动进入报价单页面': 'Please do not refresh; you will be taken to the quote page shortly',
  '正在生成文件，请稍候…': 'Generating file, please wait…',
  '记录较多时需要一点时间，请不要刷新页面': 'This may take a while for large records — please do not refresh the page',
  '正在导出': 'Exporting',
  '，请稍候…': ', please wait…',
  '耗时较长时请不要刷新页面': 'This may take a while — please do not refresh',
  '导出超时，请减少数据量后重试': 'Export timed out — please reduce the data and retry',
  '汇总超时，请减少选择的数据量后重试': 'Timed out while collecting — please select less data and retry',
  '正在导出 PDF，请稍候…': 'Exporting PDF, please wait…',
  '正在导出 Excel，请稍候…': 'Exporting Excel, please wait…',
  '该月已单独设置': 'Set for this month',
  '该月未单独设置，当前使用默认': 'Not set for this month — using default',
  '可点击上传，也可直接粘贴截图或拖拽图片到此处': 'Click to upload, or paste a screenshot / drag an image here',
  '暂无图片': 'No image',
  '已发放该月工资并冻结记录': 'Payroll distributed and records frozen',
  '取消发放': 'Cancel distribution',
  '取消发放后该月解除冻结、员工不可见，可重新编辑后再发放。是否继续？': 'Cancelling will unfreeze this month and hide it from employees; you can edit it and distribute again. Continue?',
  '确认取消发放': 'Confirm cancellation',
  '已取消发放，该月恢复可编辑': 'Distribution cancelled — this month is editable again',
  '取消失败': 'Failed to cancel',
  '该月工资已发放并冻结。系统管理员可修改个别人，保存后将重新冻结，并要求该员工重新签收。': 'This month is distributed and frozen. A system administrator may edit an individual; saving will re-freeze the record and require that employee to sign again.',
  '该月工资已发放并冻结，不可修改。如需调整请先取消发放。': 'This month is distributed and frozen and cannot be modified. Cancel the distribution first if changes are needed.',
  '该月工资已冻结。系统管理员可修改个别人，保存后将重新冻结，并要求该员工重新签收。': 'This month is frozen. A system administrator may edit an individual; saving will re-freeze the record and require that employee to sign again.',
  '该月工资已冻结，不可修改。如需调整请先解除冻结。': 'This month is frozen and cannot be modified. Unfreeze it first if changes are needed.',
  '解除冻结': 'Unfreeze',
  '确认解除冻结': 'Confirm unfreeze',
  '解除冻结后该月恢复实时计算与可编辑（不会发放给员工）。是否继续？': 'Unfreezing restores live calculation and editing for this month (it will not be visible to employees). Continue?',
  '基数': 'Base',
  '手工': 'manual',
  // ===== 样册 PDF 导入 / 导出 / 产地支纱（2026-09）=====
  '产地': 'Origin',
  '请选择产地': 'Select origin',
  '中国': 'China',
  '英国': 'UK',
  '意大利': 'Italy',
  '日本': 'Japan',
  '韩国': 'Korea',
  '如 Super 120s': 'e.g. Super 120s',
  '面料标签上的支数，如 Super 100s / Super 120s': 'Yarn count on the fabric label, e.g. Super 100s / Super 120s',
  '导出样本册 PDF': 'Export Sample Book PDF',
  '导出样本册PDF': 'Export Sample Book PDF',
  'PDF 已开始下载': 'PDF download started',
  'PDF 生成失败': 'PDF generation failed',
  'PDF 上传失败': 'PDF upload failed',
  'PDF页': 'PDF page',
  '只看异常': 'Abnormal only',
  '换图': 'Replace image',
  '图片已替换': 'Image replaced',
  '缺图': 'Missing image',
  '有图': 'Has image',
  '无图': 'No image',
  '全选所有册子': 'Select all books',
  '清空': 'Clear',
  '册': 'books',
  '本': 'books',
  '约': 'about',
  '款单独面料': 'individual fabrics',
  '请至少勾选一个样本册或面料': 'Select at least one sample book or fabric',
  '确认导出': 'Confirm export',
  '可整品牌全选、跨品牌多选，也可展开册子勾选任意面料；导出为一个 PDF（每册带封面页，面料页左下角印编号/克重/成分）。': 'Select a whole brand, mix books across brands, or expand a book to pick individual fabrics. Exports as one PDF (each book gets a cover page; fabric pages show code / weight / composition at bottom-left).',
  '该册下暂无面料': 'No fabrics in this book',
  '收起面料': 'Collapse',
  '上传样册 PDF…': 'Uploading sample book PDF…',
  '识别面料编码': 'Recognizing fabric codes',
  '按面料编码匹配…': 'Matching by fabric code…',
  '样册PDF(选填)': 'Sample book PDF (optional)',
  '封面图(选填)': 'Cover image (optional)',
  '选择PDF': 'Choose PDF',
  '上传整本样册 PDF：系统自动拆页并按「面料编码」与表格逐行匹配；上限1G': 'Upload the whole sample book PDF: pages are split automatically and matched to rows by fabric code; max 1 GB',
  '样本册封面；不传则用 PDF 首页（无编码的封面页）自动生成方图': 'Sample book cover; if omitted, the PDF first page (cover page without code) is used as a square cover',
  '供应商隶属品牌：选择供应商后，品牌下拉只显示其名下品牌': 'Suppliers own brands: after choosing a supplier, the brand list shows only its brands',
  '全部供应商': 'All suppliers',
  '选择已有册子 或 输入新名称': 'Pick an existing book or type a new name',
  '该品牌下暂无册子，直接输入新名称即可新建': 'No books under this brand yet — type a new name to create one',
  '【更新】从下拉里点选已有册子；【新建】直接输入一个不存在的名称。名称必须完全一致才认得出是同一本': '[Update] pick an existing book from the list; [Create] type a name that does not exist yet. The name must match exactly to be recognized as the same book',
  '将新建样本册': 'Will create a new sample book',
  '将更新已有样本册': 'Will update the existing sample book',
  '统一格式：SS/AW + 完整年份，如 SS2026、AW2026': 'Format: SS/AW + full year, e.g. SS2026, AW2026',
  '新增品牌': 'Add brand',
  '新增失败': 'Create failed',
  '品牌已新增': 'Brand created',
  '请输入品牌名称': 'Please enter a brand name',
  '输入新品牌名称': 'Enter new brand name',
  '该品牌已存在': 'This brand already exists',
  '设置截取标准（方图）': 'Set crop standard (square)',
  '在图片上按住鼠标拖框，圈出布料区域（裁掉标签/反光/桌角等）；框会锁定为正方形，坐标按百分比应用到整本每一页': 'Drag on the image to mark the fabric area (crop out labels, glare, table edges). The box is locked to a square and applied to every page by percentage',
  '文件内有': 'File contains',
  '个重复面料编码，已合并为一行（后出现的有值字段覆盖前一行，空值不覆盖）': 'duplicate fabric codes, merged into one row (later non-empty values override earlier ones; blanks do not override)',
  '个重复面料编码，已按「后出现的有值字段覆盖前一行」合并': 'duplicate fabric codes, merged (later non-empty values override earlier ones)',
  '行未匹配到 PDF 页图，已在预览中高亮': 'rows have no matching PDF page image and are highlighted in the preview',
  '该品牌下暂无样本册': 'No sample books under this brand',
  '暂无样本册': 'No sample books',
  '下载PDF': 'Download PDF',
  '「无图」「档变动」的行会高亮；所有字段可直接点击单元格修改，改完自动保存': 'Rows without image or with tier change are highlighted; every field is editable inline and saves on blur',
  // ===== Excel/PDF 二选一（2026-09-12）=====
  'Excel清单(与PDF至少传一个)': 'Excel list (at least one of Excel / PDF)',
  '样册PDF(与Excel至少传一个)': 'Sample book PDF (at least one of Excel / PDF)',
  '请至少上传 Excel 清单 或 样册 PDF': 'Please upload at least an Excel list or a sample book PDF',
  '未上传 Excel 时自动为「仅更新图片」：只按编码替换图片，不改动任何字段': 'Without an Excel file this is forced to "Images only": replace images by code without touching any field',
  '本次将执行：全量上架 —— 按 Excel 更新字段，并用 PDF 按面料编码匹配图片': 'This run: full import — update fields from Excel and attach images from the PDF matched by fabric code',
  '本次将执行：只更新参数 —— 按 Excel 更新价格等字段，不涉及图片': 'This run: parameters only — update prices and other fields from Excel, no images involved',
  '本次将执行：仅更新图片 —— 按 PDF 识别到的面料编码替换图片，不改动任何字段（需面料已存在）': 'This run: images only — replace images by the fabric codes recognized from the PDF, without touching any field (fabrics must already exist)',
  // ===== 2026-09-12 样册导入向导改版（流式上传 / 识别校对 / 正反面裁剪 / 批量调价多选） =====
  'OCR 原始文字（用于判断标签是否拍全、是否需要调整拍摄/裁剪）': 'OCR raw text (judge whether the label was fully captured, or the shot/crop needs adjusting)',
  '① 选择要识别的页面': '(1) Select the pages to recognize',
  '② 识别面料编码': '(2) Recognize fabric codes',
  '上传并开始识别': 'Upload and start recognition',
  '上传整本样册 PDF：系统自动拆页并按「面料编码」与表格逐行匹配；上限1G，大文件走流式上传不占内存': 'Upload the full sample-book PDF: pages are split automatically and matched to rows by fabric code. Up to 1 GB; large files are streamed to disk instead of buffered in memory',
  '下一步：生成预览': 'Next: generate preview',
  '不选=全部品牌': 'Empty = all brands',
  '不选=所选品牌下全部样本册': 'Empty = all sample books under the selected brands',
  '仅反面已设置': 'Only the back side is configured',
  '仅正面已设置': 'Only the front side is configured',
  '会话已过期': 'Session expired',
  '务必先完成识别再裁剪：裁剪只是给面料图取图用，标签须在裁剪前就被识别到': 'Always recognize before cropping: cropping only extracts the fabric image, so the label must be read first',
  '反面': 'Back',
  '只选中间页(跳过首尾)': 'Middle pages only (skip first/last)',
  '品牌（可多选）': 'Brands (multi-select)',
  '在图片上按住鼠标拖框，圈出布料区域（裁掉标签/反光/桌角等）；框锁定为正方形，按百分比应用到本册所有': 'Drag on the image to frame the fabric area (cutting out the label, glare, table edges). The box is locked to a square and applied by percentage to all',
  '处理中，请勿刷新或关闭页面': 'Processing — do not refresh or close this page',
  '尚未框选': 'No area selected yet',
  '尚未识别到任何面料编码，请先完成识别': 'No fabric code recognized yet — run recognition first',
  '已上传': 'Uploaded',
  '已恢复上次导入，可继续识别或裁剪': 'Previous import restored — you can continue recognizing or cropping',
  '已按标准裁剪': 'Cropped',
  '已放弃该会话，页图已清理': 'Session discarded; page images cleaned up',
  '已识别': 'Recognized',
  '已识别出': 'Recognized',
  '应用': 'Apply',
  '应用到本册': 'Applies to',
  '开始识别选中页': 'Recognize selected pages',
  '拆分样册页面': 'Splitting sample-book pages',
  '拆页完成，共': 'Page splitting complete,',
  '拆页等待超时，可稍后从「继续上次导入」恢复': 'Timed out waiting for page splitting — resume later via "Continue previous import"',
  '放弃': 'Discard',
  '放弃该会话？已拆好的页图会被删除': 'Discard this session? The extracted page images will be deleted',
  '未识别到': 'Not recognized',
  '未识别到的页不会参与匹配（该页图不会被使用）。可手工补填编码，或点「重识别」重试——重试不需要重新上传 PDF。中途可随时离开，下次从「继续上次导入」恢复。': 'Pages without a code are excluded from matching (their images will not be used). Type the code manually, or click Retry — retrying does not require re-uploading the PDF. You may leave at any time and resume later via "Continue previous import".',
  '未识别到编码': 'No code recognized',
  '未识别到，可手工填写': 'Not recognized — fill in manually',
  '本样本册': 'sample book(s)',
  '样本册（可多选，随品牌联动）': 'Sample books (multi-select, follows the brand selection)',
  '检测到未完成的导入会话': 'Unfinished import session detected',
  '正面': 'Front',
  '正面/反面均已设置': 'Both front and back are configured',
  '步骤：① 勾选面料页（默认已跳过首页封面/尾页）② 测试识别确认无误 ③ 整本识别 ④ 人工校对编码 ⑤ 设置裁剪区域（识别在前、裁剪在后）': 'Steps: (1) tick the fabric pages (first/last skipped by default) (2) test recognition (3) recognize the whole book (4) verify codes (5) set the crop area (recognize first, crop after)',
  '测试识别': 'Test recognition',
  '测试识别第': 'Test recognition, page',
  '测试识别第 1 页': 'Test recognition on page 1',
  '生成预览': 'Generate preview',
  '生成预览…': 'Generating preview…',
  '看原文': 'View raw text',
  '继续上次导入': 'Continue previous import',
  '范围': 'Scope',
  '裁剪效果预览': 'Crop preview',
  '裁剪预览·反面': 'Crop preview · Back',
  '裁剪预览·正面': 'Crop preview · Front',
  '解析出的面料编码': 'Parsed fabric code',
  '识别与裁剪': 'Recognize & crop',
  '识别到的面料编码': 'Recognized fabric code',
  '识别完成：命中': 'Recognition complete: matched',
  '识别超时，可重试': 'Recognition timed out — you can retry',
  '请先上传样册 PDF': 'Please upload the sample-book PDF first',
  '请先勾选要识别的页面': 'Please tick the pages to recognize first',
  '请先完成识别，再设置裁剪区域（识别在前、裁剪在后，否则会把标签一起裁掉导致识别为空）': 'Run recognition before setting the crop area (cropping first would cut the label away and recognition would come back empty)',
  '请先选择品牌或样本册': 'Please select a brand or sample book first',
  '请选择品牌或样本册': 'Please select a brand or sample book',
  '请选择季节': 'Select a season',
  '超时/失败': 'Timed out / failed',
  '重识别': 'Retry',
  '页的编码': 'pages\' codes',
  '页码': 'Page',
  '页识别超时/失败，可点该行「重识别」重试，无需重新上传': 'page(s) timed out or failed — click Retry on that row; no re-upload needed',
  '页，已自动跳过首页/尾页': 'pages; first and last pages skipped automatically',
  '预览确认入库': 'Preview & commit',
  '（无文字）': '(no text)',
  // ===== 2026-09-12 样册导入 5 步流程 / Excel 独立 tab / 图文比对 =====
  'Excel 清单': 'Excel list',
  'Excel导入模式': 'Excel import mode',
  'Excel清单(选填)': 'Excel list (optional)',
  'Excel清单导入': 'Excel list import',
  'OCR 原始文字': 'OCR raw text',
  'PDF：整本样册，自动拆页；ZIP：每张图一页（文件名=面料编码）。上限1G，大文件走流式上传': 'PDF: a whole sample book, split automatically; ZIP: one page per image (filename = fabric code). Up to 1 GB; large files are streamed to disk',
  '【更新】从下拉里点选已有册子；【新建】直接输入一个不存在的名称': '[Update] pick an existing book from the dropdown; [New] type a name that does not exist yet',
  '上传图片包…': 'Uploading image archive…',
  '上传并确认页图': 'Upload and confirm pages',
  '下一步：写入': 'Next: write',
  '不勾选时：只更新已有面料，其余跳过': 'Unchecked: update existing fabrics only, skip the rest',
  '仅更新已有面料（库中没有的跳过）': 'Update existing fabrics only (skip codes not in the library)',
  '价格档按零剪价自动重算；若导致跨档，必须逐条核对并勾选确认后才会写入': 'Price tiers are recalculated from the cut-length price; if a tier changes you must review each row and tick the confirmation before anything is written',
  '保存并退出': 'Save and exit',
  '允许新增：Excel 里有、库里没有的面料编码，自动按本样本册新建': 'Allow insert: fabric codes present in the Excel but missing in the library are created under this sample book',
  '先选「标签在正面还是反面」——反面时，每页面料的编码印在下一页顶部，系统会去下一页取；再确认下方要识别的页': 'First choose whether the label is on the front or the back — if back, each fabric\'s code is printed at the top of the next page and the system reads it there. Then confirm the pages to recognize below.',
  '参数取自第': 'values taken from page',
  '反面（编码在下一页顶部）': 'Back (code at the top of the next page)',
  '可随时离开，下次从「继续上次导入」恢复': 'You can leave at any time and resume via "Continue previous import"',
  '图文比对': 'Image vs. data',
  '图片已换，但重识别超时，可点「重识别」重试': 'Image replaced, but re-recognition timed out — click Retry on that row',
  '如这些是新品面料，请勾选上方「允许新增」后重新预览': 'If these are new fabrics, tick "Allow insert" above and preview again',
  '导入方式': 'Import behaviour',
  '尚未识别到任何面料编码，请先完成识别或手工补填': 'No fabric code recognized yet — run recognition first or fill the code in manually',
  '左列是这一行的面料图；右侧参数可直接改。整行展开可编辑全部字段。缺编码的行可手工补填或点「重识别」。': 'The left column is this row\'s fabric image; the parameters on the right are editable. Expand a row to edit every field. Rows without a code can be filled in manually or retried.',
  '已上传，请确认页图与标签位置': 'Uploaded — please confirm the pages and the label position',
  '已恢复上次导入进度': 'Previous import restored',
  '已放弃该会话': 'Session discarded',
  '已暂存': 'Saved as draft',
  '已自动勾选': 'Auto-selected',
  '已重识别第': 'Re-recognized page',
  '库中没有的面料编码自动新增（不勾则仅更新已有）': 'Create fabric codes missing from the library (unchecked = update existing only)',
  '当前：仅更新已有面料': 'Current: update existing fabrics only',
  '待人工': 'Needs manual input',
  '按标签位置重选': 'Re-select by label position',
  '按面料编码更新已有记录：只改 Excel 里有值的字段，库中不存在的编码默认跳过': 'Updates existing records by fabric code: only fields that have values in the Excel are changed; codes missing from the library are skipped by default',
  '换图失败': 'Failed to replace the image',
  '更新 + 新增（库中没有的面料自动新建）': 'Update + insert (create fabrics missing from the library)',
  '未暂存': 'Not saved yet',
  '本次将执行：以 PDF 识别结果为准（识别 → 人工比对 → 写入并保存图片）': 'This run: the PDF recognition result is the source of truth (recognize → verify → write and save images)',
  '本次将执行：只按 Excel 更新字段，不涉及图片': 'This run: update fields from the Excel only, no images involved',
  '本次将执行：按 Excel 更新字段，并用 PDF 页图按面料编码匹配图片': 'This run: update fields from the Excel and attach PDF page images matched by fabric code',
  '条？': 'row(s)?',
  '标签在': 'Label is on the',
  '样册PDF 或 图片包': 'Sample-book PDF or image archive',
  '模板': 'Template',
  '正在识别面料标签…': 'Recognizing fabric labels…',
  '正面（编码在本页）': 'Front (code on this page)',
  '生成预览失败': 'Failed to generate the preview',
  '目标样册': 'Target sample book',
  '看大图': 'View image',
  '确认写入这': 'Confirm writing these',
  '自动识别': 'Auto recognize',
  '行因「仅更新」被跳过（库中无此编码）': 'row(s) skipped because of "update only" (code not in the library)',
  '行有编码': 'row(s) have a code',
  '裁剪预览': 'Crop preview',
  '识别到的参数（点右侧「上一步」可回去修改）': 'Recognized parameters (click Back to edit)',
  '识别结果': 'Recognition result',
  '该行没有来源页，请手工填写': 'This row has no source page — please fill it in manually',
  '请至少上传 样册PDF/图片包 或 Excel 清单': 'Please upload at least a sample-book PDF/image archive or an Excel list',
  '请选择 Excel 文件': 'Please choose an Excel file',
  '选择PDF或ZIP': 'Choose PDF or ZIP',
  '选择样本册': 'Select a sample book',
  '配 Excel 时：按面料编码把 PDF 页图匹配到 Excel 行；不配 Excel 时：完全以 PDF 识别结果为准': 'With an Excel: PDF page images are matched to Excel rows by fabric code. Without one: the PDF recognition result is used as-is',
  '重识别失败': 'Re-recognition failed',
  '面料样册批量上架 / 季度调价': 'Bulk sample-book upload / seasonal repricing',
  '页图片已替换，正在重新识别': 'page image replaced, re-recognizing',
  '页图确认': 'Confirm pages',
  '页识别超时/失败，可点该行「重识别」重试': 'page(s) timed out or failed — click Retry on that row',
  '页，可手动增减': 'page(s) selected; adjust manually if needed',
  // ===== 2026-09-12 价格档跨档涨跌标记 =====
  '档位变动': 'Tier change',
  '涨': 'Up',
  '跌': 'Down',
  '变动日期': 'Change date',
  // ===== 2026-09-12 Excel 清单导入：样本册/品牌选填 =====
  '样本册(选填)': 'Sample book (optional)',
  '不选=只按面料编码更新': 'Empty = update by fabric code only',
  '不选=取表格里的品牌': 'Empty = take the brand from the sheet',
  '勾选「允许新增」时必须选择样本册（新增的面料要归属到某本册子）': 'A sample book is required when "Allow insert" is ticked (new fabrics must belong to a book)',
  '样本册和品牌都可以不选——表格里已有品牌列时会自动取用。价格档按零剪价自动重算；若导致跨档，必须逐条核对并勾选确认后才会写入': 'Sample book and brand are both optional — the brand is taken from the sheet\'s brand column when present. Price tiers are recalculated from the cut-length price; if a tier changes you must review each row and tick the confirmation before anything is written',
  // ===== 2026-09-12 Excel 未识别表头提示 =====
  '表格里有': 'The sheet has',
  '列没被识别，这些列的内容不会被导入': 'column(s) that were not recognized — their content will not be imported',
  '请对照模板使用规范表头（例如「克重」「幅宽(cm)」）': 'Please use the template\'s exact headers (e.g. 克重/Weight, 幅宽/Width (cm))',
  // ===== 2026-09-13 预览表列级「不导入」勾选 =====
  '取消勾选后，这一列不会写入数据库（也不会覆盖库中已有的值）': 'Uncheck to skip this column on import (existing values in the database are kept)',
  '列已取消勾选，不会写入数据库：': "column(s) unchecked — these will not be written to the database: ",
  '全部恢复': 'Restore all',

  // ===== 2026-09-12 不导入勾选 + 裁剪正方形修复 =====
  '上一页': 'Previous',
  '下一页': 'Next',
  '不导入': 'Exclude',
  '全部不导入': 'Exclude all',
  '全部导入': 'Include all',
  '务必先完成识别再裁剪：裁剪只是给面料图取图，标签要在裁剪之前就被识别到': 'Always recognize before cropping: cropping only extracts the fabric image, so the label must be read first',
  '参照页': 'Reference page',
  '在图片上按住鼠标拖框，圈出布料区域（去掉标签/反光/桌角）。框锁定为正方形，按比例套用到本册每一页': 'Drag on the image to frame the fabric area (excluding the label, glare, table edges). The box is locked to a square and applied proportionally to every page of this book',
  '将导入': 'To import',
  '左上角': 'Top-left',
  '左侧为原图取景预览；点「应用并裁剪」后可看到实际裁剪结果': 'The left box previews the framing on the original; click "Apply and crop" to see the actual result',
  '左列是这一行的面料图；右侧参数可直接改。整行展开可编辑全部字段。封面页/识别错的行可勾「不导入」，不会进库也不会删数据。': 'The left column is this row\'s fabric image; the parameters on the right are editable. Expand a row to edit every field. Tick "Exclude" for cover pages or misrecognized rows — they are neither imported nor deleted.',
  '已排除': 'excluded',
  '已裁剪，右侧为裁剪结果': 'Cropped — result shown on the right',
  '应用并裁剪': 'Apply and crop',
  '当前已保存的标准会应用到本册对应页面': 'The saved standard is applied to the matching pages of this book',
  '当前已保存的标准会应用到本册每一页': 'The saved standard is applied to every page of this book',
  '框选边长': 'Box side',
  '正方形': 'square',
  '没有可导入的行：请先完成识别、填写编码，或取消「不导入」的勾选': 'Nothing to import: run recognition, fill in a code, or untick "Exclude"',
  '裁剪结果（正方形 1:1）': 'Crop result (square 1:1)',
  '设置截取标准（拖框圈出布料区，应用到整本）': 'Set the crop standard (frame the fabric area, applied to the whole book)',
  '请先在图片上框选布料区域': 'Please frame the fabric area on the image first',
  // ===== 2026-09-12 向导数据改为 state 承载 =====
  '请先回第①步选择品牌并填写样册名称': 'Go back to step (1) and pick a brand, then fill in the sample-book name',
  // ===== 2026-09-13 撤回推送按工厂处理 =====
  '确认撤回推送吗？有对接接口的工厂会同时删除工厂端订单；无接口的工厂只回滚本地状态，需你到工厂后台手动删除。': 'Withdraw this push? Factories with an API will also have their order deleted; factories without an API only roll back locally — you must delete the order in the factory\'s own system.',
  // ===== 2026-09-14 个人资料+修改密码 =====
  '密码修改成功': 'Password updated',
  '密码修改失败': 'Failed to update password',
  '旧密码': 'Current password',
  '请输入旧密码': 'Enter current password',
  '请输入新密码': 'Enter new password',
  '确认新密码': 'Confirm new password',
  '请再次输入新密码': 'Re-enter new password',
  '入库日期': 'Inbound Date',
  '出库日期': 'Outbound Date',
  '入库运单号': 'Inbound Tracking No.',
  '出库运单号': 'Outbound Tracking No.',
  '查看发票详情': 'View Invoice Details',
  '出入库日期': 'Inbound / Outbound Dates',
  '暂无': 'Not available',
  "样本册合集": "Sample Book Collection",
  "面料选集": "Fabric Selection",
  // ===== 2026-09-16 面料库存/导入向导 补充翻译 =====
  "20m+价(CNY/m)": "20m+ price (CNY/m)",
  "60m+价(CNY/m)": "60m+ price (CNY/m)",
  "Excel 列 → 数据库字段对应关系（点击展开）": "Excel column → database field mapping (click to expand)",
  "Excel 列名": "Excel column",
  "Excel 里留空的格子不会覆盖库里已有的值。价格档按零剪价自动归档；跨档变动须逐条确认后才会写入": "Blank cells in the Excel file will not overwrite existing values. Price tiers are assigned automatically from the cut-length price; tier changes must be confirmed line by line before they are written.",
  "一键+10": "+10 all",
  "一键-10": "-10 all",
  "一键递增全部": "Increment all",
  "上传中…": "Uploading…",
  "不存在自动新建品牌": "created automatically if it does not exist",
  "价格已保存": "Price saved",
  "价格敏感，仅财务与系统管理可查看/编辑": "Prices are sensitive — only Finance and System Admin can view or edit them",
  "价格档从": "Tier from",
  "价格档到": "Tier to",
  "价格档设置": "Price tier settings",
  "写入中，正在上传图片并入库…": "Writing — uploading images and saving to the database…",
  "决定价格档": "determines the price tier",
  "准备导出…": "Preparing export…",
  "加载面料失败": "Failed to load fabrics",
  "品牌排序设置": "Brand sort settings",
  "品牌管理": "Brand management",
  "季节": "Season",
  "导出完成": "Export complete",
  "将对": "Will apply to",
  "已保存": "Saved",
  "库存情况": "Stock status",
  "应用并关闭": "Apply and close",
  "必填，主键": "required, primary key",
  "所属品牌": "Brand",
  "所属品类": "Category",
  "所选面料没有关联样本册": "The selected fabrics are not linked to any sample book",
  "批量价格档": "Batch price tier",
  "批量品类": "Batch category",
  "按面料编码智能导入：有编码则更新，没有则新建；品牌/样本册不存在时自动新建": "Smart import by fabric code: existing codes are updated, new ones are created; brands and sample books are created automatically if missing",
  "支持 JPG/PNG/WEBP，最大 5MB；可粘贴或拖拽图片到此区域": "Supports JPG/PNG/WEBP up to 5MB; you can also paste or drag an image into this area",
  "数据库字段": "Database field",
  "更新样本册": "Update sample books",
  "条面料执行品类操作": "fabrics will have the category operation applied",
  "条面料批量设置价格档": "fabrics will have the price tier set in bulk",
  "条面料设置价格档，确认继续？": "fabrics will have their price tier set. Continue?",
  "条面料设置品类，确认继续？": "fabrics will have their category set. Continue?",
  "样本册名": "Sample book name",
  "样本册排序设置": "Sample book sort settings",
  "格式 SS2026/AW2026": "format SS2026/AW2026",
  "织法": "Weave",
  "绑定供应商": "Linked supplier",
  "自动归一化中英文": "Chinese and English are normalised automatically",
  "英文名称": "English name",
  "行被跳过": "rows skipped",
  "设置所属品类": "Set category",
  "识别进行中，可随时离开，下次从「继续上次导入」恢复": "Recognition is running — you can leave at any time and resume later via \"Resume last import\"",
  "请先完成裁剪预览（点击「裁剪预览」按钮框选布料区域并应用）": "Please complete the crop preview first (click \"Crop preview\" and frame the fabric area)",
  "请输入英文名": "Enter the English name",
  "请选择品牌": "Select a brand",
  "跳过的行可能是编码为空或格式错误，请检查原始数据": "Skipped rows may have an empty or malformed code — please check the source data",
  "输入价格档，如 LUXURY/1300": "Enter a price tier, e.g. LUXURY/1300",
  "选择物料供应商": "Select a material supplier",
  "递增": "Increment",
  "递增100": "Increment by 100",
  "逗号分隔，如 JKT,VST": "comma-separated, e.g. JKT,VST",
  "零剪价(CNY/m)": "Cut-length price (CNY/m)",
  "面料参数导入": "Fabric parameter import",
  "面料排序设置": "Fabric sort settings",
  "面料样本册": "Fabric sample books",
  "面料编码*": "Fabric code*",
  "预定": "Pre-order",
  "颜色描述": "Colour description",
  // ===== 2026-09-21 客户列表负责人 =====
  '当前负责人': 'Current Manager',
  // ===== 2026-09-21 i18n 补全：英文界面原先回退显示中文的 749 个 key =====
  '其它订单': 'Other Orders',
  '复制当前品类（成衣尺寸—>审核尺寸)': 'Copy Current Category (Finished → Review Measurements)',
  '不推送工厂，点击推送': 'Not Pushed to Factory — Click to Push',
  '待付': 'Pending Payment',
  '推送工厂，点击取消': 'Pushed to Factory — Click to Cancel',
  '个人提成': 'Personal Commission',
  '公积金': 'Housing Fund',
  '合作折扣': 'Partner Discount',
  '品类/面料': 'Category / Fabric',
  '提成(USD)': 'Commission (USD)',
  '补货中': 'Restocking',
  '关联失败': 'Link Failed',
  '切换为自动计算': 'Switch to Auto Calculation',
  '初始密码': 'Initial Password',
  '合并失败': 'Merge Failed',
  '团队提成': 'Team Commission',
  '客户等级': 'Customer Tier',
  '岗位': 'Position',
  '应发': 'Gross Pay',
  '应扣': 'Deductions',
  '手动输入手续费': 'Enter Fee Manually',
  '拆分发票': 'Split Invoice',
  '拆分失败': 'Split Failed',
  '物料单号': 'Material No.',
  '确认关联': 'Confirm Link',
  '西服': 'Suit',
  '预估总金额': 'Estimated Total',
  '个人业绩': 'Personal Sales',
  '个人业绩(USD)': 'Personal Sales (USD)',
  '以上': ' and above',
  '元/月': ' CNY/month',
  '入职时间': 'Hire Date',
  '养老': 'Pension',
  '出勤': 'Attendance',
  '创建用户失败': 'Failed to Create User',
  '创建门店失败': 'Failed to Create Store',
  '医疗': 'Medical',
  '团队业绩': 'Team Sales',
  '失业': 'Unemployment',
  '客供面料（待采）': 'Client-Supplied Fabric (To Be Sourced)',
  '比例': 'Rate',
  '系统登录账号（自动生成）': 'System Login (auto-generated)',
  '缺勤扣款': 'Absence Deduction',
  '联系人姓名': 'Contact Name',
  '英文名（可选）': 'English Name (optional)',
  '请先生成采购链接': 'Please generate a procurement link first',
  '跟单/行政': 'Order Tracking / Admin',
  '转交失败': 'Transfer Failed',
  'API密钥': 'API Key',
  'HP工艺项': 'HP Workmanship Item',
  'Webhook配置': 'Webhook Configuration',
  '上衣': 'Jacket',
  '业务员账号/姓名': 'Sales Staff Account / Name',
  '业务提成': 'Sales Commission',
  '个留在新发票': ' will remain on the new invoice',
  '个税': 'Income Tax',
  '个订单关联到本发票？关联后将重算发票金额与未付金额。': ' order(s) to this invoice? The invoice total and unpaid amount will be recalculated.',
  '个订单将拆出，剩余': ' order(s) will be split out; the remaining',
  '主发票': 'Primary Invoice',
  '五险一金缴纳比例': 'Social Insurance & Housing Fund Rates',
  '产品名称': 'Product Name',
  '仍要删除': 'Delete Anyway',
  '供应商名称': 'Supplier Name',
  '供应商地址': 'Supplier Address',
  '保存折扣失败': 'Failed to Save Discount',
  '入账状态': 'Payment Status',
  '共 {n} 条': '{n} record(s)',
  '关联成功': 'Linked Successfully',
  '其它提成': 'Other Commission',
  '再次推送将创建新的工厂单号，并覆盖原始单号！！': 'Re-pushing will create a new factory order number and overwrite the original!!',
  '删除后不可恢复。': 'This cannot be undone after deletion.',
  '删除后订单将移入回收站': 'The order will be moved to the Recycle Bin',
  '勾选要拆分出去的订单（至少1个，且须保留至少1个）。拆分后原发票删除，生成两张新发票。': 'Select the orders to split out (at least 1, and at least 1 must remain). The original invoice will be deleted and two new invoices created.',
  '反查失败': 'Lookup Failed',
  '发放失败': 'Distribution Failed',
  '发现的问题': 'Issues Found',
  '发票合并成功': 'Invoices Merged Successfully',
  '发票总金额': 'Invoice Total',
  '发票拆分成功': 'Invoice Split Successfully',
  '只能上传图片': 'Only image files can be uploaded',
  '品类费用': 'Category Fee',
  '团队业绩汇总': 'Team Sales Summary',
  '备忘词': 'Memo Keyword',
  '备注信息，可对门店客户也可对内显示': 'Note visible to store customers and internal staff',
  '备注：': 'Note: ',
  '如：面料-VBC蓝色净色': 'e.g. Fabric - VBC Blue Solid',
  '客供纽扣（待采）': 'Client-Supplied Buttons (To Be Sourced)',
  '客供里布（待采）': 'Client-Supplied Lining (To Be Sourced)',
  '小计(USD)': 'Subtotal (USD)',
  '工资条': 'Payslip',
  '已付': 'Paid',
  '已入账': 'Recorded',
  '已入账发票明细': 'Recorded Invoice Details',
  '已入账总额': 'Total Recorded',
  '提成基数总额': 'Total Commission Base',
  '已关联订单': 'Linked Orders',
  '已分发': 'Distributed',
  '已推送过，仅管理员可重复推送': 'Already pushed; only admins can push again',
  '已移除': 'Removed',
  '应发小计': 'Gross Pay Subtotal',
  '应扣小计': 'Deduction Subtotal',
  '建议改为「禁用」，保留映射数据备查。': 'Recommend setting to "Disabled" to keep the mapping data for reference.',
  '当前工厂单号': 'Current Factory Order No.',
  '彻底删除': 'Delete Permanently',
  '待分发': 'Pending Distribution',
  '成衣订单销售提成': 'Finished-Garment Order Sales Commission',
  '我方选项名称': 'Our Option Name',
  '我方选项编码': 'Our Option Code',
  '我的档案': 'My Profile',
  '手机号': 'Mobile Number',
  '推送 Key': 'Push Key',
  '推送时间': 'Push Time',
  '推送模式': 'Push Mode',
  '推送部位': 'Push Part',
  '搜索订单号 / 客户姓名': 'Search Order No. / Customer Name',
  '数据异常，请财务/系统管理员人工修复': 'Data anomaly — please have Finance or the System Admin fix it manually',
  '新增可关联订单': 'Add Linkable Orders',
  '新增提成规则': 'Add Commission Rule',
  '暂无可添加的订单': 'No orders available to add',
  '最多10张': 'Up to 10',
  '最多10张图片': 'Up to 10 images',
  '未入账': 'Not Recorded',
  '本月无已入账订单': 'No recorded orders this month',
  '模版名称': 'Template Name',
  '添加其它类型订单': 'Add Other Order Type',
  '添加其它订单': 'Add Other Order',
  '点击可预览': 'Click to Preview',
  '物料供应商（可选）': 'Material Supplier (optional)',
  '物流费为必填项，不能为0': 'Shipping fee is required and cannot be 0',
  '确认再次推送': 'Confirm Re-push',
  '确认再次推送？': 'Push again?',
  '确认合并': 'Confirm Merge',
  '确认将选中的': 'Mark the selected ',
  '确认拆分': 'Confirm Split',
  '确认转交': 'Confirm Transfer',
  '禁用（推荐）': 'Disabled (recommended)',
  '签收失败': 'Sign-off Failed',
  '管理我方设计选项与工厂工艺编码的映射关系': 'Manage the mapping between our design options and factory workmanship codes',
  '系统默认语言': 'System Default Language',
  '结算月': 'Settlement Month',
  '编辑档案': 'Edit Profile',
  '缺勤天数': 'Absence Days',
  '耗时(ms)': 'Duration (ms)',
  '至少保留一个订单在原发票中': 'At least one order must remain on the original invoice',
  '设计选项加载中，网络异常或加载延长，请稍后！': 'Loading design options — network issue or slow load, please wait!',
  '请至少选择一个要拆出的订单': 'Please select at least one order to split out',
  '请输入邮箱': 'Please enter an email address',
  '请选择一张作为主发票（保留其发票编号），其余发票将被合并后删除。': 'Select one as the primary invoice (its invoice number is kept); the others will be merged and deleted.',
  '请选择业务员': 'Please select sales staff',
  '请选择主发票': 'Please select the primary invoice',
  '请选择单位': 'Please select a unit',
  '请选择客户等级': 'Please select a customer tier',
  '请选择物料类别': 'Please select a material category',
  '超时时间(秒)': 'Timeout (seconds)',
  '身份证号': 'ID Number',
  '转交后，新订单将自动归属新业务员；旧订单提成不受影响': 'After the transfer, new orders will belong to the new sales staff member; commission on existing orders is unaffected',
  '转交门店': 'Transfer Store',
  '选择业务员': 'Select Sales Staff',
  '选择新业务员': 'Select New Sales Staff',
  '部分订单关联失败': 'Some orders failed to link',
  '采购日期止': 'Procurement Date To',
  '采购日期起': 'Procurement Date From',
  '采购申请日期止': 'Procurement Request Date To',
  '采购申请日期起': 'Procurement Request Date From',
  '重新计算': 'Recalculate',
  '重置密码 / 绑定业务员': 'Reset Password / Bind Sales Staff',
  '金额(USD)': 'Amount (USD)',
  '发票金额(USD)': 'Invoice Amount (USD)',
  '提成基数(USD)': 'Commission Base (USD)',
  '门店号': 'Store No.',
  '门店客户账号创建成功，登录账号：': 'Store customer account created. Login: ',
  '门店转交成功': 'Store transferred successfully',
  '验证失败': 'Verification Failed',
  ' + 其他成员 $': ' + Other Members $',
  '0=自动': '0 = Auto',
  '15 天': '15 days',
  '30 天': '30 days',
  '60 天': '60 days',
  '7 天': '7 days',
  '90 天': '90 days',
  'API地址': 'API Address',
  'API基础地址': 'API Base URL',
  'API对接配置': 'API Integration Settings',
  'API秘钥/密码': 'API Key / Password',
  'CMT 加工费': 'CMT Fee',
  'HP尺寸调整映射（JSON）': 'HP Size Adjustment Mapping (JSON)',
  'measurements 中的字段名，为空时使用字段代码': 'Field name in measurements; falls back to the field code when empty',
  '· 与业务员相同阶梯': '· Same tiers as sales staff',
  '· 全员业绩合计用于计算团队管理提成': '· Total team sales are used to calculate team management commission',
  '一键全选': 'Select All',
  '一键勾选/取消全部待付订单': 'Select / deselect all pending-payment orders',
  '一键发放该月工资给所有人': 'Distribute that month\'s payroll to everyone',
  '一键设置所有人基数': 'Set Everyone\'s Base to One Value',
  '三件套': 'Three-Piece Suit',
  '上传中...': 'Uploading...',
  '上月暂无数据': 'No data for last month',
  '上海最低基数参考（实时按左侧参数计算）：': 'Shanghai Minimum Base Reference (calculated live from the parameters on the left):',
  '下单日期止': 'Order Date To',
  '下单日期起': 'Order Date From',
  '下摆围': 'Hem Circumference',
  '下载图片': 'Download Image',
  '不匹配字段': 'Unmatched Fields',
  '业务员提成计算': 'Sales Staff Commission Calculator',
  '业务员账号名（绑定到该业务员名下）': 'Sales staff account name (bound to this salesperson)',
  '两件套': 'Two-Piece Suit',
  '个人': 'Personal',
  '个人业绩覆盖(USD)': 'Personal Sales Override (USD)',
  '个人合计扣减': 'Total Personal Deductions',
  '个人扣减 = 基数 × 对应比例，修改基数后自动计算': 'Personal deduction = base × rate; recalculated automatically when the base changes',
  '个人承担': 'Employee Portion',
  '个人提成与业务员相同（所有订单类型统一计算）；团队管理提成基于全团队总销售额（含本人）超额累进': 'Personal commission is the same as for sales staff (all order types calculated uniformly); team management commission is based on total team sales (including self) on a progressive scale',
  '个字段不匹配': ' field(s) unmatched',
  '个字段匹配': ' field(s) matched',
  '个性加价成本': 'Customization Surcharge Cost',
  '个税 = (应发 - 社保 - 公积金 - 起征点) × 税率': 'Income tax = (Gross − Social Insurance − Housing Fund − Threshold) × Rate',
  '个税社保参数（上海）': 'Income Tax & Social Insurance Parameters (Shanghai)',
  '个订单工厂': ' order(s) — factory',
  '个采购单修改物料供应商': ' purchase order(s) — change material supplier',
  '个采购单关联订单的工厂': ' purchase order(s) — the factory of the linked order',
  '个门店': ' store(s)',
  '中文翻译': 'Chinese Translation',
  '主索引': 'Primary Index',
  '主色调': 'Primary Color',
  '主题模式': 'Theme Mode',
  '主题配置说明': 'Theme Configuration Guide',
  '互斥冲突 / 自动改动记录': 'Conflicts / Auto-adjustment Log',
  '仅可添加同门店、未开票、未付款且已初审（含）以上的订单。运费/关税/特殊设计费/折扣默认0，可在此编辑为准确值，手续费自动计算；勾选或点“添加”即带着这些费用并入上方关联订单。': 'Only orders from the same store that are uninvoiced, unpaid and at least pre-reviewed can be added. Shipping / duty / special design fee / discount default to 0 and can be edited to exact values here; the processing fee is calculated automatically. Checking or clicking "Add" merges them, with these fees, into the linked orders above.',
  '仅失败': 'Failed Only',
  '仅成功': 'Successful Only',
  '仅用于员工提成和工资USD→CNY换算，不影响产品定价': 'Used only for employee commission and payroll USD→CNY conversion; does not affect product pricing',
  '仅用于销售价格表计算，独立于定价汇率和薪酬汇率': 'Used only for sales price table calculations; independent of the pricing and payroll rates',
  '今日本人新增': 'Added by me today',
  '从': 'From',
  '从设计项选择（可选）': 'Select from design options (optional)',
  '付款时间': 'Payment Time',
  '价格档区间': 'Price Tier Range',
  '供应商单号': 'Supplier Order No.',
  '侧边栏导航': 'Sidebar Navigation',
  '保存工资条': 'Save Payslip',
  '保存比例': 'Save Rates',
  '修改工厂供应商': 'Change Factory Supplier',
  '修改工厂失败': 'Failed to Update Factory',
  '修改汇率将影响薪酬计算，确认保存？': 'Changing the exchange rate affects payroll calculations. Save anyway?',
  '修改物料供应商': 'Change Material Supplier',
  '允许用户切换语言': 'Allow users to switch language',
  '入账业绩(USD)': 'Recorded Sales (USD)',
  '全勤扣减': 'Full-Attendance Deduction',
  '全员工资明细': 'All-Employee Payroll Details',
  '全局定价汇率（CNY/USD）': 'Global Pricing Rate (CNY/USD)',
  '全部字段匹配': 'All Fields Matched',
  '全部季节': 'All Seasons',
  '全部性别': 'All Genders',
  '全部操作': 'All Actions',
  '全部模块': 'All Modules',
  '全部结果': 'All Results',
  '公司': 'Company',
  '公司合计承担': 'Total Company Contribution',
  '公司承担': 'Company Portion',
  '公积金基数': 'Housing Fund Base',
  '公积金扣缴': 'Housing Fund Contribution',
  '关联发票号': 'Linked Invoice No.',
  '关键指标': 'Key Metrics',
  '其它订单已添加': 'Other order already added',
  '其它费用 (USD)': 'Other Fees (USD)',
  '养老保险': 'Pension Insurance',
  '出让方': 'Transferor',
  '出让方（请假人）': 'Transferor (person on leave)',
  '分享链接已生成，外部客户无需登录即可查看': 'Share link generated — external customers can view it without logging in',
  '分摊金额': 'Allocated Amount',
  '划转管理': 'Transfer Management',
  '删除?': 'Delete?',
  '删除后可在回收站中恢复': 'Can be restored from the Recycle Bin after deletion',
  '利润贡献率': 'Profit Contribution Rate',
  '到': 'To',
  '加工厂': 'Processing Factory',
  '加工商/单号': 'Processor / Order No.',
  '加载历史失败': 'Failed to Load History',
  '加载历史报价单失败': 'Failed to Load Quote History',
  '加载基础价格表失败': 'Failed to Load Base Price Table',
  '加载备忘词失败': 'Failed to Load Memo Keywords',
  '加载失败，请稍后重试': 'Loading failed, please try again later',
  '加载详情失败': 'Failed to Load Details',
  '加载门店列表失败': 'Failed to Load Store List',
  '包含品类列': 'Include Category Column',
  '包含工艺': 'Include Workmanship',
  '医疗保险': 'Medical Insurance',
  '单位：CNY': 'Unit: CNY',
  '即将修改': 'About to Modify',
  '卷': 'Roll',
  '厂单': 'Factory Order',
  '原始返回 / Raw response': 'Raw Response',
  '双': 'Double',
  '反查工厂': 'Look Up Factory',
  '发票创建日期': 'Invoice Created Date',
  '发票已付总额': 'Total Paid on Invoice',
  '发货单号：': 'Shipment No.: ',
  '发货地': 'Ship From',
  '发货通知Webhook': 'Shipment Notification Webhook',
  '取消入账': 'Cancel Recording',
  '受让方': 'Transferee',
  '受让方（代管人）': 'Transferee (custodian)',
  '只有未完成初审、已驳回或已取消的订单才能删除': 'Only orders that have not passed pre-review, have been rejected, or have been cancelled can be deleted',
  '可添加同门店、已初审（含）以上的西服订单（不限付款状态）；或添加无订单号的其它类型订单（如零散费用等）。运费/关税/折扣默0，可编辑，手续费自动计算。': 'You can add suit orders from the same store that are at least pre-reviewed (any payment status), or add other order types without an order number (such as miscellaneous fees). Shipping / duty / discount default to 0 and are editable; the processing fee is calculated automatically.',
  '可用变量': 'Available Variables',
  '可直接 Ctrl+V 粘贴图片': 'You can paste images directly with Ctrl+V',
  '可补充备注信息': 'You may add a note',
  '后浪': 'Back Rise',
  '启用API对接': 'Enable API Integration',
  '启用API日志': 'Enable API Logging',
  '启用对接': 'Enable Integration',
  '启用（激活后账号才能登录）': 'Enabled (the account can log in only after activation)',
  '品名': 'Item Name',
  '品类利润分析': 'Category Profit Analysis',
  '回填审核成衣尺寸': 'Backfill Review Measurements',
  '团队业绩覆盖(USD)': 'Team Sales Override (USD)',
  '团队合计（': 'Team Total (',
  '团队成员销售业绩': 'Team Member Sales',
  '固定$/单': 'Fixed $/Order',
  '固定头部': 'Fixed Header',
  '固定金额($)': 'Fixed Amount ($)',
  '图片不能超过10MB': 'Images cannot exceed 10MB',
  '图片已下载到本地': 'Image downloaded',
  '圆角大小': 'Corner Radius',
  '基础价格表（价格档×工艺×品类）': 'Base Price Table (Price Tier × Workmanship × Category)',
  '备忘记录': 'Memo Log',
  '备忘词总数不能超过20个': 'You can have at most 20 memo keywords',
  '备注（交代事项，可选，保存到该合并采购单）': 'Note (instructions, optional; saved to this merged purchase order)',
  '备注（交代事项，可选，保存到该采购单）': 'Note (instructions, optional; saved to this purchase order)',
  '备注（可选）': 'Note (optional)',
  '备注，如：产假/请假一周': 'Note, e.g. maternity leave / one week off',
  '复制图片': 'Copy Image',
  '复用全部': 'Reuse All',
  '大 (16px)': 'Large (16px)',
  '失业保险': 'Unemployment Insurance',
  '失败信息': 'Failure Details',
  '套': 'Set',
  '如 0.85 表示 8.5 折': 'e.g. 0.85 means 15% off',
  '如 FAC-HP，JD 留空': 'e.g. FAC-HP; leave blank for JD',
  '如: Church\'s, John Lobb': 'e.g. Church\'s, John Lobb',
  '如: F001': 'e.g. F001',
  '如: order.status.pending': 'e.g. order.status.pending',
  '如: order_confirmation_email': 'e.g. order_confirmation_email',
  '如: salesperson': 'e.g. salesperson',
  '如：Front Length，用于英文界面/工艺单/发票展示': 'e.g. Front Length; used in the English UI, craft sheets and invoices',
  '如：jacket_front_length，空=使用字段代码': 'e.g. jacket_front_length; blank = use the field code',
  '如：里布编号/面料编号': 'e.g. lining no. / fabric no.',
  '字体大小': 'Font Size',
  '字段': 'Field',
  '实发': 'Net Pay',
  '实发合计': 'Net Pay Total',
  '实发工资明细': 'Net Pay Details',
  '客户已创建': 'Customer created',
  '密码错误，还可尝试__n__次': 'Incorrect password — __n__ attempt(s) remaining',
  '导出 Excel 价格表': 'Export Excel Price Table',
  '导出PNG并复制': 'Export PNG & Copy',
  '导出工艺单': 'Export Craft Sheet',
  '导出模式': 'Export Mode',
  '导出洗唛': 'Export Care Label',
  '导出采购图片': 'Export Procurement Images',
  '将使用当前筛选条件（品牌、样本册、价格档、关键词）导出数据': 'Export using the current filters (brand, sample book, price tier, keyword)',
  '将本品类的成衣尺寸覆盖到审核成衣尺寸（推送尺寸），请确认无误后继续。': 'This will overwrite the review measurements (push size) with this category\'s finished measurements. Please confirm before continuing.',
  '将清除该员工该月的手工编辑（业绩、提成、社保、公积金、个税、缺勤），重新按发票记录与配置自动计算，是否继续？': 'This will clear this employee\'s manual edits for the month (sales, commission, social insurance, housing fund, income tax, absence) and recalculate automatically from invoice records and configuration. Continue?',
  '小 (12px)': 'Small (12px)',
  '尖角': 'Sharp Corner',
  '工伤': 'Work Injury',
  '工伤+生育': 'Work Injury + Maternity',
  '工伤保险': 'Work Injury Insurance',
  '工作汇总工资条的社保/公积金/个税计算基数与比例；缴费基数默认按员工实际工资总额（可在工资条中单独修改），低于下限按下限、高于上限按上限': 'Bases and rates used for social insurance / housing fund / income tax in the payroll summary. The contribution base defaults to the employee\'s total actual salary (editable per payslip); below the floor the floor applies, above the cap the cap applies',
  '工厂API地址': 'Factory API Address',
  '工厂API配置': 'Factory API Configuration',
  '工厂单号/工厂供应商': 'Factory Order No. / Factory Supplier',
  '工厂单号：': 'Factory Order No.: ',
  '工厂反查结果': 'Factory Lookup Result',
  '工厂地址': 'Factory Address',
  '工厂工费对账与结算管理': 'Factory Labor Cost Reconciliation & Settlement',
  '工厂接口配置': 'Factory Interface Configuration',
  '工厂编码': 'Factory Code',
  '工厂记录': 'Factory Records',
  '工艺互斥验证未通过': 'Workmanship conflict validation failed',
  '工艺检测通过，可推送': 'Workmanship check passed — ready to push',
  '工资条尚未分发，请耐心等待财务确认后查看': 'Your payslip has not been distributed yet — please wait for Finance to confirm',
  '已取消入账': 'Recording Cancelled',
  '已启用，账号可登录': 'Enabled — the account can log in',
  '已复制到剪贴板': 'Copied to clipboard',
  '已恢复上次编辑的未保存数据': 'Restored unsaved data from your last edit',
  '已恢复历史报价单': 'Quote history restored',
  '已撤回推送': 'Push withdrawn',
  '已撤销': 'Revoked',
  '已新增': 'Added',
  '已新增划转': 'Transfer added',
  '已有': 'Existing',
  '已标记离职': 'Marked as Departed',
  '已添加': 'Added',
  '已申请/待处理': 'Applied / Pending',
  '已确认入账': 'Recording Confirmed',
  '已确认签收': 'Sign-off Confirmed',
  '已禁用该选项': 'This option has been disabled',
  '已禁用，账号无法登录': 'Disabled — the account cannot log in',
  '已自动匹配': 'Auto-matched',
  '已设为不推送工厂': 'Set to not push to factory',
  '已设为推送工厂': 'Set to push to factory',
  '已设置所有人基数为默认值': 'Everyone\'s base set to the default',
  '已达': 'Reached',
  '已选记录数': 'Selected Records',
  '已重新计算': 'Recalculated',
  '布局方式': 'Layout',
  '布局配置': 'Layout Configuration',
  '平均完成率': 'Average Completion Rate',
  '平均客单价': 'Average Order Value',
  '平均订单毛利': 'Average Order Gross Profit',
  '平均订单金额': 'Average Order Amount',
  '平摆': 'Flat Hem',
  '序号': 'No.',
  '应急手机号': 'Emergency Mobile',
  '开始(可选)': 'Start (optional)',
  '当前': 'Current',
  '彻底删除订单': 'Delete Order Permanently',
  '待审订单': 'Orders Pending Review',
  '总提成': 'Total Commission',
  '总毛利': 'Total Gross Profit',
  '总毛利率': 'Total Gross Margin',
  '总订单数': 'Total Orders',
  '总订单金额': 'Total Order Amount',
  '总销售额': 'Total Sales',
  '成本构成': 'Cost Breakdown',
  '成本率': 'Cost Ratio',
  '我方名称': 'Our Name',
  '我方字段': 'Our Field',
  '我方工艺项': 'Our Workmanship Item',
  '我方工艺项关键词': 'Our Workmanship Item Keyword',
  '我方工艺项编码': 'Our Workmanship Item Code',
  '我方推送': 'Push by Us',
  '我的工资条': 'My Payslip',
  '我的采购': 'My Procurement',
  '截图': 'Screenshot',
  '所属业务员': 'Assigned Sales Staff',
  '手续费将自动计算（金额×4.5%+0.3），添加后发票总额自动更新，已付金额不变，未付金额相应增加。': 'The processing fee is calculated automatically (amount × 4.5% + 0.3). After adding, the invoice total updates automatically; the paid amount stays the same and the unpaid amount increases accordingly.',
  '打印模版': 'Print Template',
  '批量修改工厂供应商': 'Bulk Change Factory Supplier',
  '批量修改物料供应商': 'Bulk Change Material Supplier',
  '批量申请要求所有采购单使用相同的工厂供应商，请重新选择': 'Bulk requests require all purchase orders to use the same factory supplier. Please select again.',
  '批量申请要求所有采购单使用相同的物料供应商，请重新选择': 'Bulk requests require all purchase orders to use the same material supplier. Please select again.',
  '批量转交': 'Bulk Transfer',
  '批量转交门店': 'Bulk Transfer Store',
  '找到': 'Found',
  '技术人员': 'Technical Staff',
  '技术经理': 'Technical Manager',
  '报价单数据不存在': 'Quote data not found',
  '报价单编号': 'Quote No.',
  '报价汇率（CNY/USD）': 'Quote Rate (CNY/USD)',
  '按当月订单总金额分档计算，超额累进（所有订单类型统一计算）': 'Calculated in tiers on the month\'s total order amount, progressive (all order types calculated uniformly)',
  '按成衣订单总金额计算提成': 'Commission is calculated on the total amount of finished-garment orders',
  '按样本册/品牌分 Sheet（推荐）': 'Split sheets by sample book / brand (recommended)',
  '按订单号查询': 'Search by Order No.',
  '按跟单订单总金额分档计算，技术人员/行政人员适用': 'Calculated in tiers on the total order-tracking amount; applies to technical and administrative staff',
  '按钮权限': 'Button Permissions',
  '推给工厂的尺寸 JSON': 'Size JSON Pushed to Factory',
  '推给工厂的工艺 JSON': 'Workmanship JSON Pushed to Factory',
  '推送到无API工厂': 'Push to Non-API Factory',
  '推送到照片反馈': 'Push to Photo Feedback',
  '推送日志': 'Push Log',
  '推送详情': 'Push Details',
  '提交补充': 'Submit Supplement',
  '提成值': 'Commission Value',
  '提成划转管理': 'Commission Transfer Management',
  '提成合计明细': 'Commission Summary Details',
  '提成结算': 'Commission Settlement',
  '搜索...': 'Search...',
  '搜索业务员': 'Search Sales Staff',
  '搜索名称/联系人': 'Search Name / Contact',
  '搜索员工': 'Search Employee',
  '搜索失败': 'Search Failed',
  '搜索客户名/电话': 'Search Customer Name / Phone',
  '搜索我方或HP编码、名称': 'Search our or HP code / name',
  '搜索用户/详情': 'Search User / Details',
  '搜索编号/名称/联系人': 'Search No. / Name / Contact',
  '搜索订单号/客户名': 'Search Order No. / Customer Name',
  '搜索键名/内容': 'Search Key / Content',
  '搜索门店名称 / 门店编号...': 'Search store name / store no...',
  '撤回后将删除该采购记录，是否继续？': 'Withdrawing will delete this procurement record. Continue?',
  '撤回采购申请': 'Withdraw Procurement Request',
  '撤销付款': 'Revoke Payment',
  '撤销后将回滚订单已付金额、付款状态与门店余额，确定撤销该付款记录吗？': 'Revoking will roll back the order\'s paid amount, payment status and store balance. Are you sure you want to revoke this payment?',
  '支付通知Webhook': 'Payment Notification Webhook',
  '支持拖拽图片到此处或 Ctrl+V 粘贴': 'Drag images here or paste with Ctrl+V',
  '整体毛利率': 'Overall Gross Margin',
  '整月': 'Full Month',
  '斑马纹表格': 'Zebra-Striped Table',
  '新增用户成功': 'User created successfully',
  '新增门店用户': 'Add Store User',
  '新建发票': 'New Invoice',
  '新建采购': 'New Procurement',
  '新建采购申请': 'New Procurement Request',
  '无互斥工艺，工艺验证通过 / No conflicts, tech validation passed': 'No conflicting workmanship — validation passed',
  '时间段': 'Period',
  '暂无历史报价单': 'No quote history',
  '暂无历史记录': 'No history',
  '暂无备忘词': 'No memo keywords',
  '暂无工厂API配置，请在工厂管理中添加工厂后配置': 'No factory API configuration yet — add a factory in Factory Management first',
  '暂无工资数据': 'No payroll data',
  '暂无推送日志（推送订单后会自动记录）': 'No push logs yet (logged automatically after pushing orders)',
  '暂无数据可导出': 'No data to export',
  '暂无生产节点记录': 'No production node records',
  '暂无门店数据': 'No store data',
  '更新单号': 'Update Order No.',
  '更新物流单号': 'Update Tracking No.',
  '最低($)': 'Minimum ($)',
  '最低基数': 'Minimum Base',
  '最近消费日期': 'Last Purchase Date',
  '最高($,空=无限)': 'Maximum ($, blank = unlimited)',
  '月销售额区间': 'Monthly Sales Range',
  '有工艺互斥冲突，需修改后推送': 'There are conflicting workmanship items — fix them before pushing',
  '有效期': 'Validity Period',
  '有新生产状态，点击查看': 'New production status available — click to view',
  '未付款金额': 'Unpaid Amount',
  '未找到匹配订单': 'No matching orders found',
  '未签收': 'Not Signed Off',
  '未绑定': 'Not Bound',
  '未绑定角色': 'No Role Assigned',
  '未结算': 'Unsettled',
  '本人销售额': 'Own Sales',
  '本人销售额 $': 'Own Sales $',
  '本批次暂无采购单': 'No purchase orders in this batch',
  '本月暂无数据': 'No data this month',
  '本月暂无订单': 'No orders this month',
  '本月累计订单': 'Orders This Month',
  '本次推送未发现问题': 'No issues found in this push',
  '条更新失败': ' record(s) failed to update',
  '条结果，请输入完整订单号精确匹配': ' result(s) — enter a complete order number for an exact match',
  '标准 (14px)': 'Standard (14px)',
  '标题客户/门店名称（选填，用于标题行）': 'Header customer / store name (optional; used in the header row)',
  '格式：{"suit": "工艺项,工艺项,调整量/工艺项,工艺项,调整量"}': 'Format: {"suit": "workmanship item,workmanship item,adjustment/workmanship item,workmanship item,adjustment"}',
  '检测到互斥工艺，请与客户确认后修改 / Conflicting craft items detected': 'Conflicting workmanship items detected — please confirm with the customer and fix',
  '模版代码': 'Template Code',
  '模版内容': 'Template Content',
  '模版内容，使用 {{variable}} 作为变量占位符': 'Template content; use {{variable}} as the variable placeholder',
  '模版预览': 'Template Preview',
  '次': ' time(s)',
  '次上限': ' time(s) limit',
  '正在生成图片...': 'Generating image...',
  '每个订单行都必须绑定订单号，请先绑定或删除未绑定的行': 'Every order line must be bound to an order number — please bind or delete unbound lines first',
  '每年7月更新基数（按上年月均工资申报，低于下限按下限7460）。修改后点"保存设置"生效。': 'Bases are updated every July (declared on last year\'s average monthly salary; below the floor, the floor of 7460 applies). Click "Save Settings" to apply.',
  '比例已保存': 'Rates saved',
  '毛利占比': 'Gross Profit Share',
  '永久删除不可恢复，确认删除该用户账号？': 'Permanent deletion cannot be undone. Delete this user account?',
  '永久删除不可恢复，确认删除该用户？': 'Permanent deletion cannot be undone. Delete this user?',
  '永久删除不可恢复，确认删除该门店？': 'Permanent deletion cannot be undone. Delete this store?',
  '没有可合并的其他发票': 'No other invoices to merge',
  '没有可复制的成衣尺寸（业务员尚未填写成衣尺寸）': 'No finished measurements to copy (sales staff haven\'t entered them yet)',
  '没有待付款订单': 'No pending-payment orders',
  '浅色模式': 'Light Mode',
  '消费总额': 'Total Spend',
  '消费者': 'Customer',
  '消费者明细': 'Customer Details',
  '深色模式': 'Dark Mode',
  '混合布局': 'Mixed Layout',
  '点击选择/取消备忘词（最多20个）': 'Click to select / deselect memo keywords (max 20)',
  '照片反馈内容': 'Photo Feedback Content',
  '照片反馈（已发给工厂）': 'Photo Feedback (sent to factory)',
  '物料采购': 'Material Procurement',
  '环比': 'MoM',
  '现住址': 'Current Address',
  '生产工厂': 'Production Factory',
  '生产进度': 'Production Progress',
  '生成日期': 'Generated Date',
  '生成采购单': 'Generate Purchase Order',
  '生育': 'Maternity',
  '生育保险': 'Maternity Insurance',
  '用于面料成本→售价计算，修改将影响所有产品报价': 'Used for fabric cost → retail price calculation; changes affect all product quotes',
  '用户名至少3位': 'Username must be at least 3 characters',
  '留空则不修改密码': 'Leave blank to keep the current password',
  '留空则无需密码即可访问': 'Leave blank for password-free access',
  '登录用户名': 'Login Username',
  '省份': 'Province',
  '短信模版': 'SMS Template',
  '确定撤销': 'Confirm Revoke',
  '确认入账': 'Confirm Recording',
  '确认删除消费者': 'Confirm Delete Customer',
  '确认删除该划转？': 'Delete this transfer?',
  '确认删除该报价单?': 'Delete this quote?',
  '确认发放': 'Confirm Distribution',
  '确认后将发放该月工资给所有员工，员工即可在我的工资条中查看。': 'This will distribute the month\'s payroll to all employees, who can then view it in My Payslip.',
  '确认启用该账号？启用后可登录': 'Enable this account? It will then be able to log in.',
  '确认密码': 'Confirm Password',
  '确认将所有人社保/公积金基数设为默认值？': 'Set everyone\'s social insurance / housing fund base to the default?',
  '确认将所选采购单标记为': 'Mark the selected purchase orders as ',
  '确认将该员工标记为离职？离职后将不参与工资与提成计算。': 'Mark this employee as departed? They will no longer be included in payroll or commission calculations.',
  '确认恢复此客户？': 'Restore this customer?',
  '确认撤回推送吗？本地的供应商与工厂单号一定会被清除，订单回到待发布。有对接接口的工厂会同时删除工厂端订单；删不掉的会提示你到工厂后台手动处理。': 'Withdraw the push? The local supplier and factory order numbers will be cleared and the order returns to Pending Release. Factories with an API will also have the order deleted on their side; if deletion fails you will be prompted to handle it manually in the factory portal.',
  '确认撤回采购申请': 'Confirm Withdraw Procurement Request',
  '确认禁用该账号？禁用后无法登录': 'Disable this account? It will no longer be able to log in.',
  '确认移除该员工？': 'Remove this employee?',
  '确认签收': 'Confirm Sign-off',
  '确认编辑': 'Confirm Edit',
  '确认要再次推送吗？': 'Are you sure you want to push again?',
  '确认覆盖': 'Confirm Overwrite',
  '社保': 'Social Insurance',
  '社保个人合计': 'Total Employee Social Insurance',
  '社保公积金基数默认值来自系统配置': 'Default social insurance / housing fund bases come from system configuration',
  '社保基数': 'Social Insurance Base',
  '社保扣缴': 'Social Insurance Contribution',
  '禁用（禁用后无法登录）': 'Disabled (cannot log in after disabling)',
  '签出成功': 'Checked out successfully',
  '签到': 'Check In',
  '签到成功': 'Checked in successfully',
  '签收': 'Sign Off',
  '签退': 'Check Out',
  '简体中文': 'Simplified Chinese',
  '管理系统全局参数（提成规则请前往主数据-提成规则配置）': 'Manage system-wide parameters (for commission rules, go to Master Data → Commission Rules)',
  '籍贯': 'Place of Origin',
  '系统API配置说明': 'System API Configuration Guide',
  '系统操作日志': 'System Operation Log',
  '紧凑': 'Compact',
  '紧凑模式': 'Compact Mode',
  '组件样式': 'Component Style',
  '组合分组ID': 'Group ID',
  '经理本人': 'Manager (Self)',
  '经理本人 $': 'Manager (Self) $',
  '绑定业务员': 'Bind Sales Staff',
  '绑定角色': 'Bind Role',
  '绑定门店失败': 'Failed to Bind Store',
  '结束(可选)': 'End (optional)',
  '继承自上衣': 'Inherited from Jacket',
  '编码模糊搜索': 'Fuzzy Search by Code',
  '编辑提成规则': 'Edit Commission Rule',
  '编辑警告': 'Edit Warning',
  '耗料 & 价格': 'Material Usage & Price',
  '联系方式': 'Contact Info',
  '自动带出该经理上月业绩与团队成员业绩记录': 'Automatically pulls in this manager\'s sales last month and team member records',
  '自定义备忘词': 'Custom Memo Keyword',
  '自定义系统界面风格。修改后会立即生效，仅影响当前用户的显示效果。': 'Customize the system\'s UI style. Changes take effect immediately and only affect your own view.',
  '英文工艺单': 'English Craft Sheet',
  '菜单权限': 'Menu Permissions',
  '薪酬汇率（USD→CNY）': 'Payroll Rate (USD→CNY)',
  '薪酬设置': 'Payroll Settings',
  '补充信息提交成功': 'Additional information submitted successfully',
  '补充备注': 'Add Note',
  '表格配置': 'Table Configuration',
  '裤子': 'Trousers',
  '裤装': 'Trousers',
  '西裤(单褶)': 'Dress Trousers (Single Pleat)',
  '西裤(双褶)': 'Dress Trousers (Double Pleat)',
  '西裤(无褶)': 'Dress Trousers (Flat Front)',
  '规则类型': 'Rule Type',
  '计算价格': 'Calculate Price',
  '计薪人数': 'Payroll Headcount',
  '计薪人数明细': 'Payroll Headcount Details',
  '订单号：': 'Order No.: ',
  '订单将直接标记为生产中，请选择目标工厂：': 'The order will be marked as In Production — select the target factory:',
  '订单总量': 'Total Order Volume',
  '订单数据加载中，请稍后再试': 'Order data is loading, please try again later',
  '订单状态变更Webhook': 'Order Status Change Webhook',
  '订单量': 'Order Volume',
  '记录为空，无法计算': 'No records to calculate',
  '记录系统中所有用户的操作行为，可用于审计和问题追踪。日志保留期限为90天。': 'Records all user actions for auditing and troubleshooting. Logs are retained for 90 days.',
  '设计师': 'Designer',
  '证件信息': 'ID Information',
  '词条用途说明': 'Keyword Usage Guide',
  '词条管理': 'Keyword Management',
  '该备忘词已存在': 'This memo keyword already exists',
  '该订单已复审通过，编辑将记录变更日志。确认继续编辑？': 'This order has passed the second review — edits will be logged. Continue editing?',
  '该设计项有工厂映射，请谨慎操作': 'This design option has a factory mapping — proceed with caution',
  '该选项有工厂映射，请谨慎操作': 'This option has a factory mapping — proceed with caution',
  '说明：比例 100% = 全额划转；平均分配给多人时，为每人各建一条（如 3 人各 33%）；不填时间段则整月生效': 'Note: 100% = full transfer. To split evenly among several people, create one record per person (e.g. 33% each for 3 people). Leaving the period blank applies it to the whole month.',
  '请上传付款截图': 'Please upload a payment screenshot',
  '请上传参考图片': 'Please upload a reference image',
  '请为以下订单选择工厂供应商': 'Please select a factory supplier for the following orders',
  '请为以下采购记录选择采购用途': 'Please select a procurement purpose for the following records',
  '请为所有采购单选择工厂供应商': 'Please select a factory supplier for all purchase orders',
  '请先勾选一条订单，或输入订单号搜索': 'Select an order first, or search by order number',
  '请先搜索并选择订单': 'Please search and select an order first',
  '请只勾选一条订单进行复制': 'Please select exactly one order to copy',
  '请填写品名': 'Please enter the item name',
  '请填写备注或上传付款截图': 'Please add a note or upload a payment screenshot',
  '请求异常 / Request Error': 'Request Error',
  '请求超时时间(秒)': 'Request Timeout (seconds)',
  '请添加至少一个订单行': 'Please add at least one order line',
  '请输入合作折扣': 'Please enter the partner discount',
  '请输入品名/说明': 'Please enter the item name / description',
  '请输入物流公司名称': 'Please enter the carrier name',
  '请输入真实姓名': 'Please enter the real name',
  '请输入绣字内容': 'Please enter the monogram text',
  '请输入订单号或客户名': 'Please enter an order number or customer name',
  '请选择入账状态': 'Please select a payment status',
  '请选择出让方': 'Please select the transferor',
  '请选择出货期': 'Please select the shipment period',
  '请选择刺绣位置': 'Please select the embroidery position',
  '请选择受让方': 'Please select the transferee',
  '请选择员工': 'Please select an employee',
  '请选择字体颜色': 'Please select the font color',
  '请选择有效期': 'Please select the validity period',
  '请选择物料供应商（可选）': 'Please select a material supplier (optional)',
  '财务人员': 'Finance Staff',
  '账号状态': 'Account Status',
  '跟单业绩': 'Order Tracking Sales',
  '跟单提成计算': 'Order Tracking Commission Calculator',
  '跟单提成阶梯': 'Order Tracking Commission Tiers',
  '跟单提成（技术人员/行政人员）': 'Order Tracking Commission (Technical / Administrative Staff)',
  '跟单金额': 'Order Tracking Amount',
  '跟单金额区间 (USD)': 'Order Tracking Amount Range (USD)',
  '身份证正面': 'ID Card (Front)',
  '身高筛选': 'Height Filter',
  '转交给业务员': 'Transfer to Sales Staff',
  '辅料标记': 'Accessory Tag',
  '输入变量名，按回车确认': 'Enter a variable name and press Enter',
  '运费 (USD)': 'Shipping (USD)',
  '运输公司：': 'Carrier: ',
  '选填，设置后需输入密码才能查看': 'Optional; once set, a password is required to view',
  '选择业务经理': 'Select Sales Manager',
  '选择后自动填写下方字段': 'Selecting this fills in the fields below automatically',
  '选择员工': 'Select Employee',
  '选择推送到哪个尺寸串': 'Select which measurement string to push to',
  '选择无API工厂': 'Select Non-API Factory',
  '选择模块': 'Select Module',
  '选择经理': 'Select Manager',
  '选择角色': 'Select Role',
  '选设计项自动填写编码': 'Selecting a design option auto-fills the code',
  '选项（自动填写我方编码/名称）': 'Option (auto-fills our code / name)',
  '邮件主题': 'Email Subject',
  '邮件主题，可使用变量如 {{order_no}}': 'Email subject; variables such as {{order_no}} can be used',
  '邮件模版': 'Email Template',
  '部分采购单未能自动匹配供应商，请手动选择': 'Some purchase orders could not be auto-matched to a supplier — please select manually',
  '配置与各个工厂的API对接参数。每个工厂需要独立的API密钥和接口地址。': 'Configure API integration parameters for each factory. Each factory needs its own API key and endpoint.',
  '配置系统API的基础设置和工厂对接接口。修改配置后可能需要重启服务才能生效。': 'Configure the system API basics and factory integration endpoints. A service restart may be required for changes to take effect.',
  '配置系统对外推送通知的Webhook地址，用于订单状态变更、发货通知等。': 'Configure the webhook URL for outbound notifications such as order status changes and shipment notices.',
  '采购专员': 'Procurement Specialist',
  '采购申请已提交': 'Procurement request submitted',
  '采购详情': 'Procurement Details',
  '重新计算业绩提成': 'Recalculate Sales Commission',
  '销售业绩 (USD)': 'Sales (USD)',
  '销售业绩(USD)': 'Sales (USD)',
  '销售总额': 'Total Sales',
  '销售总额 (USD)': 'Total Sales (USD)',
  '销售明细': 'Sales Details',
  '销售额%': 'Sales %',
  '销售额明细': 'Sales Details',
  '门店号/工厂单号/面料号/客户（空格隔开多个）': 'Store no. / factory order no. / fabric no. / customer (separate multiple with spaces)',
  '门店号/工厂单号/面料号（空格隔开多个）': 'Store no. / factory order no. / fabric no. (separate multiple with spaces)',
  '门店编号模糊搜索': 'Fuzzy Search by Store No.',
  '面料×品类×工艺组合定价': 'Fabric × Category × Workmanship Combination Pricing',
  '面料供应商/面料编号': 'Fabric Supplier / Fabric No.',
  '顶部导航': 'Top Navigation',
  '项成衣尺寸到审核尺寸': ' finished measurements to review measurements',
  '项目': 'Item',
  '颜色主题': 'Color Theme',
  '驳回原因': 'Rejection Reason',
  '验证工艺互斥': 'Validate Workmanship Conflicts',
  '默认收起侧边栏': 'Collapse Sidebar by Default',
  '默认表格密度': 'Default Table Density',
  '默认语言设置': 'Default Language Settings',
  '（自动创建新门店并分配登录账号）': '(automatically creates a new store and assigns a login)',
  '（自动创建门店并生成登录账号）': '(automatically creates a store and generates a login)',
  // ===== 2026-09-21 出入库模块：模板字符串陷阱修复引入的占位符 key =====
  '已识别物流单号：{no}': 'Tracking number recognized: {no}',
  '识别到 {n} 个候选，请点击选择': 'Found {n} candidate(s) — click to select',
  '识别到 {n} 个候选工厂单号，请核对': 'Found {n} factory order candidate(s) — please verify',
  '已匹配 {n} 个待入库订单': 'Matched {n} order(s) pending inbound',
  '已入库 {n} 单': '{n} order(s) received',
  '即将对 {n} 个订单标记入库': 'About to mark {n} order(s) as inbound',
  '即将对 {n} 个订单标记出库': 'About to mark {n} order(s) as outbound',
  '即将撤销 {n} 个订单的入库记录': 'About to revoke the inbound record(s) of {n} order(s)',
  '即将撤销 {n} 个订单的出库记录': 'About to revoke the outbound record(s) of {n} order(s)',
  '确认入库 ({n} 单)': 'Confirm Inbound ({n} order(s))',
  '匹配到 {n} 个待入库订单，请勾选后确认入库': 'Matched {n} order(s) pending inbound — select and confirm',
  // ===== 2026-09-21 i18n 收尾：Dashboard 汇总卡片缺失的 3 个 key =====
  '门店本月订单汇总': 'Store Orders This Month',
  '设计师本月订单汇总': 'Designer Orders This Month',
  '上月设计师订单汇总': 'Designer Orders Last Month',
  // ===== 2026-09-21 i18n A 类批次A1：工厂映射管理（FactoryMappingManager）=====
  '+ 追加推送': '+ Append Push',
  'CSS色值 (如 #FF0000)': 'CSS Color Value (e.g. #FF0000)',
  'HP品类代码（工厂）': 'HP Category Code (Factory)',
  'HP品类名（如:上衣/大衣/马甲）': 'HP Category Name (e.g. Jacket/Coat/Vest)',
  'HP特体代码 code（工厂）': 'HP Special Body Code (Factory)',
  'HP特体参数 JSON ({"suit":"字段,值/字段,值"})': 'HP Special Body Params JSON ({"suit":"field,value/field,value"})',
  'HP特体参数 adjustments': 'HP Special Body Params adjustments',
  'HP订单类型 ordertype（工厂）': 'HP Order Type ordertype (Factory)',
  'HP部位名称（工厂，推送时写入）': 'HP Body Part Name (Factory; written on push)',
  'JD品类代码（我方）': 'JD Category Code (Ours)',
  'JD套装类型（我方）': 'JD Suit Type (Ours)',
  'adjustments 存储 HP 推送时 measure_up/down/vest_alter 特体参数': 'adjustments stores the measure_up/down/vest_alter special body params from the HP push',
  'auto（自动替换为默认值）': 'auto (auto-replace with default)',
  'boya_key（推送字段名，空=用field_code）': 'boya_key (push field name; blank = use field_code)',
  'ignore（不处理）': 'ignore (skip)',
  'photo_feedback（推到备注说明）': 'photo_feedback (push to remarks)',
  'tech_name（中文）': 'tech_name (Chinese)',
  '→ HP部位名（工厂）': '→ HP Body Part Name (Factory)',
  '→ 工厂刺绣线编码': '→ Factory Embroidery Thread Code',
  '→ 工厂品类': '→ Factory Category',
  '→ 工厂工艺项': '→ Factory Workmanship Item',
  '① 选品类': '① Select Category',
  '② 选设计项': '② Select Design Item',
  '③ 筛选选项（可选/可输入）': '③ Filter Options (optional / typeable)',
  '上衣 JKT': 'Jacket JKT',
  '上衣 suit': 'Jacket suit',
  '上衣 up': 'Jacket up',
  '下裤 down': 'Trousers down',
  '中文 / 英文名称（我方）': 'Chinese / English Name (Ours)',
  '中文名称（我方）': 'Chinese Name (Ours)',
  '从工厂同步互斥规则': 'Sync Conflict Rules from Factory',
  '保存映射': 'Save Mapping',
  '全部缺失': 'All Missing',
  '共享 shared': 'Shared shared',
  '关联线色号设计项 code（共享线颜色）': 'Linked Thread Color Design Item code (shared thread color)',
  '刺绣线颜色（工厂映射）': 'Embroidery Thread Color (factory mapping)',
  '可选品类+设计项精确筛选，或直接在下方关键词框搜索我方/HP编码': 'Filter precisely by category + design item, or search our / HP codes in the keyword box below',
  '右侧互斥工艺': 'Conflicting Workmanship on the Right',
  '右侧互斥工艺描述（中文）': 'Conflicting Workmanship Description on the Right (Chinese)',
  '同步后可在此处为每条规则补充中文说明，操作员推送时将看到中文互斥提示': 'After syncing, add a Chinese note for each rule here; operators will see the Chinese conflict warning when pushing',
  '含照片反馈': 'Includes Photo Feedback',
  '固定默认': 'Fixed Default',
  '固定默认 (fixed_default)': 'Fixed Default (fixed_default)',
  '处理策略': 'Handling Strategy',
  '多推送': 'Multi-Push',
  '大工艺项代码（tech_xxx）': 'Large Workmanship Item Code (tech_xxx)',
  '大衣 OCT': 'Coat OCT',
  '大衣 coat': 'Coat coat',
  '如 coat~108~bs547，纯照片反馈填 __photo__': 'e.g. coat~108~bs547; for photo-feedback only enter __photo__',
  '如 coat~115': 'e.g. coat~115',
  '如 coat~115~xw101': 'e.g. coat~115~xw101',
  '如需同时追加备注照片，填入反馈文本': 'To also append a remark photo, enter the feedback text',
  '如需追加备注照片文字，填此处': 'Enter text here to append a remark photo',
  '展示所有推送字段映射关系，含我方 + 工厂的中英文名称与编码': 'Shows all push field mappings, including Chinese/English names and codes for ours and the factory',
  '工厂位置编码 factory_code': 'Factory Position Code factory_code',
  '工厂工艺项中文名（可空）': 'Factory Workmanship Item Chinese Name (optional)',
  '工厂工艺项代码': 'Factory Workmanship Item Code',
  '工厂编码 (factory_itemid)': 'Factory Code (factory_itemid)',
  '工厂编码 (normal)': 'Factory Code (normal)',
  '工厂编码 factory_code': 'Factory Code factory_code',
  '工厂编码和照片反馈至少填一个': 'Enter at least one of factory code or photo feedback',
  '工厂选项ID编码': 'Factory Option ID Code',
  '工厂选项中文名': 'Factory Option Chinese Name',
  '工厂选项中文名（可空）': 'Factory Option Chinese Name (optional)',
  '工厂选项名称 (factory_option_name)': 'Factory Option Name (factory_option_name)',
  '工厂选项名称（中文）': 'Factory Option Name (Chinese)',
  '工艺项名称 (factory_tech_item)': 'Workmanship Item Name (factory_tech_item)',
  '左侧工艺描述（中文，如贡针位置-wz101）': 'Workmanship Description on the Left (Chinese, e.g. pick-stitch position-wz101)',
  '左侧工艺（触发条件）': 'Workmanship on the Left (trigger condition)',
  '忽略': 'Ignore',
  '我方品类': 'Our Category',
  '我方线色号（共享）': 'Our Thread Color (shared)',
  '我方设计项 / 选项': 'Our Design Item / Option',
  '我方设计项 key（只读）': 'Our Design Item key (read-only)',
  '我方选项中文名': 'Our Option Chinese Name',
  '我方选项值 value（只读）': 'Our Option Value (read-only)',
  '我方部位': 'Our Body Part',
  '按品类筛选': 'Filter by Category',
  '按设计项筛选': 'Filter by Design Item',
  '推备注': 'Push to Remark',
  '推送目标': 'Push Target',
  '推送项已添加': 'Push item added',
  '搜我方/HP编码、名称': 'Search our / HP code or name',
  '搜索 itemid / item_name / tech_name': 'Search itemid / item_name / tech_name',
  '搜索名称/code...': 'Search name/code...',
  '搜索品类/设计项/选项名...': 'Search category / design item / option...',
  '搜索规则名/标签/选项编码': 'Search rule name / tag / option code',
  '整项无工厂映射': 'No factory mapping for the whole item',
  '整项无映射': 'No mapping for the whole item',
  '新增后将自动合并为同一组合分组。': 'New entries will be merged into the same combination group automatically.',
  '映射已添加': 'Mapping added',
  '是否启用': 'Enabled',
  '服装类型': 'Garment Type',
  '未配置': 'Not Configured',
  '未配置工厂名': 'Factory name not configured',
  '来自共享设计项「线色号」，工厂字段 tech_cixiuxian': 'From the shared design item "Thread Color"; factory field tech_cixiuxian',
  '模糊搜索...': 'Fuzzy search...',
  '模糊搜索名称/编码...': 'Fuzzy search name / code...',
  '照片反馈 (photo_feedback)': 'Photo Feedback (photo_feedback)',
  '照片反馈文字 (photo_feedback)': 'Photo Feedback Text (photo_feedback)',
  '特体推送': 'Special Body Push',
  '状态 (1=启用)': 'Status (1 = Enabled)',
  '直接映射 (direct)': 'Direct Mapping (direct)',
  '确认删除此推送行？': 'Delete this push row?',
  '筛选品类': 'Filter Category',
  '筛选工厂': 'Filter Factory',
  '筛选：': 'Filter: ',
  '组合分组': 'Combination Group',
  '组合推送 (composite)': 'Composite Push (composite)',
  '绑定工厂': 'Bind Factory',
  '编码+反馈': 'Code + Feedback',
  '编辑推送行': 'Edit Push Row',
  '缺失选项': 'Missing Options',
  '自动替换': 'Auto Replace',
  '色值 / 关联线色号（工厂共享）': 'Color Value / Linked Thread Color (factory-shared)',
  '英文名称（我方）': 'English Name (Ours)',
  '补充配置': 'Additional Configuration',
  '衬衫 SHT': 'Shirt SHT',
  '衬衫 shirt': 'Shirt shirt',
  '西服上衣 suit': 'Suit Jacket suit',
  '西裤 TRS': 'Dress Trousers TRS',
  '西裤 pant': 'Dress Trousers pant',
  '西裤 trousers': 'Dress Trousers trousers',
  '规则名称': 'Rule Name',
  '设计项（key）': 'Design Item (key)',
  '请先选择工厂': 'Please select a factory first',
  '选项值（空=整项）': 'Option Value (blank = whole item)',
  '选项显示名': 'Option Display Name',
  '选项未配置': 'Option not configured',
  '部位名称（中文，我方）': 'Body Part Name (Chinese, Ours)',
  '部分选项缺失': 'Some options missing',
  '马甲 VST': 'Vest VST',
  '马甲 vest': 'Vest vest',
  '（与线色号共享，design_item_code 关联）': '(shared with Thread Color, linked by design_item_code)',
  // ===== 2026-09-21 i18n A 类批次A2：设计选项互斥规则 + HP历史订单 =====
  'A 方（触发条件）': 'Party A (trigger condition)',
  'A方（触发条件）': 'Party A (trigger condition)',
  'B 方（目标）': 'Party B (target)',
  'B方（目标）': 'Party B (target)',
  'HP itemid（多个逗号分隔）': 'HP itemid (multiple, comma-separated)',
  'HP tech_json 键': 'HP tech_json Key',
  'HP单号': 'HP Order No.',
  'HP工厂历史订单': 'HP Factory Historical Orders',
  'HP码：': 'HP Code: ',
  'HP编码': 'HP Code',
  'HP键：': 'HP Key: ',
  'coat - 大衣': 'coat - Coat',
  'pant - 西裤': 'pant - Dress Trousers',
  'shirt - 衬衫': 'shirt - Shirt',
  'suit - 西服上衣': 'suit - Suit Jacket',
  'vest - 马甲': 'vest - Vest',
  '上衣：': 'Jacket: ',
  '下裤': 'Trousers',
  '下裤：': 'Trousers: ',
  '互斥': 'Exclusive',
  '互斥：选了A，B不能选；关联必选：选了A，必须同时选B。记录我方字段码和HP工艺码，便于推送前校验。': 'Exclusive: selecting A excludes B. Required-linked: selecting A requires B. Our field codes and HP workmanship codes are recorded for pre-push validation.',
  '关系': 'Relationship',
  '关联=必须选此项；互斥=不能选此项': 'Linked = this option is required; Exclusive = this option cannot be selected',
  '关联必选': 'Required-Linked',
  '关键词（选项名/HP码/说明）': 'Keyword (option name / HP code / note)',
  '净体尺寸': 'Net Measurements',
  '刺绣 JSON：': 'Embroidery JSON: ',
  '加减': 'Adjustment',
  '只显示': 'Show Only',
  '同品类': 'Same Category',
  '同步 HP 历史订单列表': 'Sync HP Historical Order List',
  '名称：': 'Name: ',
  '品类（空=通用）': 'Category (blank = General)',
  '品类：': 'Category: ',
  '图片链接': 'Image Link',
  '如 coat~101~bt101,coat~101~bt102': 'e.g. coat~101~bt101,coat~101~bt102',
  '如 coat~133~xk107': 'e.g. coat~133~xk107',
  '如 lapel_type、sleeve_style': 'e.g. lapel_type, sleeve_style',
  '如 notch_lapel（空=字段任意值触发）': 'e.g. notch_lapel (blank = trigger on any value)',
  '如 sleeve_button': 'e.g. sleeve_button',
  '如 tech_botouxing': 'e.g. tech_botouxing',
  '如 tech_xiukou': 'e.g. tech_xiukou',
  '如 平驳领': 'e.g. Notch Lapel',
  '如 真眼3粒': 'e.g. Functional 3-Button',
  '字段：': 'Field: ',
  '导入到门店': 'Import to Store',
  '导入完成：成功 ': 'Import complete: succeeded ',
  '尺寸原始串：': 'Raw Measurement String: ',
  '工艺 JSON：': 'Workmanship JSON: ',
  '工艺选项互斥/关联规则': 'Workmanship Option Exclusive / Linked Rules',
  '已入表': 'In Table',
  '开始同步': 'Start Sync',
  '快递单号': 'Tracking No.',
  '我方字段码': 'Our Field Code',
  '我方选项码（空=任意选项）': 'Our Option Code (blank = any option)',
  '批量导入到正式订单': 'Bulk Import to Live Orders',
  '抓取备注': 'Scrape Remarks',
  '拉取信息+照片反馈': 'Fetch Info + Photo Feedback',
  '拉取订单详情：': 'Fetch Order Details: ',
  '搜索门店编号或名称': 'Search store no. or name',
  '放量': 'Allowance',
  '新建规则': 'New Rule',
  '无尺寸数据': 'No measurement data',
  '无特体调整': 'No special body adjustments',
  '无特体调整记录': 'No special body adjustment records',
  '无设计项数据': 'No design item data',
  '暂无拉取记录': 'No fetch records',
  '暂无照片反馈记录': 'No photo feedback records',
  '未找到': 'Not Found',
  '未拉取到任何订单': 'No orders fetched',
  '未映射': 'Unmapped',
  '条 HP 历史订单，导入后订单状态为「已完成」': ' HP historical orders; imported orders will be marked "Completed"',
  '版型文件': 'Pattern File',
  '目标 HP itemid（多个逗号分隔）': 'Target HP itemid (multiple, comma-separated)',
  '目标 HP tech_json 键': 'Target HP tech_json Key',
  '目标品类（空=同品类）': 'Target Category (blank = same category)',
  '目标字段码': 'Target Field Code',
  '目标选项中文名': 'Target Option Chinese Name',
  '目标选项码（空=整个字段）': 'Target Option Code (blank = whole field)',
  '确认删除该规则？': 'Delete this rule?',
  '确认导入': 'Confirm Import',
  '规则说明': 'Rule Description',
  '订单号 / 姓名 / 电话': 'Order No. / Name / Phone',
  '订单日期范围（不填则全量）': 'Order date range (blank = all)',
  '该订单暂无照片反馈记录': 'No photo feedback records for this order',
  '说明该规则的业务含义，如：袖山款式为xs104时，袖扣数量只能选3粒或4粒': 'Describe the business meaning of this rule, e.g. when the sleeve head style is xs104, the sleeve button count can only be 3 or 4',
  '请输入HP订单号': 'Please enter the HP order number',
  '选A不能选B': 'Selecting A excludes B',
  '选A必须选B': 'Selecting A requires B',
  '选A时B只显示指定项': 'Selecting A shows only the specified B options',
  '选项': 'Option',
  '选项中文名': 'Option Chinese Name',
  '通用': 'General',
  '通用（所有品类）': 'General (all categories)',
  '顾客': 'Customer',
  '马甲：': 'Vest: ',
  '（自动识别西服/衬衫账号，拉取即存入记录表）': '(automatically detects the suit / shirt account; fetched data is saved to the record table)',
  // ===== 2026-09-21 i18n A 类批次A3：采购管理 + 工厂工艺映射 =====
  'HP名称': 'HP Name',
  'HP品类名': 'HP Category Name',
  'HP工艺': 'HP Workmanship',
  'HP选项名': 'HP Option Name',
  '▸ HP工厂字段': '▸ HP Factory Field',
  '▸ HP工厂字段（手工填写）': '▸ HP Factory Field (manual entry)',
  '▸ 我方字段': '▸ Our Field',
  '▸ 我方字段（支持手工编辑）': '▸ Our Field (editable)',
  '上衣/大衣/裤子等': 'Jacket / Coat / Trousers, etc.',
  '关联订单：': 'Linked Orders: ',
  '发货工厂：': 'Shipping Factory: ',
  '发货状态': 'Shipment Status',
  '固定': 'Fixed',
  '固定触发': 'Fixed Trigger',
  '地址：': 'Address: ',
  '如: buttonhole_thread': 'e.g. buttonhole_thread',
  '如: pant~522~mjj100': 'e.g. pant~522~mjj100',
  '如: tech_menjinyanxian': 'e.g. tech_menjinyanxian',
  '如: trousers_threads_1000': 'e.g. trousers_threads_1000',
  '如: 顺面料色': 'e.g. Match fabric color',
  '工艺项编码': 'Workmanship Item Code',
  '搜索编码/名称': 'Search code / name',
  '照片反馈文字': 'Photo Feedback Text',
  '电话：': 'Phone: ',
  '组合推送时填写': 'Fill in for composite push',
  '缺失': 'Missing',
  '选项编码': 'Option Code',
  '采购数量：': 'Purchase Qty: ',
  '采购日期：': 'Purchase Date: ',
  '风衣': 'Trench Coat',
  // ===== 2026-09-21 i18n A 类批次A4：加放/特体 + 归码规则 + 面料导入 =====
  '20m+价': '20m+ Price',
  '60m+价': '60m+ Price',
  'HP特体处理': 'HP Special Body Handling',
  'HP特体处理记录': 'HP Special Body Handling Records',
  'HP特体已保存': 'HP special body data saved',
  'JD 标准扩展版': 'JD Standard Extended',
  'USD价': 'USD Price',
  'XM特体处理': 'XM Special Body Handling',
  'XM特体处理功能开发中': 'XM special body handling is under development',
  '修正值': 'Corrected Value',
  '修正部位': 'Corrected Part',
  '华品': 'Huapin',
  '单价USD': 'Unit Price (USD)',
  '参考范围': 'Reference Range',
  '参考订单：': 'Reference Order: ',
  '夏梦完整版': 'Xiameng Full Version',
  '女装': 'Women\'s',
  '审单': 'Order Review',
  '审单操作': 'Review Actions',
  '尖角马甲': 'Pointed Vest',
  '尺寸加放功能仅限技术、技术经理、管理员使用': 'Measurement allowance is available only to Technical Staff, Technical Managers and Admins',
  '幅宽cm': 'Width (cm)',
  '平摆马甲': 'Flat Hem Vest',
  '当前为新建订单模式，无法回填': 'Currently in new-order mode; cannot backfill',
  '拖动移位': 'Drag to Move',
  '收起': 'Collapse',
  '暂无HP特体处理记录': 'No HP special body handling records',
  '暂无操作': 'No actions available',
  '点击右侧导航栏 HP 或操作区「HP特体处理」按钮展开': 'Click HP in the right navigation or the "HP Special Body Handling" button in the action area to expand',
  '男装': 'Men\'s',
  '组织': 'Organization',
  '腹围': 'Stomach',
  '腹围/肚围': 'Stomach / Belly',
  '西裤-单褶': 'Dress Trousers - Single Pleat',
  '西裤-双褶': 'Dress Trousers - Double Pleat',
  '西裤-无褶': 'Dress Trousers - Flat Front',
  '记录': 'Record',
  '该步骤不能操作': 'This step cannot be performed',
  '该步骤不能操作审核按钮': 'Review buttons are unavailable at this step',
  '调整值': 'Adjustment Value',
  '需要订单ID才能查询HP特体处理记录': 'An order ID is required to query HP special body handling records',
  '颜色说明': 'Color Description',
  '（已匹配3个月内记录，请人工确认是否同一客户）': '(Matched records within the last 3 months — please confirm manually whether it is the same customer)',
  '（无特体记录）': '(No special body records)',
  // ===== 2026-09-21 i18n A 类批次A5（最后一批）=====
  '{"suit": "胸宽,腰宽,+1.5/..."}': '{"suit": "chest width,waist width,+1.5/..."}',
  '⚠ 本次推送发现以下互斥工艺（已自动处理）': '⚠ This push found the following conflicting workmanship items (handled automatically)',
  '⚠ 检测到工艺互斥冲突': '⚠ Conflicting workmanship items detected',
  '上衣(up)': 'Jacket (up)',
  '下裤(down)': 'Trousers (down)',
  '全量交接（适用于离职）：将该门店所有历史订单和发票提成归属一并转给新业务员，旧业务员完全清出该门店': 'Full handover (for departures): transfers all historical orders and invoice commission ownership for this store to the new salesperson, removing the previous one entirely',
  '同字段代码': 'Same Field Code',
  '排产中': 'In Scheduling',
  '新增刺绣位置': 'Add Embroidery Position',
  '最近3天': 'Last 3 Days',
  '最近一周': 'Last Week',
  '沪ICP备2026036452号': '沪ICP备2026036452号',
  '用于推送工厂的位置标识，如 coat~115~xw100': 'Position identifier pushed to the factory, e.g. coat~115~xw100',
  '编辑刺绣位置': 'Edit Embroidery Position',
  '马甲(vest)': 'Vest (vest)',
  // ===== 2026-09-21 i18n A 类批次A6：字典值补翻 =====
  '互斥冲突': 'Conflict',
  '仓库发货': 'Warehouse Shipment',
  '供应商发货': 'Supplier Shipment',
  '供应商批量发货': 'Supplier Bulk Shipment',
  '创建采购单': 'Create Purchase Order',
  '刺绣位置未命中': 'Embroidery position not matched',
  '发送采购单': 'Send Purchase Order',
  '品类不符未推送': 'Category mismatch — not pushed',
  '处理售后': 'Handle After-Sales',
  '开具发票': 'Issue Invoice',
  '录入付款': 'Enter Payment',
  '批量分享采购': 'Bulk Share Procurement',
  '映射缺失': 'Mapping missing',
  '照片上传失败': 'Photo upload failed',
  '特体项未推送': 'Special body item not pushed',
  '确认收款': 'Confirm Payment Received',
  '确认采购完成': 'Confirm Procurement Complete',
  '编辑备注': 'Edit Note',
  '编辑订单': 'Edit Order',
  '自动改动设计项': 'Auto-adjusted design items',
  '财审通过': 'Finance Review Approved',
  '财审驳回': 'Finance Review Rejected',
  '超宽松': 'Extra Loose',
  '超紧身': 'Extra Tight',
  '采购人员发货': 'Procurement Staff Shipment',
  '已标记已发货': 'Marked as Shipped',
  '仅已采购/已发货状态可标记已发货': 'Only Purchased/Shipped records can be marked as shipped',
  '请选择物流公司（选填）': 'Select carrier (optional)',
  '请输入物流单号（选填）': 'Enter tracking number (optional)',
  '物流信息均为选填；确认后状态变为「已发货」并自动记录发货时间。': 'Shipping info is optional. Confirming sets the status to Shipped and records the ship date automatically.',
  // 左侧菜单栏遗漏的 key：原先这几项在 en-US 里没有定义，英文模式下 t() 回退成
  // 中文 key，导致菜单出现中英文混写（2026-09-23 补全）。
  '历史订单': 'Historical Orders',
  'JD工艺互斥表': 'JD Craft Mutex Rules',
  '工厂数据映射': 'Factory Data Mapping',
  '薪酬参数设置': 'Payroll Settings',
  '年终分红（完善中）': 'Year-end Bonus (In Progress)',
  '该订单的尺寸数据已被他人修改，请刷新页面后重试': 'The measurements of this order were modified by someone else. Please refresh the page and try again.',
  '功能已更新': 'Update Available',
  '当前页面是旧版本，点击刷新即可使用最新功能（未提交的内容会自动保留）': 'This page is running an older version. Refresh to use the latest features. (Unsaved data will be kept.)',
  '立即刷新': 'Refresh Now',

  // ── 本地既有、服务器缺失的 key（2026-09-26 合并保留，避免丢失）──
  '将用各品类「业务员填写的成衣尺寸」覆盖「最终审核的成衣尺寸」，原审核值会被替换。': 'This will overwrite the reviewed RTW sizes with the salesperson-filled RTW sizes for all categories.',
  '覆盖所有品类（上衣/裤子/马甲/衬衫/大衣及自定义部位），请确认无误后继续。': 'Applies to all categories (jacket/trousers/vest/shirt/coat and custom parts). Please confirm to continue.',
  '将用成衣尺寸列覆盖所有品类（上衣/裤子/马甲/衬衫/大衣及自定义部位），请确认无误后继续。': 'This will overwrite the reviewed sizes with the RTW size column for all categories (jacket/trousers/vest/shirt/coat and custom parts). Please confirm to continue.',
  '将成衣尺寸列覆盖所有品类（上衣/裤子/马甲/衬衫/大衣及自定义部位）至审核成衣尺寸（推送尺寸），请确认无误后继续。': 'This will overwrite the reviewed RTW sizes (pushed sizes) with the RTW size column for all categories (jacket/trousers/vest/shirt/coat and custom parts). Please confirm to continue.',
  '映射表': 'Mapping Table',
  '管理我方设计选项与工厂工艺编码的映射关系，并查看每次推送到工厂的日志': 'Manage mappings between our design options and factory craft codes, and review every push log',

  // ── 出入库管理 · 工厂单据 AI 识别（2026-09-26）──
  '再次识别': 'Re-recognize',
  '识别值': 'Recognized Value',
  '命中列': 'Matched Column',
  '请先上传工厂单据图片': 'Please upload the factory document image first',
  '未匹配到任何待入库订单，请点「再次识别」换一种列切分再试': 'No pending order matched. Click "Re-recognize" to try a different column split.',
  '已匹配 {n} 个待入库订单（订单号列：第 {c} 列）': 'Matched {n} pending order(s) (order-no column: #{c})',
  '当前列切分策略': 'Column Split Strategy',
  '订单号列': 'Order No. Column',

  // ── 出入库AI识别：已入库标记（2026-09-26）──
  '已匹配 {n} 条（待入库 {p} 条，已入库 {d} 条）': 'Matched {n} record(s) (pending inbound {p}, already inbound {d})',
  '匹配到 {n} 条记录，请勾选后确认入库': 'Matched {n} record(s). Check the ones to stock in.',
  // ── 发票管理：按月份搜索（2026-10-15）──
  // 注：'选择月份' 英文版已存在（4024 行），此处不再重复添加，避免 TS1117。
  '开票月份': 'Invoice Month',
  '结算月份': 'Settlement Month',

  // ── 加工商对账改版：订单级列表+账单编号模型（2026-10-22）──
  '工厂工费对账与付款管理': 'Factory Cost Reconciliation & Payment Management',
  '账单编号': 'Bill No.',
  '订单号/客户号': 'Order No. / Customer No.',
  '面料编号/面料供应商': 'Fabric Code / Fabric Supplier',
  '未对账': 'Not Reconciled',
  '已对账': 'Reconciled',
  '对账状态': 'Reconciliation Status',
  '品类 / 面料号': 'Category / Fabric Code',
  '客户名': 'Customer Name',
  '工费金额(CNY)': 'Factory Cost (CNY)',
  '对账': 'Reconcile',
  '回滚': 'Revert',
  '回滚为未对账？': 'Revert to not reconciled?',
  '标记为已对账？': 'Mark as reconciled?',
  '已标记为已对账': 'Marked as reconciled',
  '已回滚为未对账': 'Reverted to not reconciled',
  '标记已对账': 'Mark as Reconciled',
  '标记未对账': 'Mark as Not Reconciled',
  '标记已付款': 'Mark as Paid',
  '标记未付款': 'Mark as Unpaid',
  '已更新对账状态': 'Reconciliation status updated',
  '已更新付款状态': 'Payment status updated',
  '批量对账': 'Batch Reconcile',
  '批量对账成功': 'Batch reconciliation succeeded',
  '批量对账需所选订单属于同一加工商': 'Batch reconciliation requires all selected orders to belong to the same factory',
  '批量付款需所选订单属于同一账单编号': 'Batch payment requires all selected orders to share the same bill number',
  '格式为 NO + 8位日期，如 NO20261010': 'Format: NO + 8-digit date, e.g. NO20261010',
  '账单编号格式不正确，应为 NO+8位日期，如 NO20261010': 'Invalid bill number format, should be NO + 8-digit date, e.g. NO20261010',
  '确认对账': 'Confirm Reconciliation',
  '付款金额(CNY)': 'Payment Amount (CNY)',
  '付款已记录': 'Payment recorded',
  '核销': 'settled',
  '勾选本次完成付款的订单；支持多次付款，金额由财务手工输入，不按比例自动分配': 'Check the orders settled by this payment; multiple payments are supported, the amount is entered manually and not auto-allocated proportionally',

  // ── 加工商对账二次优化：账单编号带点格式、按钮精简、单条对账弹框（2026-10-22）──
  '供应商 / 工厂单号': 'Supplier / Factory Order No.',
  '对账确认': 'Reconciliation Confirmation',
  '批量回滚': 'Batch Revert',
  '批量回滚需所选订单均为已对账': 'Batch revert requires all selected orders to be currently reconciled',
  '格式为 NO. + 8位日期，如 NO.20261010': 'Format: NO. + 8-digit date, e.g. NO.20261010',
  '清空选择': 'Clear Selection',
  '账单编号格式不正确，应为 NO.+8位日期，如 NO.20261010': 'Invalid bill number format, should be NO. + 8-digit date, e.g. NO.20261010',

  // ── 加工商对账三次优化：按钮布局/品类中文/付款校验（2026-10-22）──
  '请至少勾选一个订单或填写付款金额': 'Please check at least one order or enter a payment amount',

  // ── 加工商对账：回滚时若已有付款记录需二次警示确认（2026-10-22）──
  '该订单已标记付款，仍要回滚为未对账吗？': 'This order is already marked as paid. Revert to not reconciled anyway?',
  '回滚会清空该订单的账单编号与付款状态，但已记录的付款流水不会被删除，请确认后再操作': 'Reverting will clear this order\'s bill number and payment status, but recorded payment entries will not be deleted. Please confirm before proceeding.',
  '所选订单中有 {n} 条已标记付款，仍要批量回滚吗？': '{n} of the selected orders are already marked as paid. Batch revert anyway?',
  '回滚会清空这些订单的账单编号与付款状态，但已记录的付款流水不会被删除，请确认后再操作': 'Reverting will clear these orders\' bill numbers and payment status, but recorded payment entries will not be deleted. Please confirm before proceeding.',
  '确认回滚': 'Confirm Revert',

  // ── 新建/编辑订单面料选择：品牌/样本册实时搜索下拉（2026-11-03）──
  '按品牌搜索': 'Search by Brand',
  '按样本册搜索': 'Search by Sample Book',
} as Record<string, string>;
